import { VOICEX_URL_CONSTANTS } from "../../utils/constants";
import {
  DEFAULT_TENANT_ID,
  DEFAULT_WORKSPACE_ID,
  DEFAULT_USER_ID,
  US_TENANT_ID,
  US_WORKSPACE_ID,
  US_USER_ID,
  NURIX_WORKSPACE_ID,
  NURIX_TENANT_ID
} from "../../utils/constants";
/*
-- Images Female
1. https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female1.png
2. https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female2.png
3. https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female3.png
4. https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png

-- Images Male
1. https://d3udl6i7sipqjw.cloudfront.net/agent-images/male1.png
 */

/*
 Voice-Ids
 1. 11labs-Adrian
 3. 11labs-Andrew
 4. 11labs-Bing
 5. 11labs-Brian

 2. 11labs-Amy
 6. 11labs-Zuri
 7. 11labs-Nina
 8. 11labs-Myra
 9. 11labs-Marissa
*/

export const newAgentCategories = {
  Insurance: {
    path: "insurance",
    pageTitle: "Experience our AI Agents",
    pageCategory: "Health Insurance",
    agents: [
      {
        id: "80823e8e-afa8-4098-83fd-2d1c5ca40060",
        name: "Ask Your Policy",
        agentName: "Myra",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female2.png",
        chatIcon:
          "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female2.png",
        featureList: [
          "Clarify details of your policy",
          "Explain payment breakdown"
        ],
        description:
          "Explains policy benefits, cost implications, and support options for ongoing medical needs.",
        voice: "true",
        chat: "true",
        chatHints: [
          { triggers: ["full name"], hint: "Full name: Alex Smith" },
          {
            triggers: ["date of birth", "janm date", "birth date"],
            hint: "Date of Birth: February 15, 1989"
          }
        ],
        try_speaking: [
          "Can you walk me through how my out-of-pocket costs will change now that each family member has met their individual deductible? ",
          "Are there any medical programs or support services available for managing ongoing conditions like diabetes?",
          "Can you clarify how coverage works if we ever need emergency care outside our service area?"
        ],
        callHints: ["User Name: Alex Smith", "User DOB: February 15, 1989"],
        callTitle: "Ask Your Policy",
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {},
        default_voiceId: "default",
        optional_voices: [
          {
            id: "11labs-Myra",
            name: "Myra",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
            description: "Female Young & Professional",
            language: "English",
            region: "American"
          },
          {
            id: "11labs-Amy",
            name: "Myra",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female1.png",
            description: "Female Young & Professional",
            language: "English",
            region: "British"
          },
          {
            id: "11labs-Zuri",
            name: "Myra",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female3.png",
            description: "Female Old & Professional",
            language: "English",
            region: "American"
          }
        ],
        activities: ["Send an email", "Schedule a meeting"]
      },
      {
        id: "205cd6f2-79ad-4a2b-b3dd-d927b6359055",
        name: "Lead Qualification",
        agentName: "Merissa",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female3.png",
        chatIcon:
          "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female3.png",
        featureList: ["Assess customer needs", "Suggest best suited policy"],
        voice: "true",
        chat: "false",
        description:
          "Assists with plan recommendations based on specific health and budget needs.",
        chatHints: [],
        callHints: [],
        callHintsTable: [],
        callTitle: "Lead Qualification Agent",
        try_speaking: [
          "I happen to have diabetes and Tony keeps having dental problems, do you have any policy which covers both?",
          "The cost is quite high, I wont be able to afford it --> Can you provide more discount?",
          "I'd like to check across other providers before making a decision"
        ],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {},
        default_voiceId: "default",
        optional_voices: [
          {
            id: "11labs-Myra",
            name: "Myra",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
            description: "Female Young & Professional",
            language: "English",
            region: "American"
          },
          {
            id: "11labs-Amy",
            name: "Myra",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female1.png",
            description: "Female Young & Professional",
            language: "English",
            region: "British"
          },
          {
            id: "11labs-Zuri",
            name: "Myra",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female3.png",
            description: "Female Old & Professional",
            language: "English",
            region: "American"
          }
        ],
        activities: ["Send an email", "Schedule a meeting"]
      }
    ]
  },
  Retail: {
    path: "retail",
    pageTitle: "Experience Our Retail Agents",
    pageCategory: "Retail",
    agents: [
      {
        id: "c6479ac8-feac-4b19-943f-c1f4099e5988",
        name: "Order Tracking & Return",
        agentName: "Alice",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female1.png",
        chatIcon:
          "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female1.png",
        featureList: [
          "Track/Cancel order",
          "Change delivery instructions",
          "Exchange and refund status",
          "Return order"
        ],
        description:
          "Provides real-time order tracking and return process guidance.",
        voice: "true",

        chat: "false",
        chatHints: [
          {
            triggers: ["name or order id"],
            hint: "Order ID: 202, Name: Bluetooth Speaker"
          },
          {
            triggers: ["how may i help you today?"],
            hint: "Ask it to fetch details of all orders, delivery status, etc..."
          }
        ],
        callHints: [
          "Bluetooth Speaker ID: #202",
          "Security Camera  ID: #456",
          "Smartphone Case  ID: #789",
          "Headphones ID: #123",
          "Smart Watch ID: #101"
        ],
        callHintsTable: [],
        try_speaking: [
          " I'd like to return the Smartphone Case, ID 789—how do I send it back and when will the refund show up?"
        ],
        default_voiceId: "default",
        optional_voices: [
          {
            id: "default",
            name: "Alice",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female1.png",
            description: "Female Young & Professional",
            language: "English",
            region: ""
          }
        ],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {},
        activities: ["Send an email", "Schedule a meeting"]
      },
      {
        id: "2e7a74d6-fd3b-4b23-80e6-5a3db7596deb",
        name: "Reward Supports Agent",
        agentName: "Maya",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female2.png",
        chatIcon:
          "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female2.png",
        featureList: [
          "Star Rewards Inquiry",
          "Star calculation elucidation",
          "Reward issue resolution"
        ],
        description:
          "Handles customer queries related to rewards, redemptions, and program eligibility.",
        voice: "true",
        chat: "false",
        chatHints: [],
        callHints: [],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {},
        try_speaking: [],
        activities: ["Send an email", "Schedule a meeting"],
        default_voiceId: "default",
        optional_voices: [
          {
            id: "default",
            name: "Maya",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female2.png",
            description: "Female Young & Professional",
            language: "English",
            region: ""
          }
        ]
      },
      {
        id: "d25890ec-1766-4467-94ed-867378088ff0",
        name: "Customer Service Representative",
        agentName: "Myra",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        chatIcon:
          "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        featureList: ["Taking orders", "Scheduling Pickup"],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHints: [],
        description:
          "Resolves general retail queries and provides support for purchases or issues.",
        callHintsTable: [],
        try_speaking: [],
        activities: ["Send an email", "Schedule a meeting"],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {},
        default_voiceId: "default",
        optional_voices: [
          {
            id: "default",
            name: "Myra",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
            description: "Female Young & Professional",
            language: "English",
            region: ""
          }
        ]
      },
      {
        id: "c04bc7d7-1c73-4d0a-aff1-ed591aa44b58",
        name: "Vendor Support Representative",
        agentName: "Alex",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/male1.png",
        chatIcon:
          "https://d3udl6i7sipqjw.cloudfront.net/agent-images/male1.png",
        featureList: [
          "Payment due",
          "Pending documents to be uploaded",
          "Shipment delay"
        ],
        description:
          "Assists vendors with profile updates and partnership-related concerns.",
        voice: "true",
        chat: "false",
        chatHints: [],
        callHints: [
          "Vendor Name: ABC Traders",
          "Vendor ID : ABCT-0912",
          "Last four digits of phone number: 9123"
        ],
        try_speaking: [
          "Alex, this is ABC Traders—can we review my vendor profile?"
        ],
        activities: ["Send an email", "Schedule a meeting"],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {},
        default_voiceId: "default",
        optional_voices: [
          {
            id: "default",
            name: "Alex",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/male1.png",
            description: "Male Young & Professional",
            language: "English",
            region: ""
          }
        ]
      }
    ]
  },
  Burgers: {
    path: "crispy-burgers",
    pageTitle: "Experience Our Voice AI Agents",
    pageCategory: "Crispy Burgers",
    agents: [
      {
        id: "fab68d43-4c06-4312-8d69-750b392f7dcc",
        name: "Catering - Order Taking",
        description:
          "Empathetic voice agent for planning catering menu, placing order, and scheduling delivery",
        subDescription: "Voice: Excited, Patient",
        agentName: "Myra",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female2.png",
        chatIcon:
          "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female2.png",
        featureList: [
          "Empathetic and Patient",
          "Can help plan party menu",
          "Well-versed with Crispy Burgers brand guidelines",
          "Captures cross-sell opportunities"
        ],
        voice: "true",
        chat: "false",
        callTitle: "Big Burgers Catering Service",
        chatHints: [],
        callHintsTable: [],
        callHints: ["Agent Name: Myra", "Agent Role: Catering Order Taking"],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {},
        try_speaking: [],
        activities: ["Place Order", "Send Payment Email"],
        phoneNumber: "070239",
        language: "English",
        default_voiceId: "default",
        optional_voices: [
          {
            id: "default",
            name: "Myra",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female2.png",
            description: "Female Young & Professional",
            language: "English",
            region: ""
          }
        ]
      }
    ]
  },
  ChickFila: {
    path: "chick-fil-a",
    pageTitle: "Experience our Voice Agents",
    pageCategory: "Chick-Fil-A",
    agents: [
      {
        id: "0cb1faac-eeec-4a1d-a998-60b28b1263bc",
        name: "Catering - Order Taking",
        description:
          "Empathetic voice agent for planning catering menu, placing order, and scheduling delivery",
        subDescription: "Voice: Excited, Patient",
        agentName: "Myra",
        icon: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face",
        chatIcon:
          "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face",
        featureList: [
          "Empathetic and Patient",
          "Can help plan party menu",
          "Well-versed with CFA brand guidelines",
          "Captures cross-sell opportunities"
        ],
        voice: "true",
        chat: "false",
        callTitle: "Chick-Fil-A Catering Service",
        chatHints: [],
        callHintsTable: [],
        callHints: ["Agent Name: Myra", "Agent Role: Catering Order Taking"],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {},
        try_speaking: ["What tray options work best for a ten-person lunch?", "What kids’ meal options would you suggest for a group of 20 children?", "Can you recommend meals that are easy to eat while traveling?"],
        activities: ["Place Order", "Send Payment Email"],
        phoneNumber: "070239",
        language: "English",
        default_voiceId: "default",
        optional_voices: [
          {
            id: "default",
            name: "Myra",
            icon: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face",
            description: "Female Young & Professional",
            language: "English",
            region: ""
          }
        ]
      },
      {
        id: "670dec49-72dc-4ee1-911c-3941066cdd2a",
        name: "Takes Individual Orders",
        description:
          "An empathetic AI voice agent that guides you through the menu and seamlessly places your order online.",
        subDescription: "Voice: Excited, Patient",
        agentName: "Samantha",
        icon: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face",
        chatIcon:
          "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face",
        featureList: [
          "Empathetic and patient",
          "Can help you choose from the menu",
          "Well-versed with CFA Brand Guidelines",
          "Captures cross-sell opportunities"
        ],
        voice: "true",
        chat: "false",
        callTitle: "Chick-Fil-A Order Taking Service",
        chatHints: [],
        callHintsTable: [],
        callHints: ["Agent Name : Samantha", "Agent Role : Takes Individual Orders"],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {},
        try_speaking: ["Can you suggest some drinks?", "What would be best for a four-person meal?", "Any dessert ideas to go with a nugget tray?"],
        activities: ["Place Order", "Send Payment Email"],
        phoneNumber: "070239",
        language: "English",
        default_voiceId: "default",
        optional_voices: [
          {
            id: "default",
            name: "Samantha",
            icon: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face",
            description: "Female Young & Professional",
            language: "English",
            region: ""
          }
        ]
      },
      {
        id: "03448c3e-7f89-4484-ad65-2512a325171c",
        name: "Reorder - Returning Customer",
        description:
          "Empathetic voice agent for planning catering menu, placing order, and scheduling delivery.",
        subDescription: "Voice: Excited, Patient",
        agentName: "Daniel",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/cfa_image.png",
        chatIcon:
          "https://d3udl6i7sipqjw.cloudfront.net/agent-images/cfa_image.png",
        featureList: [
          "Empathetic and Patient",
          "Can help plan party menu",
          "Well-versed with CFA Brand Guidelines",
          "Captures cross-sell opportunities"
        ],
        voice: "true",
        chat: "false",
        callTitle: "Chick-Fil-A Reorder Service",
        chatHints: [],
        callHintsTable: [],
        callHints: ["Agent Name: Daniel", "Agent Role: Catering - Order Taking"],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {},
        try_speaking: ["I had ordered catering from you and I’d like to place another order"],
        activities: ["Place Order", "Send Payment Email"],
        phoneNumber: "070239",
        language: "English",
        default_voiceId: "default",
        optional_voices: [
          {
            id: "default",
            name: "Daniel",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/cfa_image.png",
            description: "Male Young & Professional",
            language: "English",
            region: ""
          }
        ]
      }
    ]
  },
  ChickFilaDemo: {
    path: "chick-fil-a-demo",
    pageTitle: "Experience our Voice Agents",
    pageCategory: "Chick-Fil-A",
    agents: [
      {
        id: "fee79626-02c7-4619-82f5-80a9cc2cb827",
        name: "Catering - Order Taking",
        description:
          "Empathetic voice agent for planning catering menu, placing order, and scheduling delivery",
        subDescription: "Voice: Excited, Patient",
        agentName: "Myra",
        icon: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face",
        chatIcon:
          "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face",
        featureList: [
          "Empathetic and Patient",
          "Can help plan party menu",
          "Well-versed with CFA brand guidelines",
          "Captures cross-sell opportunities"
        ],
        voice: "true",
        chat: "false",
        callTitle: "Chick-Fil-A Catering Service",
        chatHints: [],
        callHintsTable: [],
        callHints: ["Agent Name: Myra", "Agent Role: Catering Order Taking"],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {},
        try_speaking: [],
        activities: ["Place Order", "Send Payment Email"],
        phoneNumber: "070239",
        language: "English",
        default_voiceId: "default",
        optional_voices: [
          {
            id: "default",
            name: "Myra",
            icon: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face",
            description: "Female Young & Professional",
            language: "English",
            region: ""
          }
        ]
      },

    ]
  },
  VoicexTest: {
    path: "voicex-test",
    pageTitle: "Experience Our Demo Agents",
    pageCategory: "Voicex",
    agents: [
      {
        id: "03876c0c-f46a-4ae7-97b8-f06233b46aca",
        name: "Health Insurance Sales",
        agentName: "Aayush",
        icon: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face",
        chatIcon:
          "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face",
        featureList: [
          "Assess customer needs",
          "Suggest best suited policy",
          "Language: Hinglish"
        ],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHintsTable: [],
        description: "",
        callHints: ["Phone Number - 555-123-4567", "Policy Number - NRX-1234"],
        voiceInputs: [],
        voiceProvider: "voicex",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "b2b9f0e2-9808-442f-9a47-948a88739b88",
          overide_previous_context: true,
          custom_data: {},
          webhook_customer_id: "experience-page",
          tenant_id: DEFAULT_TENANT_ID,
          workspace_id: DEFAULT_WORKSPACE_ID
        },
        phoneNumber: "",
        language: "Hinglish",
        default_voiceId: "default",
        optional_voices: [
          {
            id: "default",
            name: "Aayush",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/male1.png",
            language: "Hinglish"
          }
        ],
        try_speaking: [
          "I need a health insurance plan for my family",
          "What are the benefits of your premium health plan?",
          "Can you explain the coverage for pre-existing conditions?",
          "What is the waiting period for this policy?"
        ],
        activities: ["Send an email", "Schedule a meeting"]
      }
    ]
  },
  //   pageCategory: "Voicex",
  //   agents:[{
  //     id: "47f11233-f375-4312-af4c-7689efa8aa15",
  //     name: "Health Insurance Sales",
  //     agentName: "Aayush",
  //     icon: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face",
  //     chatIcon:
  //       "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face",
  //     featureList: [
  //       "Assess customer needs",
  //       "Suggest best suited policy",
  //       "Language: Hinglish"
  //     ],
  //     voice: "true",
  //     chat: "false",
  //     chatHints: [],
  //     callHintsTable: [],
  //     description: "",
  //     callHints: ["Phone Number - 555-123-4567", "Policy Number - NRX-1234"],
  //     voiceInputs: [],
  //     voiceProvider: "voicex",
  //     voiceConfig: {
  //       baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
  //       user_id: "experience-page",
  //       agent_id: "47f11233-f375-4312-af4c-7689efa8aa15",
  //       tenant_id: "4321b0d7-361c-4250-97c2-f987f0b72a56",
  //       workspace_id: "4321b0d7-361c-4250-97c2-f987f0b72a56",
  //       overide_previous_context: true
  //     },
  //     phoneNumber: "",
  //     language: "Hinglish",
  //     default_voiceId: "default",
  //     optional_voices: [
  //       {
  //         id: "default",
  //         name: "Sierra",
  //         icon: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face",
  //         language: "Hinglish"
  //       }
  //     ],
  //     try_speaking: [
  //       "I need a health insurance plan for my family",
  //       "What are the benefits of your premium health plan?",
  //       "Can you explain the coverage for pre-existing conditions?",
  //       "What is the waiting period for this policy?"
  //     ],
  //     activities: ["Send an email", "Schedule a meeting"]
  //   }]
  // },
  Mexican: {
    path: "mexican",
    pageTitle: "Experience our Voice AI Agents",
    pageCategory: "Mexican Kitchen",
    agents: [
      {
        id: "c7a679f0-864f-48cc-b8d4-d4ec6a22032d",
        name: "Order Taking",
        description:
          "Empathetic voice agent for placing order, and scheduling delivery",
        subDescription: "Voice: Excited, Patient",
        agentName: "Myra",
        icon: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face",
        chatIcon:
          "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face",
        featureList: [
          "Empathetic and Patient",
          "Well-versed with Mexican Kitchen brand guidelines",
          "Captures cross-sell opportunities"
        ],
        voice: "true",
        chat: "false",
        callTitle: "Mexican Kitchen",
        chatHints: [],
        callHintsTable: [],
        callHints: ["Agent Name: Myra", "Agent Role: Order Taking"],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {},
        try_speaking: [],
        activities: ["Place Order", "Send Payment Email"],
        phoneNumber: "070239",
        language: "English",
        default_voiceId: "default",
        optional_voices: [
          {
            id: "default",
            name: "Myra",
            icon: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face",
            description: "Female Young & Professional",
            language: "English",
            region: ""
          }
        ]
      }
    ]
  },
  GlobalAssure: {
    path: "global-assure",
    pageTitle: "Experience our Voice AI Agents",
    pageCategory: "Global Assure",
    agents: [
      {
        id: "a2682f62-0186-4322-a5ec-0a3e95f9fc1f",
        name: "Road Side Assistance (Male)",
        description:
          "Empathetic voice agent on-location help for towing and road side repair",
        subDescription: "Voice: Excited, Patient",
        agentName: "Raj",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/male2.png",
        chatIcon:
          "https://d3udl6i7sipqjw.cloudfront.net/agent-images/male2.png",

        featureList: [
          "Register RSA request",
          "Verify customer identity",
          "Capture incident details and initiate assistance"
        ],
        voice: "true",
        chat: "false",
        callTitle: "RSA Agent",
        chatHints: [],
        callHintsTable: [],
        callHints: [
          "Name: Ajay Kumar",
          "Vehicle Number: GJ01 KN 1234",
          "Car Make and Model: Hyundai Creta",
          "Phone number: 9547876789",
          "Policy Number: 123478"
        ],
        voiceInputs: [],
        voiceProvider: "voicex",
        try_speaking: [],
        activities: ["Send WhatsApp Link"],
        phoneNumber: "070239",
        language: "Hinglish",
        default_voiceId: "default",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "a2682f62-0186-4322-a5ec-0a3e95f9fc1f",
          overide_previous_context: true,
          custom_data: {},
          tenant_id: DEFAULT_TENANT_ID,
          workspace_id: DEFAULT_WORKSPACE_ID
        },
        optional_voices: [
          {
            id: "default",
            name: "Raj",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/male2.png",
            description: "Male Young & Professional",
            language: "Hinglish",
            region: ""
          }
        ]
      },
      {
        id: "1fb8a1e6-1266-467d-ab3c-6ae0cf84f555",
        name: "Road Side Assistance (Female) ",
        description: "Empathetic voice agent on-location help for towing and road side repair",
        subDescription: "Voice: Excited, Patient",
        agentName: "Neha",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        chatIcon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        featureList: [
          "Register RSA request",
          "Verify customer identity",
          "Capture incident details and initiate assistance"
        ],
        voice: "true",
        chat: "false",
        callTitle: "RSA Agent",
        chatHints: [],
        callHintsTable: [],
        callHints: [
          "Name: Ajay Kumar",
          "Vehicle Number: GJ01 KN 1234",
          "Car Make and Model: Hyundai Creta",
          "Phone number: 9547876789",
          "Policy Number: 123478"
        ],
        voiceInputs: [],
        voiceProvider: "voicex",
        try_speaking: [],
        activities: ["Send WhatsApp Link"],
        phoneNumber: "070239",
        language: "Hinglish",
        default_voiceId: "default",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "1fb8a1e6-1266-467d-ab3c-6ae0cf84f555",
          overide_previous_context: true,
          custom_data: {},
          tenant_id: DEFAULT_TENANT_ID,
          workspace_id: DEFAULT_WORKSPACE_ID
        },
        optional_voices: [
          {
            id: "default",
            name: "Neha",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
            description: "Female Young & Professional",
            language: "Hinglish",
            region: ""
          }
        ]
      }

    ]
  },
  // PaisaBazaar2: {
  //   path: "paisabazaar",
  //   pageTitle: "Experience our Voice AI Agents",
  //   pageCategory: "PaisaBazaar",
  //   agents: [
  //     {
  //       id: "8d58e16c-ce81-4812-aedb-8feb3fc78fea",
  //       name: "EMI Reminder",
  //       description: "Empathetic voice agent for EMI remainder",
  //       subDescription: "Empathetic voice agent for EMI remainder",
  //       agentName: "Raj",
  //       icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/male2.png",
  //       chatIcon:
  //         "https://d3udl6i7sipqjw.cloudfront.net/agent-images/male2.png",
  //       featureList: ["Overdue Payment Alerts", "Language: Hinglish"],
  //       voice: "true",
  //       chat: "false",
  //       callTitle: "EMI Reminder Agent",
  //       chatHints: [],
  //       callHintsTable: [],
  //       callHints: ["Name:Ram"],
  //       voiceInputs: [],
  //       voiceProvider: "voicex",
  //       try_speaking: [],
  //       activities: [],
  //       phoneNumber: "070239",
  //       language: "Hinglish",
  //       default_voiceId: "default",
  //       voiceConfig: {
  //         baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
  //         user_id: DEFAULT_USER_ID,
  //         agent_id: "d1f00f20-17b2-4990-85d2-e119ccbd1d46",
  //         tenant_id: DEFAULT_TENANT_ID,
  //         workspace_id: DEFAULT_WORKSPACE_ID,
  //         overide_previous_context: true
  //       },
  //       optional_voices: [
  //         {
  //           id: "default",
  //           name: "Raj",
  //           icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/male2.png",
  //           description: "Male Young & Professional",
  //           language: "Hinglish",
  //           region: ""
  //         }
  //       ]
  //     }
  //   ]
  // },
  Swiggy: {
    path: "swiggy-tracking",
    pageTitle: "Experience our Voice AI Agents",
    pageCategory: "Swiggy",
    agents: [
      {
        id: "7f111fcb-39b0-4fb4-9c8c-86d7ef210e5c",
        name: "Order Tracking and Refund",
        description:
          " Empathetic voice agent for tracking orders in real-time and providing clear refund updates for cancelled deliveries.",
        subDescription:
          " Empathetic voice agent for tracking orders in real-time and providing clear refund updates for cancelled deliveries.",
        agentName: "Aayush",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/male1.png",
        chatIcon:
          "https://d3udl6i7sipqjw.cloudfront.net/agent-images/male1.png",
        featureList: ["Order tracking", "Refund status", "Language: Hinglish"],
        voice: "true",
        chat: "false",
        callTitle: "Order Tracking and Refund Agent",
        chatHints: [],
        callHintsTable: [],
        callHints: [
          "Aloo Paratha ID: 1234 (Order Tracking)",
          "Masala Dosa ID: 1235 (Order Tracking)",
          "Pesto Pizza ID: 1236 (Refund)",
          "Pav Bhaji ID: 1237 (Refund)"
        ],
        voiceInputs: [],
        voiceProvider: "voicex",
        try_speaking: [],
        activities: [],
        phoneNumber: "070239",
        language: "Hinglish",
        default_voiceId: "default",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "7f111fcb-39b0-4fb4-9c8c-86d7ef210e5c",
          tenant_id: DEFAULT_TENANT_ID,
          workspace_id: DEFAULT_WORKSPACE_ID,
          overide_previous_context: true
        },
        optional_voices: [
          {
            id: "default",
            name: "Aayush",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/male1.png",
            description: "Male Young & Professional",
            language: "Hinglish",
            region: ""
          }
        ]
      }
    ]
  },
  TokioMarine: {
    path: "tokio-marine",
    pageTitle: "Experience our Voice AI Agents",
    pageCategory: "Tokio Marine",
    agents: [
      {
        id: "b815ce9b-83ad-4081-b74c-3f5be7633b33",
        name: "AI Voice Receptionist",
        description:
          "Helps travelers access insurance benefits, urgent assistance, and emergency support worldwide",
        subDescription:
          "Helps travelers access insurance benefits, urgent assistance, and emergency support worldwide",
        agentName: "Sarah",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        chatIcon:
          "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        featureList: [],
        voice: "true",
        chat: "false",
        callTitle: "Voice Receptionist",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "retell",
        try_speaking: [
          "I lost my passport and don't know what to do",
          "What is covered in my policy?",
          "What is the best policy? If I buy the plan today, when does the coverage start?"
        ],
        activities: [
          "Guide travelers through steps to recover lost passports or documents",
          "Answer questions about insurance benefits, coverage, and eligibility",
          "Share local travel tips, safety information, and embassy contact details",
        ],
        phoneNumber: "070239",
        language: "English",
        default_voiceId: "default",
        voiceConfig: {},
        optional_voices: [
          {
            id: "default",
            name: "Sarah",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
            description: "Female Young & Professional",
            language: "English",
            region: ""
          }
        ]
      }
    ]
  },
  ATCA: {
    path: "atca",
    pageTitle: "Experience our Voice AI Agents",
    pageCategory: "ATCA",
    agents: [
      {
        id: "a897d925-2660-4464-9a0c-507fdd2a907b",
        name: "ATCA Care Assistant",
        description:
          "A supportive outpatient wellness agent that helps Alzheimer’s patients and caregivers navigate early detection, personalized treatment, and medication routines with clarity and compassion.",
        subDescription:
          "A supportive outpatient wellness agent that helps Alzheimer’s patients and caregivers navigate early detection, personalized treatment, and medication routines with clarity and compassion.",
        agentName: "Ava",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        chatIcon:
          "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        featureList: [
          "Personalized intake for cognitive screening",
          "Explain treatment options"
        ],
        voice: "true",
        chat: "false",
        callTitle: "ATCA Care Assistant",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "retell",
        try_speaking: [
          "Can you help me schedule mom’s virtual brain screening?",
          "I’m not sure if she took her meds today… can we set reminders for that?"
        ],
        activities: [],
        phoneNumber: "070239",
        language: "English",
        default_voiceId: "default",
        voiceConfig: {},
        optional_voices: [
          {
            id: "default",
            name: "Ava",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
            description: "Female Young & Professional",
            language: "English",
            region: ""
          }
        ]
      }
    ]
  },
  CultFit: {
    path: "cultfit",
    pageTitle: "Experience Our AI Agents",
    pageCategory: "CultFit",
    agents: [
      {
        id: "f9afb1d3-8806-41bc-949e-d03798bc30fc",
        name: "Weekly pulse check-in",
        description:
          "Conducts weekly pulse check-in with center manager employees",
        subDescription:
          "Conducts weekly pulse check-in with center manager employees",
        agentName: "Aditi",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        chatIcon:
          "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        featureList: ["Survey center managers of cult",
          "Gather essential feedback"],
        voice: "true",
        chat: "false",
        callTitle: "Weekly Pulse Check-in Agent",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        try_speaking: [],
        activities: [],
        phoneNumber: "070239",
        language: "Hinglish",
        default_voiceId: "default",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "f9afb1d3-8806-41bc-949e-d03798bc30fc",
          tenant_id: DEFAULT_TENANT_ID,
          workspace_id: DEFAULT_WORKSPACE_ID,
          overide_previous_context: true
        },
        optional_voices: [
          {
            id: "default",
            name: "Aditi",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
            description: "Female Young & Professional",
            language: "Hinglish",
            region: ""
          }
        ]
      },
      {
        id: "de776194-9bfd-455d-b441-2b7aa84a167c",
        name: "Employee Feedback",
        description:
          "Conducts daily CM coaching with centre manager employees",
        subDescription:
          "Conducts daily CM coaching with centre manager employees",
        agentName: "Aditi",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female1.png",
        chatIcon:
          "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female1.png",
        featureList: ["Survey center managers of cult",
          "Gather essential feedback"],
        voice: "true",
        chat: "false",
        callTitle: "Employee Feedback Agent",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        try_speaking: [],
        activities: [],
        phoneNumber: "070239",
        language: "Hinglish",
        default_voiceId: "default",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "de776194-9bfd-455d-b441-2b7aa84a167c",
          tenant_id: DEFAULT_TENANT_ID,
          workspace_id: DEFAULT_WORKSPACE_ID,
          overide_previous_context: true
        },
        optional_voices: [
          {
            id: "default",
            name: "Aditi",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female1.png",
            description: "Female Young & Professional",
            language: "Hinglish",
            region: ""
          }
        ]
      },
      {
        id: "41997189-2e98-425f-b5a4-4cb7da865413",
        name: "Customer Resurrection",
        description:
          "Re-engage members who have been inactive since 14 days",
        subDescription:
          "Re-engage members who have been inactive since 14 days",
        agentName: "Aditi",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female3.png",
        chatIcon:
          "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female3.png",
        featureList: ["Attendance/penalty FAQs",
          "City-move and pause/flexibility FAQs"],
        voice: "true",
        chat: "false",
        callTitle: "Customer Resurrection Agent",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        try_speaking: [],
        activities: [],
        phoneNumber: "070239",
        language: "Hinglish",
        default_voiceId: "default",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "41997189-2e98-425f-b5a4-4cb7da865413",
          tenant_id: DEFAULT_TENANT_ID,
          workspace_id: DEFAULT_WORKSPACE_ID,
          overide_previous_context: true
        },
        optional_voices: [
          {
            id: "default",
            name: "Aditi",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female3.png",
            description: "Female Young & Professional",
            language: "Hinglish",
            region: ""
          }
        ]
      },
      {
        id: "48d5078f-1842-46f9-9e4a-554ff5e56334",
        name: "Checkout Abandonment",
        description:
          "Helps people who dropped off during checkout",
        subDescription:
          "Helps people who dropped off during checkout",
        agentName: "Aditi",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female3.png",
        chatIcon:
          "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female3.png",
        featureList: ["Cult related FAQs",
          "Payment FAQs"],
        voice: "true",
        chat: "false",
        callTitle: "Checkout Abandonment Agent",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        try_speaking: [],
        activities: [],
        phoneNumber: "070239",
        language: "Hinglish",
        default_voiceId: "default",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "48d5078f-1842-46f9-9e4a-554ff5e56334",
          tenant_id: DEFAULT_TENANT_ID,
          workspace_id: DEFAULT_WORKSPACE_ID,
          overide_previous_context: true
        },
        optional_voices: [
          {
            id: "default",
            name: "Aditi",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female3.png",
            description: "Female Young & Professional",
            language: "Hinglish",
            region: ""
          }
        ]
      },

    ]
  },
  WhollyKaw: {
    path: "whollykaw",
    pageTitle: "Experience Our Voice AI Agents",
    pageCategory: "WhollyKaw",
    agents: [
      {
        id: "4bd0ff7e-3c2d-4e99-ac2f-c9c133a1184e",
        name: "Customer Service & FAQ",
        description:
          "Helps customers with product inquiries, shipping and general support for artisan products.",
        subDescription:
          "Helps customers with product inquiries, shipping and general support for artisan products.",
        agentName: "Aditi",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        chatIcon:
          "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        featureList: [],
        voice: "true",
        chat: "false",
        callTitle: "Customer Service & FAQ Agent",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "retell",
        try_speaking: [],
        activities: [],
        phoneNumber: "070239",
        language: "English",
        default_voiceId: "default",
        voiceConfig: {},
        optional_voices: [
          {
            id: "default",
            name: "Sarah",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
            description: "Female Young & Professional",
            language: "English",
            region: ""
          }
        ]
      }
    ]
  },
  Swiggy2: {
    path: "swiggy",
    pageTitle: "Experience our Voice AI Agents",
    pageCategory: "Swiggy",
    agents: [
      {
        id: "efdd30fa-d25a-4dc9-8c46-28c9d99624ac",
        name: "Order Tracking and Refund",
        description:
          " Empathetic voice agent for tracking orders in real-time and providing clear refund updates for cancelled deliveries.",
        subDescription:
          " Empathetic voice agent for tracking orders in real-time and providing clear refund updates for cancelled deliveries.",
        agentName: "Aayush",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/male1.png",
        chatIcon:
          "https://d3udl6i7sipqjw.cloudfront.net/agent-images/male1.png",
        featureList: ["Order tracking", "Refund status"],
        voice: "true",
        chat: "false",
        callTitle: "Order Tracking and Refund Agent",
        chatHints: [],
        callHintsTable: [],
        callHints: [
          "Aloo Paratha ID: 1234 (Order Tracking)",
          "Masala Dosa ID: 1235 (Order Tracking)",
          "Pesto Pizza ID: 1236 (Refund)",
          "Pav Bhaji ID: 1237 (Refund)"
        ],
        voiceInputs: [],
        voiceProvider: "voicex",
        try_speaking: [],
        activities: [],
        phoneNumber: "070239",
        language: "English",
        default_voiceId: "default",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "efdd30fa-d25a-4dc9-8c46-28c9d99624ac",
          tenant_id: DEFAULT_TENANT_ID,
          workspace_id: DEFAULT_WORKSPACE_ID,
          overide_previous_context: true
        },
        optional_voices: [
          {
            id: "default",
            name: "Aayush",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/male1.png",
            description: "Male Young & Professional",
            language: "English",
            region: ""
          }
        ]
      }
    ]
  },
  NurixInternationalSchool: {
    path: "nurix-int-school",
    pageTitle: "Experience our Voice AI Agents",
    pageCategory: "Nuplay International School",
    agents: [
      {
        id: "073a02d2-43e0-47cf-ad7d-c8279c549199",
        name: "FAQs Agent",
        description:
          "A voice agent designed to handle common queries related to admissions, academic programs, tuition, extracurricular activities, and campus facilities for an international school",
        subDescription:
          "A voice agent designed to handle common queries related to admissions, academic programs, tuition, extracurricular activities, and campus facilities for an international school",
        agentName: "Sarah",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        chatIcon:
          "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        featureList: ["FAQ agent",
          "Appointment Scheduling for school visit"],
        voice: "true",
        chat: "false",
        callTitle: "FAQs Agent",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "retell",
        try_speaking: ["How do I enroll my child?",
          "What is the School Uniform policy?"],
        activities: [],
        phoneNumber: "070239",
        language: "English",
        default_voiceId: "default",
        voiceConfig: {},
        optional_voices: [
          {
            id: "default",
            name: "Sarah",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
            description: "Female Young & Professional",
            language: "English",
            region: ""
          }
        ]
      }
    ]
  },
  NurixHomeService: {
    path: "nurix-home-services",
    pageTitle: "Experience our Voice AI Agents",
    pageCategory: "Nuplay Home Services",
    agents: [
      {
        id: "fab5ff9c-e095-400a-8011-88586c8e3be5",
        name: "Customer Support Agent",
        description:
          "A Customer Support voice agent that assists with HVAC, plumbing, and electrical service inquiries. It helps customers understand service offerings, schedule technician visits, and handle emergencies quickly",
        subDescription:
          "A Customer Support voice agent that assists with HVAC, plumbing, and electrical service inquiries. It helps customers understand service offerings, schedule technician visits, and handle emergencies quickly",
        agentName: "Andrew",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/male1.png",
        chatIcon:
          "https://d3udl6i7sipqjw.cloudfront.net/agent-images/male1.png",
        featureList: ["Book Technician Appointments",
          "Explain Service Coverage & Estimates",
          "Handle Emergency Repair Requests"],
        voice: "true",
        chat: "false",
        callTitle: "Support Agent",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "retell",
        try_speaking: ["Can I book a plumber for tomorrow morning?",
          "My AC isn’t cooling — can someone check it today ?",
          "What’s your service charge for electrical work?"],
        activities: ["Schedule & Manage Technician Appointments",
          "Provide Service Details & Pricing Info",
          "Prioritize Emergency Service Requests"],
        phoneNumber: "070239",
        language: "English",
        default_voiceId: "default",
        voiceConfig: {},
        optional_voices: [
          {
            id: "default",
            name: "Andrew",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/male1.png",
            description: "Male Young & Professional",
            language: "English",
            region: ""
          }
        ]
      }
    ]
  },
  HCAHealthCare: {
    path: "hca-healthcare",
    pageTitle: "Experience our Voice AI Agents",
    pageCategory: "HCA Healthcare",
    agents: [
      {
        id: "57124ece-e5a2-4c69-811f-cf2999e74ade",
        name: "Outbound Call Agent",
        description:
          "A friendly voice agent that helps with insurance questions, billing breakdowns, payment reminders, and wellness visit booking—delivering clear, compassionate support throughout the patient journey.",
        subDescription:
          "A friendly voice agent that helps with insurance questions, billing breakdowns, payment reminders, and wellness visit booking—delivering clear, compassionate support throughout the patient journey.",
        agentName: "Claire",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        chatIcon:
          "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        featureList: [
          "Explains deductibles, co-insurance & billing breakdowns",
          "Sends proactive billing reminders and payment updates",
          "Books wellness visits quickly"
        ],
        voice: "true",
        chat: "false",
        callTitle: "Outbound Call Agent",
        chatHints: [],
        callHintsTable: [],
        callHints: [
          "Patient’s Name: Sarah Johnson",
          "Patient’s Birth date: 13th May, 1990"
        ],
        voiceInputs: [],
        voiceProvider: "retell",
        try_speaking: [
          "Oh okay, I didn't realize there was a balance. Can you explain how that was calculated?",
          "Can we go over what the insurance covered?",
          "Sure, go ahead and text me the payment link."
        ],
        activities: [],
        phoneNumber: "070239",
        language: "English",
        default_voiceId: "default",
        voiceConfig: {},
        optional_voices: [
          {
            id: "default",
            name: "Claire",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
            description: "Female Young & Professional",
            language: "English",
            region: ""
          }
        ]
      }
    ]
  },
  EighteenHundredBattery: {
    path: "1800-battery",
    pageTitle: "Experience our Voice AI Agents",
    pageCategory: "1800-battery",
    agents: [
      {
        id: "e8cdea11-21ae-4119-8cb9-eaad4846ccd5",
        name: "Customer Service",
        description:
          "Helps customers with product inquiries",
        subDescription:
          "Helps customers with product inquiries",
        agentName: "Alex",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/male1.png",
        chatIcon:
          "https://d3udl6i7sipqjw.cloudfront.net/agent-images/male1.png",
        featureList: [
          "Battery replacement service"
        ],
        voice: "true",
        chat: "false",
        callTitle: "Customer Service Agent",
        chatHints: [],
        callHintsTable: [],
        callHints: ["Zip code: 12345",
          "Car model: 2015 Chevrolet Avalanche"],
        voiceInputs: [],
        voiceProvider: "retell",
        try_speaking: [],
        activities: [],
        phoneNumber: "070239",
        language: "English",
        default_voiceId: "default",
        voiceConfig: {},
        optional_voices: [
          {
            id: "default",
            name: "Alex",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/male1.png",
            description: "Male Young & Professional",
            language: "English",
            region: ""
          }
        ]
      }
    ]
  },
  HOABL: {
    path: "hoabl",
    pageTitle: "Experience our Voice AI Agents",
    pageCategory: "HOABL",
    agents: [
      {
        id: "808069ef-19ff-43d9-a743-7a410e2c1a8e",
        name: "Sales",
        description:
          "To get insights from people prior to launch",
        subDescription: "Voice: Excited, Patient",
        agentName: "Priya",
        icon: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face",
        chatIcon:
          "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face",
        featureList: [
          "Register RSA request",
          "Verify customer identity",
          "Capture incident details and initiate assistance"
        ],
        voice: "true",
        chat: "false",
        callTitle: "Sales Agent",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        try_speaking: [],
        activities: [],
        phoneNumber: "070239",
        language: "Hinglish",
        default_voiceId: "default",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "808069ef-19ff-43d9-a743-7a410e2c1a8e",
          overide_previous_context: true,
          custom_data: {},
          tenant_id: DEFAULT_TENANT_ID,
          workspace_id: DEFAULT_WORKSPACE_ID
        },
        optional_voices: [
          {
            id: "default",
            name: "Priya",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
            description: "Female Young & Professional",
            language: "Hinglish",
            region: ""
          }
        ]
      }
    ]
  },
  CultEmployee: {
    path: "cult-employee",
    pageTitle: "Experience Our AI Agents",
    pageCategory: "CultFit",
    agents: [
      {
        id: "de776194-9bfd-455d-b441-2b7aa84a167c",
        name: "Employee Feedback",
        description:
          "Conducts daily performance coaching with center manager employees",
        subDescription:
          "Conducts daily performance coaching with center manager employees",
        agentName: "Aditi",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female1.png",
        chatIcon:
          "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female1.png",
        featureList: ["Survey center managers of cult",
          "Gather essential feedback"],
        voice: "true",
        chat: "false",
        callTitle: "Employee Feedback Agent",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        try_speaking: [],
        activities: [],
        phoneNumber: "070239",
        language: "Hinglish",
        default_voiceId: "default",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "de776194-9bfd-455d-b441-2b7aa84a167c",
          tenant_id: DEFAULT_TENANT_ID,
          workspace_id: DEFAULT_WORKSPACE_ID,
          overide_previous_context: true
        },
        optional_voices: [
          {
            id: "default",
            name: "Aditi",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female1.png",
            description: "Female Young & Professional",
            language: "Hinglish",
            region: ""
          }
        ]
      }
    ]
  },
  PaisaBazaarV2V: {
    path: "paisabazaar-v2v",
    pageTitle: "Experience our Voice AI Agents",
    pageCategory: "PaisaBazaar",
    agents: [
      {
        id: "8d58e16c-ce81-4812-aedb-8feb3fc78fea",
        name: "EMI Reminder",
        description: "A voice agent that helps users stay on top of their EMIs by sending timely reminders, explaining loan details, and guiding them through payment options.",
        subDescription: "A voice agent that helps users stay on top of their EMIs by sending timely reminders, explaining loan details, and guiding them through payment options.",
        agentName: "Raj",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/male2.png",
        chatIcon:
          "https://d3udl6i7sipqjw.cloudfront.net/agent-images/male2.png",
        featureList: ["Overdue Payment Alerts", "Language: Hinglish"],
        voice: "true",
        chat: "false",
        callTitle: "EMI Reminder Agent",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        try_speaking: [],
        activities: [],
        phoneNumber: "070239",
        language: "Hinglish",
        default_voiceId: "default",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "8d58e16c-ce81-4812-aedb-8feb3fc78fea",
          tenant_id: DEFAULT_TENANT_ID,
          workspace_id: DEFAULT_WORKSPACE_ID,
          overide_previous_context: true
        },
        optional_voices: [
          {
            id: "default",
            name: "Raj",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/male2.png",
            description: "Male Young & Professional",
            language: "Hinglish",
            region: ""
          }
        ]
      }
    ]
  },
  MarketPlacer: {
    path: "marketplacer",
    pageTitle: "Experience Our AI Agents",
    pageCategory: "MarketPlacer",
    agents: [
      {
        id: "4d50167c-fc16-49f2-92ee-8962a100133c",
        name: "Outbound Sales Agent",
        description:
          "A proactive Sales Voice Agent designed to engage potential sellers through outbound calls. It introduces Marketplacer, explains platform benefits, and guides interested businesses through the seller onboarding process by collecting key registration details.",
        subDescription:
          "A proactive Sales Voice Agent designed to engage potential sellers through outbound calls. It introduces Marketplacer, explains platform benefits, and guides interested businesses through the seller onboarding process by collecting key registration details.",
        agentName: "Andrew",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/male1.png",
        chatIcon:
          "https://d3udl6i7sipqjw.cloudfront.net/agent-images/male1.png",
        featureList: ["Deliver Platform Introduction & Sales Pitch",
          "Collect Seller Onboarding Information",
          "Handle Basic Questions About Marketplacer’s Benefits & Process"],
        voice: "true",
        chat: "false",
        callTitle: "Outbound Sales Agent",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "retell",
        try_speaking: ["What is Marketplacer ? What do they do?",
          "I’m interested — how do I become a seller ?",
          "Do I need my own website to start selling ?",
          "What kind of businesses are already using Marketplacer?",],
        activities: ["Introduce Marketplacer and its value proposition",
          "Qualify interested sellers and collect personal / business info",
          "Provide key statistics or success examples",
          "Redirect complex or technical questions to live agents if needed"],
        phoneNumber: "070239",
        language: "English",
        default_voiceId: "default",
        voiceConfig: {},
        optional_voices: [
          {
            id: "default",
            name: "Andrew",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/male1.png",
            description: "Male Young & Professional",
            language: "English",
            region: ""
          }
        ]
      },
      {
        id: "37931107-9e14-44c0-b8d7-ef6914f3a414",
        name: "Onboarding Agent",
        description:
          "An Onboarding Voice Agent designed to assist interested sellers in completing their registration with Marketplacer. It collects essential details, confirms critical information, and ensures a smooth handoff to the next stage of activation.",
        subDescription:
          "An Onboarding Voice Agent designed to assist interested sellers in completing their registration with Marketplacer. It collects essential details, confirms critical information, and ensures a smooth handoff to the next stage of activation.",
        agentName: "Andrew",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/male1.png",
        chatIcon:
          "https://d3udl6i7sipqjw.cloudfront.net/agent-images/male1.png",
        featureList: ["Collects and Confirms Information",
          "Guide Through Onboarding Steps"],
        voice: "true",
        chat: "false",
        callTitle: "Onboarding Agent",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "retell",
        try_speaking: ["Yes, I want to register — what do you need from me?",
          "Please help me, with my Onboarding",],
        activities: [],
        phoneNumber: "070239",
        language: "English",
        default_voiceId: "default",
        voiceConfig: {},
        optional_voices: [
          {
            id: "default",
            name: "Andrew",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/male1.png",
            description: "Male Young & Professional",
            language: "English",
            region: ""
          }
        ]
      },
    ]
  },
  VGuard: {
    path: "vguard",
    pageTitle: "Experience Our AI Agents",
    pageCategory: "VGuard",
    agents: [
      {
        id: "9372b4fd-76c8-4d36-898b-301cc7ad8f19",
        name: "Installation Support Agent",
        description:
          "A unique Installation support agent that helps schedule installation task for any of the VGuard products purchased online or offline. It involves taking important info. from the user and scheduling the installation process",
        subDescription:
          "A unique Installation support agent that helps schedule installation task for any of the VGuard products purchased online or offline. It involves taking important info. from the user and scheduling the installation process",
        agentName: "Sara",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        chatIcon:
          "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        featureList: ["Collects basic information from the user regarding the purchase",
          "Schedules the final installation for the user"],
        voice: "true",
        chat: "false",
        callTitle: "Installation Support Agent",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        try_speaking: ["Please help me install my VGuard water purifier",
          "I am interested to install Zenora RO.Help me in the next steps forward."],
        activities: [],
        phoneNumber: "070239",
        language: "English",
        default_voiceId: "default",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "9372b4fd-76c8-4d36-898b-301cc7ad8f19",
          tenant_id: DEFAULT_TENANT_ID,
          workspace_id: DEFAULT_WORKSPACE_ID,
          overide_previous_context: true
        },
        optional_voices: [
          {
            id: "default",
            name: "Sara",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
            description: "Female Young & Professional",
            language: "English",
            region: ""
          }
        ]
      },
      {
        id: "1249a1e4-0544-40ff-a210-3fde77356e83",
        name: "Customer Support Agent",
        description:
          "A friendly and professional Customer Support Voice Agent designed to assist customers with installation and service requests for V-Guard water purifiers.",
        subDescription:
          "A friendly and professional Customer Support Voice Agent designed to assist customers with installation and service requests for V-Guard water purifiers.",
        agentName: "Revathi",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        chatIcon:
          "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        featureList: ["Guides Through Installation Request Process",
          "Schedules Technician Visits"],
        voice: "true",
        chat: "false",
        callTitle: "Customer Support Agent",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        try_speaking: ["Yes, I bought a V-Guard purifier. Can you help me install it?"],
        activities: [],
        phoneNumber: "070239",
        language: "English",
        default_voiceId: "default",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "1249a1e4-0544-40ff-a210-3fde77356e83",
          tenant_id: DEFAULT_TENANT_ID,
          workspace_id: DEFAULT_WORKSPACE_ID,
          overide_previous_context: true
        },
        optional_voices: [
          {
            id: "default",
            name: "Revathi",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
            description: "Female Young & Professional",
            language: "English",
            region: ""
          }
        ]
      },
    ]
  },
  TurtleMint: {
    path: "turtlemint",
    pageTitle: "Experience Our AI Agents",
    pageCategory: "TurtleMint",
    agents: [
      {
        id: "db6a6780-1af7-4d9e-8b0c-809293a68409",
        name: " Health Insurance Sales",
        description:
          "A health insurance support agent that advices the user on various options available as a part of Turtlemint's health insurance partnerships with other insurance companies.",
        subDescription:
          "A health insurance support agent that advices the user on various options available as a part of Turtlemint's health insurance partnerships with other insurance companies.",
        agentName: "Myra",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        chatIcon:
          "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        featureList: ["Advices the user about available options under their plan.",
          "Asks the user about their preferences."],
        voice: "true",
        chat: "false",
        callTitle: " Health Insurance Sales Agent",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        try_speaking: ["Suggest me a really good health insurance plan",
          "I want an affordable health insurance plan for myself."],
        activities: [],
        phoneNumber: "070239",
        language: "English",
        default_voiceId: "default",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "db6a6780-1af7-4d9e-8b0c-809293a68409",
          tenant_id: DEFAULT_TENANT_ID,
          workspace_id: DEFAULT_WORKSPACE_ID,
          overide_previous_context: true
        },
        optional_voices: [
          {
            id: "default",
            name: "Myra",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
            description: "Female Young & Professional",
            language: "English",
            region: ""
          }
        ]
      },
    ]
  },
  Tucows: {
    path: "tucows",
    pageTitle: "Experience our Voice AI Agents",
    pageCategory: "Tucows",
    agents: [
      {
        id: "b3ecf97f-dce7-4e20-82d4-9f44046d0c97",
        name: "FAQ Agent",
        description:
          "Helps users manage DNS related queries",
        subDescription:
          "Helps users manage DNS related queries",
        agentName: "Sarah",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        chatIcon:
          "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        featureList: [
          "Identify any DNS issue faced by the user",
          "Assist the user towards a resolution"
        ],
        voice: "true",
        chat: "false",
        callTitle: "FAQ Agent",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "retell",
        try_speaking: [],
        activities: [],
        phoneNumber: "070239",
        language: "English",
        default_voiceId: "default",
        voiceConfig: {},
        optional_voices: [
          {
            id: "default",
            name: "Sarah",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
            description: "Female Young & Professional",
            language: "English",
            region: ""
          }
        ]
      },
      {
        "id": "a8b7684f-942c-486e-a484-f9276dde6eed",
        "name": "Ting Internet Customer Support Agent",
        "description": "A helpful and patient voice assistant that helps Ting Internet customers with troubleshooting, billing, and service setup.",
        "subDescription": "A helpful and patient voice assistant that helps Ting Internet customers with troubleshooting, billing, and service setup.",
        "agentName": "Bessie",
        "icon": "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        "chatIcon": "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        "featureList": [
          "Troubleshoot internet and connection issues",
          "Answer billing and account-related questions",
          "Check service availability by ZIP code"
        ],
        "voice": "true",
        "chat": "false",
        "callTitle": "Ting Internet Customer Support Agent",
        "chatHints": [],
        "callHintsTable": [],
        "callHints": [],
        "voiceInputs": [],
        "voiceProvider": "retell",
        "try_speaking": [
          "Why is my internet not working?",
          "Is Ting available in my area?",
          "How do I set up my router?"
        ],
        "activities": [
          "Identify the user's issue type and guide them accordingly",
          "Guide through internet or equipment troubleshooting steps",
          "Escalate complex or off-topic issues to human agents"
        ],
        "phoneNumber": "070239",
        "language": "English",
        "default_voiceId": "default",
        "voiceConfig": {},
        "optional_voices": [
          {
            "id": "default",
            "name": "Bessie",
            "icon": "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
            "description": "Female Young & Professional",
            "language": "English",
            "region": ""
          }
        ]
      }

    ]
  },
  Myntra: {
    path: "myntra",
    pageTitle: "Experience Our AI Agents",
    pageCategory: "Myntra",
    agents: [
      {
        id: "76c436df-14aa-46c0-97dd-c7893354cc29",
        name: "Seller Onboarding",
        description:
          "Give prospective or existing sellers a smooth, positive onboarding and growth experience on Myntra.",
        subDescription:
          "Give prospective or existing sellers a smooth, positive onboarding and growth experience on Myntra.",
        agentName: "Sneha",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        chatIcon:
          "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        featureList: ["All Myntra seller onboarding steps included, subscription related and general FAQs."],
        voice: "true",
        chat: "false",
        callTitle: "Seller Onboarding Agent ",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        try_speaking: [],
        activities: [],
        phoneNumber: "070239",
        language: "English",
        default_voiceId: "default",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "76c436df-14aa-46c0-97dd-c7893354cc29",
          tenant_id: DEFAULT_TENANT_ID,
          workspace_id: DEFAULT_WORKSPACE_ID,
          overide_previous_context: true
        },
        optional_voices: [
          {
            id: "default",
            name: "Sneha",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
            description: "Female Young & Professional",
            language: "English",
            region: ""
          }
        ]
      },
    ]
  },
  Groww: {
    path: "groww",
    pageTitle: "Experience Our AI Agents",
    pageCategory: "Groww",
    agents: [
      {
        id: "60987538-11d6-499c-b6cc-0904debfa864",
        name: "Groww- Outbound e-KYC Completion",
        description:
          "An intelligent outbound e-KYC completion agent that help users complete their e-KYC for account setup for trading, buying mutual funds etc.",
        subDescription:
          "An intelligent outbound e-KYC completion agent that help users complete their e-KYC for account setup for trading, buying mutual funds etc.",
        agentName: "Priya",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        chatIcon:
          "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        featureList: ["Helps user complete their e - KYC by identifying the loop holes.",
          "Real time guidance to users."
        ],
        voice: "true",
        chat: "false",
        callTitle: "Groww- Outbound e-KYC Completion Agent",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        try_speaking: ["Aadhaar e-sign हो ही नहीं रहा... बार-बार error आ रहा है।",
          "इतने सारे steps हैं, मुझे थोड़ा complicated लग रहा है।"],
        activities: [],
        phoneNumber: "070239",
        language: "Hinglish",
        default_voiceId: "default",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "60987538-11d6-499c-b6cc-0904debfa864",
          tenant_id: DEFAULT_TENANT_ID,
          workspace_id: DEFAULT_WORKSPACE_ID,
          overide_previous_context: true
        },
        optional_voices: [
          {
            id: "default",
            name: "Priya",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
            description: "Female Young & Professional",
            language: "Hinglish",
            region: ""
          }
        ]
      },
      {
        id: "fd79c5c1-6a2a-4d77-acce-88dfa0795ba8",
        name: "Personal Loan Qualification Agent",
        description:
          "An advanced outbound personal loan qualification agent from Groww, offering personal loans to its customer base.",
        subDescription:
          "An advanced outbound personal loan qualification agent from Groww, offering personal loans to its customer base.",
        agentName: "Kavya",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        chatIcon:
          "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        featureList: ["Fast Loan Check with Soft Guidance",
          "Personalized Eligibility Flow"
        ],
        voice: "true",
        chat: "false",
        callTitle: "Personal Loan Qualification Agent",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        try_speaking: ["क्या ये loan Groww के app में ही दिखेगा या अलग से कुछ करना होगा?",
          "Qualification check करने में कितना time लगता है?"],
        activities: [],
        phoneNumber: "070239",
        language: "Hinglish",
        default_voiceId: "default",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "fd79c5c1-6a2a-4d77-acce-88dfa0795ba8",
          tenant_id: DEFAULT_TENANT_ID,
          workspace_id: DEFAULT_WORKSPACE_ID,
          overide_previous_context: true
        },
        optional_voices: [
          {
            id: "default",
            name: "Kavya",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
            description: "Female Young & Professional",
            language: "Hinglish",
            region: ""
          }
        ]
      }
    ]
  },
  liquide: {
    path: "liquide",
    pageTitle: "Experience Our AI Agents",
    pageCategory: "Liquide",
    agents: [
      // {
      //   id: "c7421a1c-8ca2-42f4-a7eb-51b91593fa65",
      //   name: "Customer Support Agent",
      //   agentName: "Riya",
      //   description:
      //     "Helps people with their queries about Liquide",
      //   subDescription:
      //     "Helps people with their queries about Liquide",
      //   icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
      //   chatIcon:
      //     "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
      //   featureList: [
      //     "All liquide feature and subscription related FAQs"
      //   ],
      //   voice: "true",
      //   chat: "false",
      //   callTitle: "Customer Support Agent",
      //   chatHints: [],
      //   callHints: [],
      //   callHintsTable: [],
      //   voiceInputs: [],
      //   voiceProvider: "voicex",
      //   try_speaking: [],
      //   activities: [],
      //   phoneNumber: "",
      //   language: "English",
      //   default_voiceId: "default",
      //   voiceConfig: {
      //     baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
      //     user_id: DEFAULT_USER_ID,
      //     agent_id: "c7421a1c-8ca2-42f4-a7eb-51b91593fa65",
      //     tenant_id: DEFAULT_TENANT_ID,
      //     workspace_id: DEFAULT_WORKSPACE_ID,
      //     overide_previous_context: true
      //   },
      //   optional_voices: [{
      //     id: "default",
      //     name: "Riya",
      //     icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
      //     description: "Female Young & Professional",
      //     language: "English",
      //     region: ""
      //   }]
      // },
      {
        id: "c7421a1c-8ca2-42f4-a7eb-51b91593fa65",
        name: "Wealth Engagement Advisor",
        agentName: "Riya",
        description:
          "An intelligent wealth engagement advisor that advices users about importance of engaging in Liquide Investment Solutions' offerings for handling their personal wealth.",
        subDescription:
          "An intelligent wealth engagement advisor that advices users about importance of engaging in Liquide Investment Solutions' offerings for handling their personal wealth.",
        icon: "https://iili.io/FN2hG19.png",
        chatIcon:
          "https://iili.io/FN2hG19.png",
        featureList: [
          "Personalised guidance for traders and investors", "States the importance of using Liquide's offerings for your wealth management"
        ],
        voice: "true",
        chat: "false",
        callTitle: "Wealth Engagement Advisor",
        chatHints: [],
        callHints: [],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        try_speaking: ["मैं trader हूँ — Liquide मेरे लिए क्या करता है?", "मुझे tax planning सीखनी है — Liquide help करता है क्या?"],
        activities: [],
        phoneNumber: "",
        language: "English",
        default_voiceId: "default",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "c7421a1c-8ca2-42f4-a7eb-51b91593fa65",
          tenant_id: "4321b0d7-361c-4250-97c2-f987f0b72a56",
          workspace_id: "4321b0d7-361c-4250-97c2-f987f0b72a56",
          overide_previous_context: true
        },
        optional_voices: [{
          id: "default",
          name: "Riya",
          icon: "https://iili.io/FN2hG19.png",
          description: "Female Young & Professional",
          language: "Hinglish",
          region: ""
        }]
      },

    ]
  },
  Barclays: {
    path: "Barclays",
    pageTitle: "Experience Our Voice AI Agents",
    pageCategory: "Barclays",
    agents: [
      {
        id: "3335fd8b-78a2-4f27-be0a-4b77f71b7d85",
        name: "Debt Collection Agent",
        agentName: "Maria",
        description:
          "Remind Users to Pay Overdue",
        subDescription:
          "Remind Users to Pay Overdue",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        chatIcon:
          "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        featureList: [
          "Optimal Debt Resolution Strategies",
          "Reminds User to Pay Overdue"
        ],
        voice: "true",
        chat: "false",
        callTitle: "Debt Collection Agent",
        chatHints: [],
        callHints: ["Name of User : Mr Robin Smith", "Social security code : 3456", "Date of Birth : 2nd Jan 1998"],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "retell",
        try_speaking: ["I am broke, I can only pay $100 per month.Do you have any plans that help me settle my debt?", "I cannot share my Social Security Number."],
        activities: [],
        phoneNumber: "",
        language: "English",
        default_voiceId: "default",
        voiceConfig: {},
        optional_voices: [{
          id: "default",
          name: "Maria",
          icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
          description: "Male Young & Professional",
          language: "English",
          region: ""
        }]
      },
      {
        id: "018c4ff7-b587-4b0c-a195-d32eff584609",
        name: "Banking Customer Agent",
        agentName: "Sarah",
        description:
          "Ensures that customers have a positive experience when interacting with Barclays.",
        subDescription:
          "Ensures that customers have a positive experience when interacting with Barclays.",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        chatIcon:
          "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        featureList: [
          "Account Transaction Support",
          "Credit Card Transaction Support",
          "Credit Card Upgradation and Modification",
        ],
        voice: "true",
        chat: "false",
        callTitle: "Banking Customer Agent",
        chatHints: [],
        callHints: ["Last four digits of SSN : 5439", "Last Four digits of Bank Account : 5438", "Last Four digits of Credit Card : 1532"],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "retell",
        try_speaking: ["What were the last five transaction on my savings bank account?", "I did not initiate the last transaction that you mentioned. Can you help me raise a dispute regarding the same?"],
        activities: [],
        phoneNumber: "",
        language: "English",
        default_voiceId: "default",
        voiceConfig: {},
        optional_voices: [{
          id: "default",
          name: "Sarah",
          icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
          description: "Male Young & Professional",
          language: "English",
          region: ""
        }]
      }
    ]
  },
  Westan: {
    path: "Westan",
    pageTitle: "Experience Our Voice AI Agents",
    pageCategory: "Westan Insurance Group",
    agents: [
      {
        id: "312d41be-1c1f-4e40-9bb7-a80090efc7fc",
        name: "Auto Insurance Renewal",
        agentName: "Ethan",
        description:
          "Guiding customer through the renewal of their Auto Insurance Policy.",
        subDescription:
          "Guiding customer through the renewal of their Auto Insurance Policy.",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/male1.png",
        chatIcon:
          "https://d3udl6i7sipqjw.cloudfront.net/agent-images/male1.png",
        featureList: [
          "Sales Qualification",
          "Policy Updates Collection",
          "Renewal Reminders",
        ],
        voice: "true",
        chat: "false",
        callTitle: "Auto Insurance Renewal Agent",
        chatHints: [],
        callHints: [],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "retell",
        try_speaking: ["I had a major accident last week and my car has a huge dent on it.", "I have a son who is going to turn seventeen year old , can he be added to the drivers list?", "How much discount would i get on bundling?"],

        activities: [],
        phoneNumber: "",
        language: "English",
        default_voiceId: "default",
        voiceConfig: {},
        optional_voices: [{
          id: "default",
          name: "Ethan",
          icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/male1.png",
          description: "Male Young & Professional",
          language: "English",
          region: ""
        }]
      },
    ]
  },
  CoverRight: {
    path: "cover-right",
    pageTitle: "Experience Our AI Agents",
    pageCategory: "CoverRight",
    agents: [
      {
        id: "1d121919-3abf-4584-845f-92dbc285db8d",
        name: "CSR Agent",
        description:
          "Qualifies Medicare callers, answers their queries and connects them to a licensed expert.",
        subDescription:
          "Qualifies Medicare callers, answers their queries and connects them to a licensed expert.",
        agentName: "Susan",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female1.png",
        chatIcon:
          "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female1.png",
        featureList: ["Qualifies Medicare callers in minutes",
          "Answers basic plan questions",
          "Hands off to a licensed agent"],
        voice: "true",
        chat: "false",
        callTitle: "CSR Agent",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "retell",
        try_speaking: ["I’m turning 65 soon—can you help me understand my Medicare options?",
          "What’s the difference between Medicare Advantage and Medigap?",
          "Will it cost me more if I enroll in Medicare through CoverRight?"],
        activities: [],
        phoneNumber: "070239",
        language: "English",
        default_voiceId: "default",
        voiceConfig: {},
        optional_voices: [
          {
            id: "default",
            name: "Susan",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female1.png",
            description: "Female Young & Professional",
            language: "English",
            region: ""
          }
        ]
      }
    ]
  },
  HOABL2: {
    path: "hoabl-new",
    pageTitle: "Experience our Voice AI Agents",
    pageCategory: "HOABL",
    agents: [
      {
        id: "61fcc174-233a-4df1-b6df-0a0fa5434aa5",
        name: "Sales",
        description:
          "To get insights from people prior to launch",
        subDescription: "Voice: Excited, Patient",
        agentName: "Priya",
        icon: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face",
        chatIcon:
          "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face",
        featureList: [
          "Register RSA request",
          "Verify customer identity",
          "Capture incident details and initiate assistance"
        ],
        voice: "true",
        chat: "false",
        callTitle: "Sales Agent",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        try_speaking: [],
        activities: [],
        phoneNumber: "070239",
        language: "Hinglish",
        default_voiceId: "default",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: US_USER_ID,
          agent_id: "61fcc174-233a-4df1-b6df-0a0fa5434aa5",
          overide_previous_context: true,
          custom_data: {},
          tenant_id: DEFAULT_TENANT_ID,
          workspace_id: DEFAULT_WORKSPACE_ID
        },
        optional_voices: [
          {
            id: "default",
            name: "Priya",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
            description: "Female Young & Professional",
            language: "Hinglish",
            region: ""
          }
        ]
      }
    ]
  },
  Encova: {
    path: "encova",
    pageTitle: "Experience Our Voice AI Agents",
    pageCategory: "Encova Insurance",
    agents: [
      {
        id: "11802ac8-7780-4629-8ea0-03e8439284ed",
        name: "Auto Insurance Renewal Agent",
        description:
          "Guiding customer through the renewal of their Auto Insurance Policy",
        subDescription:
          "Guiding customer through the renewal of their Auto Insurance Policy",
        agentName: "Ethan",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/male1.png",
        chatIcon:
          "https://d3udl6i7sipqjw.cloudfront.net/agent-images/male1.png",
        featureList: ["Sales Qualification",
          "Policy Updates Collection",
          "Renewal Reminders"],
        voice: "true",
        chat: "false",
        callTitle: "Auto Insurance Renewal Agent",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "retell",
        try_speaking: ["I had a major accident last week and my car has a huge dent on it.",
          "I have a son who is going to turn seventeen year old , can he be added to the drivers list?",
          "How much discount would i get on bundling?"],
        activities: [],
        phoneNumber: "070239",
        language: "English",
        default_voiceId: "default",
        voiceConfig: {},
        optional_voices: [
          {
            id: "default",
            name: "Ethan",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/male1.png",
            description: "Female Young & Professional",
            language: "English",
            region: ""
          }
        ]
      },
      {
        id: "cbc59d56-f5f8-494a-b6b1-cb1e4be4b3d5",
        name: "Home Insurance FNOL",
        description:
          "Ensures that customers have a smooth experience in registering their FNOL claim.",
        subDescription:
          "Ensures that customers have a smooth experience in registering their FNOL claim.",
        agentName: "Sarah",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        chatIcon:
          "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        featureList: ["Register home damage claim",
          "Collect incident details"
        ],
        voice: "true",
        chat: "false",
        callTitle: "Home Insurance FNOL",
        chatHints: [],
        callHintsTable: [],
        callHints: ["Claimant name : John Doe", "Phone Number : 555-123-4567", "Policy Number : NRX-1234", "OTP : 123456"],
        voiceInputs: [],
        voiceProvider: "retell",
        try_speaking: ["Hi, I need to report a claim on my home policy?",
          "Can you tell me what my policy covers?"],
        activities: [],
        phoneNumber: "070239",
        language: "English",
        default_voiceId: "default",
        voiceConfig: {},
        optional_voices: [
          {
            id: "default",
            name: "Sarah",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
            description: "Female Young & Professional",
            language: "English",
            region: ""
          }
        ]
      }
    ]
  },
  Bambinos: {
    path: "bambinos",
    pageTitle: "Experience Our AI Agents",
    pageCategory: "Bambinos",
    agents: [
      {
        id: "afb8f7a4-e9e8-4e27-b286-943ddd5f4235",
        name: "Customer Support ",
        description:
          "A friendly and professional Customer Support Voice Agent designed to assist parents with course inquiries, trial class bookings, and service-related questions for Bambinos online learning programs.",
        subDescription:
          "A friendly and professional Customer Support Voice Agent designed to assist parents with course inquiries, trial class bookings, and service-related questions for Bambinos online learning programs.",
        agentName: "Shweta",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        chatIcon:
          "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        featureList: ["Helps explore age - appropriate courses(like Unbox English, Little Yogi, and Alpha Math",
          "Shares info about subscriptions, class formats, and teacher profiles"
        ],
        voice: "true",
        chat: "false",
        callTitle: "Customer Support Agent",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        try_speaking: ["Hi, I’m looking for an online English class for my 7-year - old—can you help me out?"],
        activities: [],
        phoneNumber: "070239",
        language: "Hinglish",
        default_voiceId: "default",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: US_USER_ID,
          agent_id: "afb8f7a4-e9e8-4e27-b286-943ddd5f4235",
          tenant_id: DEFAULT_TENANT_ID,
          workspace_id: DEFAULT_WORKSPACE_ID,
          overide_previous_context: true
        },
        optional_voices: [
          {
            id: "default",
            name: "Shweta",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
            description: "Female Young & Professional",
            language: "Hinglish",
            region: ""
          }
        ]
      },
    ]
  },
  NurixEcom: {
    path: "nurix-ecom",
    pageTitle: "Experience Our AI Agents",
    pageCategory: "Nuplay Ecom",
    agents: [
      {
        id: "8ca9eae4-574c-43bf-b621-f404c69ac35a",
        name: "Inbound Customer Support",
        description:
          "A friendly and efficient Customer Support Voice Agent designed to assist Nuplay Ecom customers with order-related inquiries.",
        subDescription:
          "A friendly and efficient Customer Support Voice Agent designed to assist Nuplay Ecom customers with order-related inquiries.",
        agentName: "Alice",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        chatIcon:
          "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        featureList: ["Assist with Returns and Refunds",
          "Provide Order Status and Delivery Information",
          "Offer Return Method Options and Process Refunds",
          "Maintain Contextual, Human- like Conversation Flow"
        ],
        voice: "true",
        chat: "false",
        callTitle: "Inbound Customer Support Agent",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "retell",
        try_speaking: [],
        activities: ["Greet customers and identify orders",
          "Confirm delivery and reason for return",
          "Offer return options and refund methods"],
        phoneNumber: "070239",
        language: "English",
        default_voiceId: "default",
        voiceConfig: {},
        optional_voices: [
          {
            id: "default",
            name: "Alice",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
            description: "Female Young & Professional",
            language: "English",
            region: ""
          }
        ]
      },
    ]
  },
  Creighton: {
    path: "creighton",
    pageTitle: "Experience Our Voice AI Agents",
    pageCategory: "Creighton",
    agents: [
      {
        id: "33d4c7d1-0014-444e-8e7e-1b9169f236de",
        name: "Student admissions & support - FAQ",
        description:
          "The agent handles common admissions-related queries for Creighton University, including financial aid, international student support, campus tours, application deadlines, and orientation - all in an empathetic, calm, and supportive tone.",
        subDescription:
          "The agent answers common admissions queries for Creighton University in an empathetic & supportive tone.",
        agentName: "Sarah",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        chatIcon:
          "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        featureList: ["Answers general student FAQs extensively, clearly and accurately.",
          "Encourages users to explore Creighton in person and offers to help schedule a campus tour.",
          "Helps users book campus visits based on their preferred time and location."
        ],
        voice: "true",
        chat: "false",
        callTitle: "Student admissions & support Agent",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "retell",
        try_speaking: ["I want to book a campus visit for Pheonix Campus next week. ",
          "Can I get a scholarship as an international student ? "],
        activities: [],
        phoneNumber: "070239",
        language: "English",
        default_voiceId: "default",
        voiceConfig: {},
        optional_voices: [
          {
            id: "default",
            name: "Sarah",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
            description: "Female Young & Professional",
            language: "English",
            region: ""
          }
        ]
      },
    ]
  },
  Ekart: {
    path: "ekart",
    pageTitle: "Experience Our AI Agents",
    pageCategory: "ekart",
    agents: [
      {
        id: "375c6815-1a52-4012-ab19-07786a31987a",
        name: "Recruitment Voice Agent ",
        description:
          "A friendly and professional Recruitment Voice Agent designed to assist job seekers with delivery partner roles at Ekart.",
        subDescription:
          "A friendly and professional Recruitment Voice Agent designed to assist job seekers with delivery partner roles at Ekart.",
        agentName: "Shweta",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        chatIcon:
          "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        featureList: ["Helps job seekers explore flexible delivery roles at Ekart (part-time or full-time)",
          "Helps schedule training sessions (virtual onboarding)"
        ],
        voice: "true",
        chat: "false",
        callTitle: "Recruitment Voice Agent",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        try_speaking: ["Hello, main delivery partner banna चाहता हूँ Ekart ke साथ — क्या abhi hiring चल रही है?"],
        activities: [],
        phoneNumber: "070239",
        language: "Hinglish",
        default_voiceId: "default",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "375c6815-1a52-4012-ab19-07786a31987a",
          tenant_id: DEFAULT_TENANT_ID,
          workspace_id: DEFAULT_WORKSPACE_ID,
          overide_previous_context: true
        },
        optional_voices: [
          {
            id: "default",
            name: "Shweta",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
            description: "Female Young & Professional",
            language: "Hinglish",
            region: ""
          }
        ]
      },
    ]
  },
  EncovaFNOL: {
    path: "encovafnol",
    pageTitle: "Experience Our Voice AI Agents",
    pageCategory: "EncovaFNOL",
    agents: [
      {
        id: "cbc59d56-f5f8-494a-b6b1-cb1e4be4b3d5",
        name: "Home Insurance FNOL",
        description:
          "Ensures that customers have a smooth experience.",
        subDescription:
          "Ensures that customers have a smooth experience .",
        agentName: "Sarah",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        chatIcon:
          "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        featureList: ["Register home damage claim",
          "Collect incident details"
        ],
        voice: "true",
        chat: "false",
        callTitle: "Home Insurance FNOL",
        chatHints: [],
        callHintsTable: [],
        callHints: ["Claimant name : John Doe", "Phone Number : 555-123-4567", "Policy Number : NRX-1234", "OTP : 123456"],
        voiceInputs: [],
        voiceProvider: "retell",
        try_speaking: ["Hi, I need to report a claim on my home policy?",
          "Can you tell me what my policy covers?"],
        activities: [],
        phoneNumber: "070239",
        language: "English",
        default_voiceId: "default",
        voiceConfig: {},
        optional_voices: [
          {
            id: "default",
            name: "Sarah",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
            description: "Female Young & Professional",
            language: "English",
            region: ""
          }
        ]
      },
    ]
  },
  Allivet: {
    path: "allivet",
    pageTitle: "Experience Our Voice AI Agents",
    pageCategory: "Allivet",
    agents: [
      {
        id: "f7eb8f64-a2a8-4d48-8bc6-b79270c095f9",
        name: "Order FAQ Agent",
        description:
          "The agent helps Allivet customers quickly get answers to common order-related questions like tracking, shipping, returns, and more.",
        subDescription:

          "The agent helps Allivet Pet Pharmacy customers quickly get answers to common order-related questions.",

        agentName: "Allie",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        chatIcon:
          "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        featureList: ["Answers general FAQs extensively, clearly and accurately.",
          "Clarifies shipping options, costs, timelines, and eligibility for free shipping.",
          "Assists with account access, password resets, and profile updates."
        ],
        voice: "true",
        chat: "false",
        callTitle: "Order FAQ Agent",
        chatHints: [],
        callHintsTable: [],
        callHints: ["Name : John Smith", "Email ID : john.smith@gmail.com"],
        voiceInputs: [],
        voiceProvider: "retell",
        try_speaking: ["How can I order prescription medicines?",
          "What is Autoship?"],
        activities: [],
        phoneNumber: "070239",
        language: "English",
        default_voiceId: "default",
        voiceConfig: {},
        optional_voices: [
          {
            id: "default",
            name: "Allie",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
            description: "Female Young & Professional",
            language: "English",
            region: ""
          }
        ]
      },
    ]
  },
  CareOne: {
    path: "careone&puredebit",
    pageTitle: "Experience Our Voice AI Agents",
    pageCategory: "CareOne & PureDebit",
    agents: [
      {
        id: "7d9c4143-d918-4d14-b6a8-1988baeb8f4c",
        name: "Pre-qualification for Debt Relief Services",
        description:
          "Delivers compassionate first contact for existing & new customers .",
        subDescription:

          "Delivers compassionate first contact for existing & new customers .",

        agentName: "Emma",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        chatIcon:
          "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        featureList: ["Routes callers to the right team – Sends current clients to Negotiations or Support and new prospects to Sales.",
          "Helps with FAQs – Gives clear answers about Care One's & Pure Debt's services.",
          "New client intake – Collects debt amount, basic details, and contact info, then hands off for enrollment."
        ],
        voice: "true",
        chat: "false",
        callTitle: "Pre-qualification for Debt Relief Services",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "retell",
        try_speaking: ["I'm an existing client",
          "I got a text about my CareOne account—what should I do?",
          "I’m struggling with $15,000 in credit-card debt—can you help?"
        ],
        activities: [],
        phoneNumber: "070239",
        language: "English",
        default_voiceId: "default",
        voiceConfig: {},
        optional_voices: [
          {
            id: "default",
            name: "Emma",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
            description: "Female Young & Professional",
            language: "English",
            region: ""
          }
        ]
      },
    ]
  },
  Aditya_birla_capital: {
    path: "aditya_birla_capital",
    pageTitle: "Experience Our AI Agents",
    pageCategory: "Aditya Birla Capital",
    agents: [
      {
        id: "d7de52b6-5734-45a6-83ec-6e7ef6655244",
        name: "Loan Qualification Agent",
        description:
          "An advanced outbound personal loan qualification agent from ABCL,  offering personal loans to its customer base.",
        subDescription:
          "An advanced outbound personal loan qualification agent from ABCL,  offering personal loans to its customer base.",
        agentName: "Arjun",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/male1.png",
        chatIcon:
          "https://d3udl6i7sipqjw.cloudfront.net/agent-images/male1.png",
        featureList: ["Personal loan enquiry",
          "Checking eligibility"
        ],
        voice: "true",
        chat: "false",
        callTitle: "Loan Qualification Agent",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        try_speaking: [],
        activities: [],
        phoneNumber: "070239",
        language: "English",
        default_voiceId: "default",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "d7de52b6-5734-45a6-83ec-6e7ef6655244",
          tenant_id: DEFAULT_TENANT_ID,
          workspace_id: DEFAULT_WORKSPACE_ID,
          overide_previous_context: true
        },
        optional_voices: [
          {
            id: "default",
            name: "Arjun",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/male1.png",
            description: "Male Young & Professional",

            language: "English",
            region: ""
          }
        ]
      },
    ]
  },
  TopRankers: {
    path: "toprankers",
    pageTitle: "Experience Our AI Agents",
    pageCategory: "TopRankers",
    agents: [
      {
        id: "afad7b77-8e29-47fe-87ae-fd07fb14634c",
        name: "Customer Support Agent",
        description:
          "Help students and parents understand everything related to IPMAT & BBA entrance exam coaching, especially the courses and mentorship programs offered by TopRankers.",
        subDescription:
          "Help students and parents understand everything related to IPMAT & BBA entrance exam coaching, especially the courses and mentorship programs offered by TopRankers.",
        agentName: "Mira",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        chatIcon:
          "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        featureList: ["Personalized Course Recommendations Based on Year & Mode",
          "Smooth WhatsApp Follow-up & Enrollment Support"
        ],
        voice: "true",
        chat: "false",
        callTitle: "Customer Support Agent",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        try_speaking: ["I wish to understand more about IPMAT?", "अगर मैं Live Class Miss कर दूं तो क्या होगा?"],
        activities: [],
        phoneNumber: "070239",
        language: "Hinglish",
        default_voiceId: "default",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "afad7b77-8e29-47fe-87ae-fd07fb14634c",
          tenant_id: DEFAULT_TENANT_ID,
          workspace_id: DEFAULT_WORKSPACE_ID,
          overide_previous_context: true
        },
        optional_voices: [
          {
            id: "default",
            name: "Mira",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
            description: "Female Young & Professional",
            language: "Hinglish",
            region: ""
          }
        ]
      },
    ]
  },

  Orchid_school: {
    path: "orchid-intl-school",
    pageTitle: "Experience Our Voice AI Agents",
    pageCategory: "Orchid International School",
    agents: [
      {
        id: "ee805971-5077-4ca5-b66a-2f1fda5b8ccd",
        name: "Customer Support Rep",
        description:
          "A friendly assistant dedicated to helping Orchid Intl School's parents and students with everything from admissions to campus life, academic support, and resources.",
        subDescription: "A friendly assistant dedicated to helping Orchid Intl School's parents and students with everything from admissions to campus life, academic support, and resources.",
        agentName: "Priya",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        chatIcon:
          "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        featureList: ["Assits with Admission queries.",
          "Fee Related Queries.",
          "Schedules school visits."
        ],
        voice: "true",
        chat: "false",
        callTitle: "Customer Support Rep",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "retell",
        try_speaking: ["How can my son apply for admission at Orchid?",
          "What’s the fee structure for Grade 6?",
          "How do I sign up for the school bus?"
        ],
        activities: [],
        phoneNumber: "070239",
        language: "English",
        default_voiceId: "default",
        voiceConfig: {},
        optional_voices: [
          {
            id: "default",
            name: "Priya",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
            description: "Female Young & Professional",
            language: "English",
            region: ""
          }
        ]
      },
    ]
  },
  cult_chat: {
    path: "cult-chat",
    pageTitle: "Experience Our AI Agents",
    pageCategory: "Cult Chat",
    agents: [
      {
        id: "c6771eeb-3527-426d-bdd0-71cb36a67ec0",
        name: "Weekly Pulse Chat Agent",
        description:
          "The agent conducts a brief, structured weekly check-in with center managers to gather updates on highlights, challenges, operations, and feedback, ensuring timely support and recognition.",
        subDescription:
          "The agent conducts a brief, structured weekly check-in with center managers to gather updates on highlights, challenges, operations, and feedback, ensuring timely support and recognition.",
        agentName: "Aditi",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female2.png",
        chatIcon:
          "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female2.png",
        featureList: ["Captures weekly highlights and key achievements",
          "Assesses team morale and operational issues",
          "Identifies staff recognition and success stories",
          "Collects feedback for continuous improvements"
        ],
        voice: "true",
        chat: "false",
        callTitle: "Weekly Pulse Chat Agent",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        try_speaking: [],
        activities: [],
        phoneNumber: "070239",
        language: "English & Hindi",
        default_voiceId: "default",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "c6771eeb-3527-426d-bdd0-71cb36a67ec0",
          tenant_id: DEFAULT_TENANT_ID,
          workspace_id: DEFAULT_WORKSPACE_ID,
          overide_previous_context: true
        },
        optional_voices: [
          {
            id: "default",
            name: "Aditi",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female2.png",
            description: "Female Young & Professional",
            language: "English & Hindi",
            region: ""
          }
        ]
      },
    ]
  },
  BrightWheel: {
    path: "brightwheel",
    pageTitle: "Experience Our Voice AI Agents",
    pageCategory: "BrightWheel",
    agents: [
      {
        id: "b109d582-8041-460e-896b-7864b6adde98",
        name: "Lead Qualification Agent",
        description: "Lead qualification based on predefined criteria and seamlessly hand off qualified prospects by scheduling appointments with an account executive for further engagement.",
        subDescription: "Lead qualification based on predefined criteria and seamlessly hand off qualified prospects by scheduling appointments with an account executive for further engagement.",
        agentName: "Olivia",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        chatIcon:
          "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        featureList: ["Qualifies leads by identifying role, program type, and enrollment size to assess Brightwheel fit.", "Schedules demos and shares key platform features tailored to the user's needs.", "Answers common questions, provides follow-up via email or text, and supports next-step onboarding"],
        voice: "true",
        chat: "false",

        callTitle: "Lead Qualification Agent",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "retell",
        try_speaking: ["How does Brightwheel handle tuition invoicing and autopay?", "Is my data safe and compliant with regulations?", "Can you schedule my demo right now?"],
        activities: [],
        phoneNumber: "070239",
        language: "English",
        default_voiceId: "default",
        voiceConfig: {},
        optional_voices: [
          {
            id: "default",
            name: "Olivia",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
            description: "Female Young & Professional",
            language: "English",
            region: ""
          }
        ]
      },
    ]
  },
  LibertyMutual: {
    path: "liberty-mutual",
    pageTitle: "Experience Our Voice AI Agents",
    pageCategory: "Liberty Mutual",
    agents: [
      {
        id: "4b0bb552-cd4c-4673-8860-0bdf89b3a8d0",
        name: "Customer Support Agent",
        description: "A warm, conversational support rep named Doug who helps Liberty Mutual Insurance customers with quick, friendly answers about policies, billing & claims.",
        subDescription: "A warm, conversational support rep named Doug who helps Liberty Mutual Insurance customers with quick, friendly answers about policies, billing & claims.",
        agentName: "Doug",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/male1.png",
        chatIcon:
          "https://d3udl6i7sipqjw.cloudfront.net/agent-images/male1.png",
        featureList: ["Handles policy and coverage questions", "Schedules demos and shares key platform features.", "Billing and payment queries", "Guides claims filing and status checks"],
        voice: "true",
        chat: "false",

        callTitle: "Customer Support Agent",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "retell",
        try_speaking: ["How do I file an auto claim with Liberty Mutual?", "What discounts can I get for bundling home and auto?", "Can you help me update the beneficiary on my life policy?"],
        activities: [],
        phoneNumber: "070239",
        language: "English",
        default_voiceId: "default",
        voiceConfig: {},
        optional_voices: [
          {
            id: "default",
            name: "Doug",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/male1.png",
            description: "Female Young & Professional",
            language: "English",
            region: ""
          }
        ]
      },
    ]
  },
  Churchill: {
    path: "Churchill",
    pageTitle: "Experience Our Voice AI Agents",
    pageCategory: "Churchill",
    agents: [
      {
        id: "1042bfcb-ad20-496f-99ea-4de1b8ebe88f",
        name: "Appointment Booking Agent",
        description: "The agent from Churchill Mortgage helps eligible customers schedule their Annual Mortgage Review",
        subDescription: "The agent from Churchill Mortgage helps eligible customers schedule their Annual Mortgage Review",
        agentName: "Erica",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        chatIcon:
          "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        featureList: ["Compares customer interest rate against fixed rate", "Checks for loan anniversary matches based on today’s date", "Schedules callback appointments with Churchill representatives"],
        voice: "true",
        chat: "false",

        callTitle: "Appointment Booking Agent",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "retell",
        try_speaking: [],
        activities: ["Checks eligibility based on interest rate and loan anniversary.", "Books appointments with Churchill representatives."],
        phoneNumber: "070239",
        language: "English",
        default_voiceId: "default",
        voiceConfig: {},
        optional_voices: [
          {
            id: "default",
            name: "Erica",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
            description: "Female Young & Professional",
            language: "English",
            region: ""
          }
        ]
      },
    ]
  },
  TopRankers2: {
    path: "toprankers2",
    pageTitle: "Experience Our AI Agents",
    pageCategory: "TopRankers",
    agents: [
      {
        id: "c81c555f-4a85-4652-8a98-9c991e882324",
        name: "Customer Support Agent",
        description:
          "Help students and parents understand everything related to IPMAT & BBA entrance exam coaching, especially the courses and mentorship programs offered by TopRankers.",
        subDescription:
          "Help students and parents understand everything related to IPMAT & BBA entrance exam coaching, especially the courses and mentorship programs offered by TopRankers.",
        agentName: "Mira",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        chatIcon:
          "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        featureList: ["Personalized Course Recommendations Based on Year & Mode",
          "Smooth WhatsApp Follow-up & Enrollment Support"
        ],
        voice: "true",
        chat: "false",
        callTitle: "Customer Support Agent",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        try_speaking: ["I wish to understand more about IPMAT?", "अगर मैं Live Class Miss कर दूं तो क्या होगा?"],
        activities: [],
        phoneNumber: "070239",
        language: "Hinglish",
        default_voiceId: "default",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "c81c555f-4a85-4652-8a98-9c991e882324",
          tenant_id: DEFAULT_TENANT_ID,
          workspace_id: DEFAULT_WORKSPACE_ID,
          overide_previous_context: true
        },
        optional_voices: [
          {
            id: "default",
            name: "Mira",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
            description: "Female Young & Professional",
            language: "Hinglish",
            region: ""
          }
        ]
      },
    ]
  },
  MarshAffinity: {
    path: "marsh-affinity",
    pageTitle: "Experience Our Voice AI Agents",
    pageCategory: "Marsh Affinity",
    agents: [
      {
        id: "4f2ceba4-b58b-4315-a1d0-f5da9b6c9d31",
        name: "Customer Support Agent",
        description: "A warm, calm voice representative named Susan who guides Callers through FNOL Claims, Policy Information, Billing Status and more.",
        subDescription: "A warm, calm voice representative named Susan who guides Callers through FNOL Claims, Policy Information, Billing Status and more.",
        agentName: "Susan",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        chatIcon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        featureList: [
          "Helps with initiating Claims",
          "Provides Policy Information",
          "Provides Billing Status",
          "Provides Certificates of Insurance"
        ],
        voice: "true",
        chat: "false",
        callTitle: "Customer Support Agent",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "retell",
        try_speaking: [
          "Hey, I need help with initiating a claim?",
          "Could you help me understand my policy coverage?",
          "How much of my family deductible is still unpaid this year?"
        ],
        activities: [
          "Assists with FNOL and claim filing",
          "Provides policy and billing information",
          "Guides on insurance certificates and deductible status"
        ],
        phoneNumber: "070239",
        language: "English",
        default_voiceId: "default",
        voiceConfig: {},
        optional_voices: [
          {
            id: "default",
            name: "Susan",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
            description: "Female Warm & Calm",
            language: "English",
            region: ""
          }
        ]
      }
    ]
  },
  LyraCollective: {
    path: "lyra_collective",
    pageTitle: "Experience Our Voice AI Agents",
    pageCategory: "Lyra Collective",
    agents: [
      {
        id: "4e8678a8-7677-44a4-8408-1da1c70a3ce3",
        name: "Sales Agent",
        description: "Sales (to office managers, procurement team of large venues, etc.) for Lola - Women’s health and hygiene company.",
        subDescription: "Sales (to office managers, procurement team of large venues, etc.) for Lola - Women’s health and hygiene company.",
        agentName: "Luna",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        chatIcon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        featureList: [
          "Qualifies B2B leads",
          "Captures required order volumes",
          "Answers all product queries"
        ],
        voice: "true",
        chat: "false",
        callTitle: "Sales Agent",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "retell",
        try_speaking: [],
        activities: [],
        phoneNumber: "070239",
        language: "English",
        default_voiceId: "default",
        voiceConfig: {},
        optional_voices: [
          {
            id: "default",
            name: "Luna",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
            description: "Female Confident & Persuasive",
            language: "English",
            region: ""
          }
        ]
      }
    ]
  },
  ShivNadarUniversity: {
    path: "shiv-nadar",
    pageTitle: "Experience Our Voice AI Agents",
    pageCategory: "Shiv Nadar University",
    agents: [
      {
        id: "b4c6af67-8ea7-43f3-9f53-b2868a9e0603",
        name: "FAQs Agent",
        description: "A friendly, well-informed agent who helps students and parents navigate Shiv Nadar University admissions, academics, and campus life.",
        subDescription: "A friendly, well-informed agent who helps students and parents navigate Shiv Nadar University admissions, academics, and campus life.",
        agentName: "Priya",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        chatIcon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        featureList: [
          "Answers admissions, scholarships, fees, and academics queries.",
          "Explains hostel life, course structure"
        ],
        voice: "true",
        chat: "false",
        callTitle: "FAQs Agent",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "retell",
        try_speaking: [
          "Can you walk me through the admission process for B.Tech?",
          "What kind of scholarships does Shiv Nadar University offer?",
          "Is hostel accommodation compulsory for undergraduates?"
        ],
        activities: [
          "Guides through admission process and requirements",
          "Explains available scholarships and eligibility",
          "Answers common queries about hostel life and academics"
        ],
        phoneNumber: "070239",
        language: "English (with Indian Accent)",
        default_voiceId: "default",
        voiceConfig: {},
        optional_voices: [
          {
            id: "default",
            name: "Priya",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
            description: "Female Friendly & Informed",
            language: "English (with Indian Accent)",
            region: ""
          }
        ]
      }
    ]
  },
  SkillForge: {
    path: "skillforge",
    pageTitle: "Experience Our Voice AI Agents",
    pageCategory: "SkillForge",
    agents: [
      {
        id: "4ce79a84-edb4-4fa6-8eb8-11cdc3fa311d",
        name: "Counselling Agent",
        description: "Help students and understand everything related to courses offered by SkillForge",
        subDescription: "Help students and understand everything related to courses offered by SkillForge",
        agentName: "Mira",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        chatIcon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        featureList: [
          "Suggests the most suitable bootcamps based on the learner’s educational background", "Delivers personalized career guidance tailored to individual goals", "Proactively follows up with learners to ensure timely support and engagement"
        ],
        voice: "true",
        chat: "false",
        callTitle: "Counselling Agent",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        try_speaking: [
          "What is the need of Upscaling my career?",
          "आप placement में मदद करते हैं क्या?"
        ],
        activities: [],
        phoneNumber: "070239",
        language: "Hinglish",
        default_voiceId: "default",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "4ce79a84-edb4-4fa6-8eb8-11cdc3fa311d",
          tenant_id: DEFAULT_TENANT_ID,
          workspace_id: DEFAULT_WORKSPACE_ID,
          overide_previous_context: true
        },
        optional_voices: [
          {
            id: "default",
            name: "Mira",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
            description: "Female Friendly & Motivational",
            language: "Hinglish",
            region: ""
          }
        ]
      }
    ]
  },
  Churchill2: {
    path: "churchill-new",
    pageTitle: "Experience our Voice AI Agents",
    pageCategory: "Churchill",
    agents: [
      {
        id: "74bfc50a-c7f8-421a-89e6-04a79423192f",
        name: "Mortgage Review Agent",
        description:
          "The agent from Churchill Mortgage helps eligible customers schedule their Annual Mortgage Review",
        subDescription: "The agent from Churchill Mortgage helps eligible customers schedule their Annual Mortgage Review",
        agentName: "Erica",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female3.png",
        chatIcon:
          "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female3.png",
        featureList: [
          "Compares customer interest rate against fixed rate",
          "Checks for loan anniversary matches based on today’s date",
          "Schedules callback appointments with Churchill representatives"
        ],
        voice: "true",
        chat: "false",
        callTitle: "Mortgage Review Agent",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "retell",
        try_speaking: [],
        activities: [
          "Checks eligibility based on interest rate and loan anniversary.",
          "Books appointments with Churchill representatives."
        ],
        phoneNumber: "070239",
        language: "English",
        default_voiceId: "default",
        voiceConfig: {},
        optional_voices: [
          {
            id: "default",
            name: "Erica",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female3.png",
            description: "Female Young & Professional",
            language: "English",
            region: ""
          }
        ]
      }
    ]
  },
  MyCaptain: {
    path: "mycaptain",
    pageTitle: "Experience Our Voice AI Agents",
    pageCategory: "MyCaptain",
    agents: [
      {
        id: "02eef198-84c8-447f-af9c-43ba4c46fec5",
        name: "Lead Qualification Agent",
        description: "Help students and understand everything related to the UI/UX Design Pro Course on Mycaptain",
        subDescription: "Help students and understand everything related to the UI/UX Design Pro Course on Mycaptain",
        agentName: "Mira",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        chatIcon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        featureList: [
          "Provides detailed insights into the features of both Graduate and Advanced versions of the courses.",
          "Provides Guidance about the diverse range of hiring partners associated with the program."
        ],
        voice: "true",
        chat: "false",
        callTitle: "Lead Qualification Agent",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        try_speaking: [
          "What are the specialities of the Advanced Design Strategy Program ?",
          "Mujhe MyCaption Scholarship Test ke baare mein batao?"
        ],
        activities: [],
        phoneNumber: "070239",
        language: "Hinglish",
        default_voiceId: "default",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "02eef198-84c8-447f-af9c-43ba4c46fec5",
          tenant_id: DEFAULT_TENANT_ID,
          workspace_id: DEFAULT_WORKSPACE_ID,
          overide_previous_context: true
        },
        optional_voices: [
          {
            id: "default",
            name: "Mira",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
            description: "Female Friendly & Motivational",
            language: "Hinglish",
            region: ""
          }
        ]
      }
    ]
  },
  PhysicsWallah: {
    path: "physicswallah",
    pageTitle: "Experience Our Voice AI Agents",
    pageCategory: "PhysicsWallah",
    agents: [
      {
        id: "194e7870-bcb1-42ef-a93b-051339e92105",
        name: "Counselling Agent",
        description: "Help students and understand everything related to the Prayaas 3.0 Batch for Droppers offered by PhysicsWallah",
        subDescription: "Help students and understand everything related to the Prayaas 3.0 Batch for Droppers offered by PhysicsWallah",
        agentName: "Mira",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        chatIcon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        featureList: [
          "Offers Personalised Guidance for JEE Droppers",
          "Provides Detailed Counselling for JEE Mains"
        ],
        voice: "true",
        chat: "false",
        callTitle: "Counselling Agent",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        try_speaking: [
          "Kya mentorship ka provision hai?",
          "What if I miss a live class?"
        ],
        activities: [],
        phoneNumber: "070239",
        language: "Hinglish",
        default_voiceId: "default",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "194e7870-bcb1-42ef-a93b-051339e92105",
          tenant_id: DEFAULT_TENANT_ID,
          workspace_id: DEFAULT_WORKSPACE_ID,
          overide_previous_context: true
        },
        optional_voices: [
          {
            id: "default",
            name: "Mira",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
            description: "Female Friendly & Motivational",
            language: "Hinglish",
            region: ""
          }
        ]
      }
    ]
  },
  AmityUniversity: {
    path: "amityuniversity",
    pageTitle: "Experience Our Voice AI Agents",
    pageCategory: "Amity University",
    agents: [
      {
        id: "7a90294c-c295-414c-a9e5-ad8cbd71fb2d",
        name: "Counselling Agent",
        description: "Help students and understand everything related to the MCA Course in Cybersecurity provided by Amity University",
        subDescription: "Help students and understand everything related to the MCA Course in Cybersecurity provided by Amity University",
        agentName: "Mira",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        chatIcon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        featureList: [
          "Provides in depth information about the features of the MCA Course in Cyber Security by Amity University",
          "Offers personalised career support for students"
        ],
        voice: "true",
        chat: "false",
        callTitle: "Counselling Agent",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        try_speaking: [
          "Kya offline campus access milta hai?",
          "Do you offer placement assistance?"
        ],
        activities: [],
        phoneNumber: "070239",
        language: "Hinglish",
        default_voiceId: "default",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "7a90294c-c295-414c-a9e5-ad8cbd71fb2d",
          tenant_id: DEFAULT_TENANT_ID,
          workspace_id: DEFAULT_WORKSPACE_ID,
          overide_previous_context: true
        },
        optional_voices: [
          {
            id: "default",
            name: "Mira",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
            description: "Female Friendly & Motivational",
            language: "Hinglish",
            region: ""
          }
        ]
      }
    ]
  },
  PlaytoLabs: {
    path: "Playto-labs",
    pageTitle: "Experience Our Voice AI Agents",
    pageCategory: "Playto Labs",
    agents: [
      {
        id: "aecf4511-13da-4272-956b-b2a43c2dbccb",
        name: "Lead Qualification",
        description: "Provides in Depth Information about the Online Coding Classes provided by Playto Labs",
        subDescription: "Provides in Depth Information about the Online Coding Classes provided by Playto Labs",
        agentName: "Neha",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        chatIcon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        featureList: [
          "Clearly explain what’s included in the coding curriculum, how the 1 - on - 1 live sessions are conducted, and what projects kids will create at each skill level.",
          "Assist with scheduling or expressing interest in a free 1-on - 1 coding trial class for your child."
        ],
        voice: "true",
        chat: "false",
        callTitle: "Lead Qualification Agent",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        try_speaking: [
          "Free trial class kaise book karte hain ?",
          "Will a course completion certificate be provided for kids ?"
        ],
        activities: [],
        phoneNumber: "070239",
        language: "Hinglish",
        default_voiceId: "default",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "e5df78ba-5aba-4cdf-8984-459ec4a031e9",
          tenant_id: DEFAULT_TENANT_ID,
          workspace_id: DEFAULT_WORKSPACE_ID,
          overide_previous_context: true
        },
        optional_voices: [
          {
            id: "default",
            name: "Neha",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
            description: "Female Young & Professional",
            language: "Hinglish",
            region: ""
          }
        ]
      }
    ]
  },
  MutualOfOmaha: {
    path: "mutualofomaha",
    pageTitle: "Experience Our Voice AI Agents",
    pageCategory: "Mutual Of Omaha",
    agents: [
      {
        id: "99dc8ecf-f311-4fc1-a7f0-e72afe14fa56",
        name: "Customer Support Agent",
        description: "Ensures that customers have a smooth experience while enquiring about the services offered by Mutual of Omaha",
        subDescription: "Ensures that customers have a smooth experience while enquiring about the services offered by Mutual of Omaha",
        agentName: "Marissa",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        chatIcon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        featureList: [
          "Provides in depth information for all the services provided by Mutual of Omaha",
          "Answers FAQ"
        ],
        voice: "true",
        chat: "false",
        callTitle: "Customer Support Agent",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "retell",
        try_speaking: [
          "I need help to access my account",
          "Can you connect me to a licensed agent?"
        ],
        activities: [],
        phoneNumber: "070239",
        language: "English",
        default_voiceId: "default",
        voiceConfig: {
        },
        optional_voices: [
          {
            id: "default",
            name: "Marissa",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
            description: "Female Reassuring & Clear",
            language: "English",
            region: ""
          }
        ]
      }
    ]
  },
  NurixInsurance: {
    path: "nurix-insurance",
    pageTitle: "Experience Our Voice AI Agents",
    pageCategory: "Nuplay Insurance",
    agents: [
      {
        id: "d35d5463-7001-4cb4-bebb-6b9289867795",
        name: "Auto Sales Qualification - Video Only",
        description: "An agent from Nuplay Auto Insurance who provides personalized quotes and helps customers choose the best coverage options.",
        subDescription: "An agent from Nuplay Auto Insurance who provides personalized quotes and helps customers choose the best coverage options.",
        agentName: "Marissa",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        chatIcon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        featureList: [
          "Gather insurance preferences and driver history",
          "Provide personalized quote scheduling",
          "Capture and confirm policy details"
        ],
        voice: "true",
        chat: "false",
        callTitle: "Auto Sales Qualification - Video Only",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "retell",
        try_speaking: [],
        activities: [
          "Confirm current insurer and driving history",
          "Identify coverage priorities",
          "Schedule follow-up with licensed insurance agent"
        ],
        phoneNumber: "070239",
        language: "English",
        default_voiceId: "default",
        voiceConfig: {},
        optional_voices: [
          {
            id: "default",
            name: "Marissa",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
            description: "Female Professional & Clear",
            language: "English",
            region: ""
          }
        ]
      }
    ]
  },
  HOAB2L: {
    path: "hoabl-new",
    pageTitle: "Experience our Voice AI Agents",
    pageCategory: "HOABL",
    agents: [
      {
        id: "66b376ba-c32c-48c8-9205-0a58660c3c58",
        name: "Sales",
        description:
          "To get insights from people prior to launch",
        subDescription: "Voice: Excited, Patient",
        agentName: "Priya",
        icon: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face",
        chatIcon:
          "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face",
        featureList: [
          "Register RSA request",
          "Verify customer identity",
          "Capture incident details and initiate assistance"
        ],
        voice: "true",
        chat: "false",
        callTitle: "Sales Agent",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        try_speaking: [],
        activities: [],
        phoneNumber: "070239",
        language: "Hinglish",
        default_voiceId: "default",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "66b376ba-c32c-48c8-9205-0a58660c3c58",
          overide_previous_context: true,
          custom_data: {},
          tenant_id: DEFAULT_TENANT_ID,
          workspace_id: DEFAULT_WORKSPACE_ID
        },
        optional_voices: [
          {
            id: "default",
            name: "Priya",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
            description: "Female Young & Professional",
            language: "Hinglish",
            region: ""
          }
        ]
      }
    ]
  },
  TopRankersRecovery: {
    path: "toprankersrecovery",
    pageTitle: "Experience Our Voice AI Agents",
    pageCategory: "TopRankers",
    agents: [
      {
        id: "b70f01ac-8cc6-4b39-bd6b-ce054b1f17f9",
        name: "Recovery Agent",
        description: "Reminds subscriber to pay their due installment for active subscription.",
        subDescription: "Reminds subscriber to pay their due installment for active subscription.",
        agentName: "Priya",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        chatIcon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        featureList: [
          "Provides a WhatsApp link to facilitate EMI collection.",
          "Offers flexible date selection for EMI payments."
        ],
        voice: "true",
        chat: "false",
        callTitle: "Recovery Agent",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        try_speaking: [
          "Can you send me the Whatsapp link for payment?",
          "Main abhi payment nahi kar paunga."
        ],
        activities: [],
        phoneNumber: "070239",
        language: "Hinglish",
        default_voiceId: "default",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "b70f01ac-8cc6-4b39-bd6b-ce054b1f17f9",
          tenant_id: DEFAULT_TENANT_ID,
          workspace_id: DEFAULT_WORKSPACE_ID,
          overide_previous_context: true
        },
        optional_voices: [
          {
            id: "default",
            name: "Priya",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
            description: "Female Empathetic & Persuasive",
            language: "Hinglish",
            region: ""
          }
        ]
      }
    ]
  },
  NurixDebtCollection: {
    path: "nurixdebtcollection",
    pageTitle: "Experience Our Voice AI Agents",
    pageCategory: "Nuplay",
    agents: [
      {
        id: "f408ab5b-ea26-42ec-b311-f86f4ff5e9ec",
        name: "Debt Collection Agent",
        description: "Remind Users to Pay Overdue",
        subDescription: "Remind Users to Pay Overdue",
        agentName: "Raj",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/male2.png",
        chatIcon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/male2.png",
        featureList: [
          "Optimal Debt Resolution Strategies",
          "Reminds User to Pay Overdue"
        ],
        voice: "true",
        chat: "false",
        callTitle: "Debt Collection Agent",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        try_speaking: [
          "I cannot pay you right now.",
          "kya aap mujhe call kar sakte ho?"
        ],
        activities: [],
        phoneNumber: "070239",
        language: "Hinglish",
        default_voiceId: "default",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "f408ab5b-ea26-42ec-b311-f86f4ff5e9ec",
          tenant_id: DEFAULT_TENANT_ID,
          workspace_id: DEFAULT_WORKSPACE_ID,
          overide_previous_context: true
        },
        optional_voices: [
          {
            id: "default",
            name: "Raj",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/male2.png",
            description: "Male Calm & Assertive",
            language: "Hinglish",
            region: ""
          }
        ]
      }
    ]
  },
  Realtor: {
    path: "realtor",
    pageTitle: "Experience Our AI Agents",
    pageCategory: "Realtor",
    agents: [
      {
        id: "8eb4f684-69f7-4f0a-a610-57e6342767b1",
        name: "Real Estate Support Agent",
        agentName: "Sarah",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female1.png",
        chatIcon:
          "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female1.png",
        featureList: [
          "FAQ agent"
        ],
        description:
          "A Customer Support Voice Agent for Realtor.com that handles inbound calls, answers property and account-related queries, guides users on platform navigation, and escalates complex issues to human agents when needed.",
        subDescription: "A Customer Support Voice Agent for Realtor.com that handles inbound calls, answers property and account-related queries, guides users on platform navigation, and escalates complex issues to human agents when needed.",
        voice: "true",

        chat: "false",
        chatHints: [],
        callHints: [],
        callHintsTable: [],
        try_speaking: [],
        default_voiceId: "default",
        optional_voices: [
          {
            id: "default",
            name: "Sarah",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female1.png",
            description: "Female Young & Professional",
            language: "English",
            region: ""
          }
        ],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {},
        activities: []
      },
      {
        id: "fa441586-b41e-4756-abd5-f4435a8f126d",
        name: "Lead Qualification Agent",
        agentName: "Barbara",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female3.png",
        chatIcon:
          "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female3.png",
        featureList: [
          "Gather essential information",
          "Screen potential clients"
        ],
        description:
          "A Lead Qualification Voice Agent that engages inbound leads, gathers essential information, screens potential clients based on predefined criteria, and routes qualified prospects to the sales team for follow-up.",
        subDescription: "A Lead Qualification Voice Agent that engages inbound leads, gathers essential information, screens potential clients based on predefined criteria, and routes qualified prospects to the sales team for follow-up.",
        voice: "true",

        chat: "false",
        chatHints: [],
        callHints: [],
        callHintsTable: [],
        try_speaking: [],
        default_voiceId: "default",
        optional_voices: [
          {
            id: "default",
            name: "Barbara",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female3.png",
            description: "Female Young & Professional",
            language: "English",
            region: ""
          }
        ],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {},
        activities: []
      },
    ]
  },
  NurixBankDebt: {
    path: "nurix-bank-debt",
    pageTitle: "Experience Our Banking Agents ",
    pageCategory: "NuplayBank Debt",
    agents: [
      {
        id: "ca04adb8-911f-4552-a4cf-2777bb8774f9",
        name: "Debt Collection Agent",
        agentName: "Maria",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female1.png",
        chatIcon:
          "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female1.png",
        featureList: ["Optimal Debt Resolution Strategies",
          "Reminds User to Pay Overdue"],
        description:
          "Reminds User to Pay Overdue",
        subDescription: "Reminds User to Pay Overdue",
        voice: "true",
        chat: "false",
        chatHints: [],
        callHints: [
          "Name of User : Mr Robin Smith",
          "Social Security Code : 3456",
          "Date of Birth : 2nd Jan 1998"
        ],
        callHintsTable: [],
        try_speaking: [
          "I can't pay in 10 months, could you please share another plan ?",
          "I cannot share my Social Security Number."
        ],
        default_voiceId: "default",
        optional_voices: [
          {
            id: "default",
            name: "Maria",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female1.png",
            description: "Female Young & Professional",
            language: "English",
            region: ""
          }
        ],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {},
        activities: []
      }
    ]
  },
  thabl: {
    path: "thabl",
    pageTitle: "Experience our Voice Agents",
    pageCategory: "Chick-Fil-A",
    agents: [
      {
        id: "43b3c63b-62a7-4a83-ad3b-f533411da170",
        name: "Hinglish Demo",
        description: "A support agent that greets callers, verifies identity, then logs, escalates, or fulfills service/installation and fee‑waiver requests—while calming frustrated customers and owning the case",
        subDescription: "A support agent that greets callers, verifies identity, then logs, escalates, or fulfills service/installation and fee‑waiver requests—while calming frustrated customers and owning the case",
        agentName: "Rahul",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        chatIcon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        featureList: [
          "Emotion-aware de‑escalation",
          "Identifies the type of complaint and proceeds accordingly"
        ],
        voice: "true",
        chat: "false",
        callTitle: "Hinglish Demo",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        try_speaking: [
          "मैंने नया water purifier खरीदा है, installation चाहिए।",
          "आपने टिकट बंद कर दिया, लेकिन समस्या अभी भी है।"
        ],
        activities: [],
        phoneNumber: "070239",
        language: "Hinglish",
        default_voiceId: "default",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "43b3c63b-62a7-4a83-ad3b-f533411da170",
          tenant_id: "122f0f76-f68c-4cee-a115-94a82b870890",
          workspace_id: "122f0f76-f68c-4cee-a115-94a82b870890",
          overide_previous_context: true
        },
        optional_voices: [
          {
            id: "default",
            name: "Rahul",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
            description: "Male Calm & Reassuring",
            language: "Hinglish",
            region: ""
          }
        ]
      }
    ]
  },
  xanadu: {
    path: "xanadu",
    pageTitle: "Experience our Voice Agents",
    pageCategory: "Chick-Fil-A",
    agents: [
      {
        id: "43b3c63b-62a7-4a83-ad3b-f533411da170",
        name: "Hinglish Demo",
        description: "A support agent that greets callers, verifies identity, then logs, escalates, or fulfills service/installation and fee‑waiver requests—while calming frustrated customers and owning the case",
        subDescription: "A support agent that greets callers, verifies identity, then logs, escalates, or fulfills service/installation and fee‑waiver requests—while calming frustrated customers and owning the case",
        agentName: "Rahul",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        chatIcon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        featureList: [
          "Emotion-aware de‑escalation",
          "Identifies the type of complaint and proceeds accordingly"
        ],
        voice: "true",
        chat: "false",
        callTitle: "Hinglish Demo",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        try_speaking: [
          "मैंने नया water purifier खरीदा है, installation चाहिए।",
          "आपने टिकट बंद कर दिया, लेकिन समस्या अभी भी है।"
        ],
        activities: [],
        phoneNumber: "070239",
        language: "Hinglish",
        default_voiceId: "default",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "43b3c63b-62a7-4a83-ad3b-f533411da170",
          tenant_id: "122f0f76-f68c-4cee-a115-94a82b870890",
          workspace_id: "122f0f76-f68c-4cee-a115-94a82b870890",
          overide_previous_context: true
        },
        optional_voices: [
          {
            id: "default",
            name: "Rahul",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
            description: "Male Calm & Reassuring",
            language: "Hinglish",
            region: ""
          }
        ]
      }
    ]
  },
  VGuard2: {
    path: "v-guard",
    pageTitle: "Experience Our Voice AI Agents",
    pageCategory: "V-Guard",
    agents: [
      {
        id: "b12cf1d4-49fc-4f9f-95b8-09a3c6665d5e",
        name: "Hinglish Demo",
        description: "A support agent that greets callers and verifies their identity then either logs or escalates service/installation and fee‑waiver requests—while calming frustrated customers and owning the case.",
        subDescription: "A support agent that greets callers and verifies their identity then either logs or escalates service/installation and fee‑waiver requests—while calming frustrated customers and owning the case.",
        agentName: "Rahul",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/male2.png",
        chatIcon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/male2.png",
        featureList: [
          "Emotion-aware de‑escalation",
          "Identifies the type of complaint and proceeds accordingly"
        ],
        voice: "true",
        chat: "false",
        callTitle: "Customer Support Agent",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        try_speaking: [
          "मैंने नया water purifier खरीदा है, installation चाहिए।",
          "आपने टिकट बंद कर दिया, लेकिन समस्या अभी भी है।"
        ],
        activities: [],
        phoneNumber: "070239",
        language: "Hinglish",
        default_voiceId: "default",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "b12cf1d4-49fc-4f9f-95b8-09a3c6665d5e",
          tenant_id: DEFAULT_TENANT_ID,
          workspace_id: DEFAULT_WORKSPACE_ID,
          overide_previous_context: true
        },
        optional_voices: [
          {
            id: "default",
            name: "Rahul",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/male2.png",
            description: "Male Calm & Reassuring",
            language: "Hinglish",
            region: ""
          }
        ]
      }
    ]
  },
  Tutorials: {
    path: "tutorials",
    pageTitle: "Experience Our Voice AI Agents",
    pageCategory: "TutorialsPoint",
    agents: [
      {
        id: "aa643cc1-9e73-4bfa-b50a-56808b9d7f29",
        name: "Lead Qualification Agent",
        description: "Provides In depth information about the Python Programming Certification offered by TutorialsPoint",
        subDescription: "Provides In depth information about the Python Programming Certification offered by TutorialsPoint",
        agentName: "Meera",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        chatIcon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        featureList: [
          "Outlines the scope of Python Programming in the future.",
          "Provides the overview of the course curriculum of the course."
        ],
        voice: "true",
        chat: "false",
        callTitle: "Lead Qualification Agent",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        try_speaking: [
          "Kya aapka course beginner friendly hai? .",
          "Can you send me a summary of the course curriculum on my Whatsapp Number?"
        ],
        activities: [],
        phoneNumber: "070239",
        language: "Hinglish",
        default_voiceId: "default",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "aa643cc1-9e73-4bfa-b50a-56808b9d7f29",
          tenant_id: DEFAULT_TENANT_ID,
          workspace_id: DEFAULT_WORKSPACE_ID,
          overide_previous_context: true
        },
        optional_voices: [
          {
            id: "default",
            name: "Meera",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
            description: "Female Friendly & Instructive",
            language: "Hinglish",
            region: ""
          }
        ]
      }
    ]
  },
  GSG2: {
    path: "GSG",
    pageTitle: "Experience Our Voice AI Agents",
    pageCategory: "GSG",
    agents: [
      {
        id: "8f4659b6-e1f3-4153-a4aa-e092485c0d51",
        name: "Sara Outbound",
        description: "An admissions support agent that engages parents after they submit the GIIS contact form, helping schedule campus tours and answer FAQs to ensure a smooth, personalized experience.",
        subDescription: "An admissions support agent that engages parents after they submit the GIIS contact form, helping schedule campus tours and answer FAQs to ensure a smooth, personalized experience.",
        agentName: "Sara Outbound",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        chatIcon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        featureList: [],
        voice: "true",
        chat: "false",
        callTitle: "Admission Enquiry Agent",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        try_speaking: [],
        activities: [],
        phoneNumber: "070239",
        language: "English",
        default_voiceId: "default",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-us"],
          user_id: DEFAULT_USER_ID,
          agent_id: "8f4659b6-e1f3-4153-a4aa-e092485c0d51",
          tenant_id: "b2a880a5-84d8-40f4-9616-5f43ed77d2d4",
          workspace_id: "b2a880a5-84d8-40f4-9616-5f43ed77d2d4",
          overide_previous_context: true
        },
        optional_voices: [
          {
            id: "default",
            name: "Sara",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
            description: "Female Friendly & Instructive",
            language: "English",
            region: ""
          }
        ]
      },
      {
        id: "7655b608-bce3-4f73-9c12-e0562d13cc06",
        name: "Sara Inbound",
        description: "A 24/7 admissions enquiry agent on the GIIS website that instantly assists prospective parents with FAQs on admissions, eligibility, and related queries.",
        subDescription: "A 24/7 admissions enquiry agent on the GIIS website that instantly assists prospective parents with FAQs on admissions, eligibility, and related queries.",
        agentName: "Sara Inbound",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        chatIcon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        featureList: [],
        voice: "true",
        chat: "false",
        callTitle: "Admission Enquiry Agent",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        try_speaking: [],
        activities: [],
        phoneNumber: "070239",
        language: "English",
        default_voiceId: "default",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-us"],
          user_id: DEFAULT_USER_ID,
          agent_id: "7655b608-bce3-4f73-9c12-e0562d13cc06",
          tenant_id: "b2a880a5-84d8-40f4-9616-5f43ed77d2d4",
          workspace_id: "b2a880a5-84d8-40f4-9616-5f43ed77d2d4",
          overide_previous_context: true
        },
        optional_voices: [
          {
            id: "default",
            name: "Sara",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
            description: "Female Friendly & Instructive",
            language: "English",
            region: ""
          }
        ]
      }
    ]
  },
  KnitWell: {
    path: "knitwell",
    pageTitle: "Experience Our AI Agents",
    pageCategory: "Talbots",
    agents: [
      {
        id: "61608973-bcc8-4c8b-b3c5-b225b169f846",
        name: "Talbots - Refund related Support",
        agentName: "James",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/male1.png",
        chatIcon:
          "https://d3udl6i7sipqjw.cloudfront.net/agent-images/male1.png",
        featureList: ["Checks refund status and timelines.",
          "Provides updates on progress",
          "Assists with refund - related delays"],
        description:
          "Talbot's Refund Support Assistant, here to assist with refund-related inquiries. He provides clear, empathetic support for refund status and processing timelines.",
        subDescription: "Talbot's Refund Support Assistant, here to assist with refund-related inquiries. He provides clear, empathetic support for refund status and processing timelines.",
        voice: "true",
        chat: "false",
        chatHints: [],
        callHints: [
          "Order ID : TLB0901A12",
          "Order ID : TLB0901A20",
          "Order ID : TLB0901A21",
        ],
        callTitle: "Refund related Support",
        try_speaking: [
          "Can you check my refund status?",
          "When will my refund be processed?"
        ],
        default_voiceId: "default",
        optional_voices: [
          {
            id: "default",
            name: "James",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/male1.png",
            description: "Male Young & Professional",
            language: "English",
            region: ""
          }
        ],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {},
        activities: []
      }
    ]
  },
  Reskill2: {
    path: "reskill2",
    pageTitle: "Experience Our Voice AI Agents",
    pageCategory: "Reskill",
    agents: [
      {
        id: "6565b0b5-4f97-43fa-b2b7-585df4624983",
        name: "Lead Qualification Agent",
        description: "Provides In depth information about the virtual workshop — 'One Prompt, Many Possibilities: Agent Magic with Azure AI",
        subDescription: "Provides In depth information about the virtual workshop — 'One Prompt, Many Possibilities: Agent Magic with Azure AI",
        agentName: "Meera",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        chatIcon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        featureList: [
          "Outlines the scope of Prompt Engineering in the future.",
          "Details the features of the virtual workshop: One Prompt, Many Possibilities – Agent Magic with Azure AI."
        ],
        voice: "true",
        chat: "false",
        callTitle: "Lead Qualification Agent",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        try_speaking: [
          "Who is the Keynote Speaker?",
          "Iss event ki registration fees kya hai?"
        ],
        activities: [],
        phoneNumber: "070239",
        language: "Hinglish",
        default_voiceId: "default",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "6565b0b5-4f97-43fa-b2b7-585df4624983",
          tenant_id: DEFAULT_TENANT_ID,
          workspace_id: DEFAULT_WORKSPACE_ID,
          overide_previous_context: true
        },
        optional_voices: [
          {
            id: "default",
            name: "Meera",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
            description: "Female Friendly & Instructive",
            language: "Hinglish",
            region: ""
          }
        ]
      }
    ]
  },
  NurixCollectionsAgent: {
    path: "nurix-collections",
    pageTitle: "Experience Our Voice AI Agents",
    pageCategory: "Nuplay Collections Agent",
    agents: [
      {
        id: "65a03fb0-c85a-45e8-ab42-1a50b4977e41",
        name: "Debt Recovery Agent",
        description: "A calm and attentive outbound agent who listens actively and gently reminds customers about payment while maintaining a composed and professional conduct.",
        subDescription: "A calm and attentive outbound agent who listens actively and gently reminds customers about payment while maintaining a composed and professional conduct.",
        agentName: "Raj",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/male2.png",
        chatIcon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/male2.png",
        featureList: [
          "Give appropriate reason for not giving the payment",
          "Identify the user's requirements clearly and accurately."
        ],
        voice: "true",
        chat: "false",
        callTitle: "Debt Recovery Agent",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        try_speaking: [
          "Mujhe bilkul payment nahi karni.",
          "Mujhe yaad nahi ki Maine credit kabh liya tha"
        ],
        activities: [],
        phoneNumber: "070239",
        language: "Hinglish",
        default_voiceId: "default",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "65a03fb0-c85a-45e8-ab42-1a50b4977e41",
          tenant_id: DEFAULT_TENANT_ID,
          workspace_id: DEFAULT_WORKSPACE_ID,
          overide_previous_context: true
        },
        optional_voices: [
          {
            id: "default",
            name: "Raj",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/male2.png",
            description: "Male Calm & Professional",
            language: "Hinglish",
            region: ""
          }
        ]
      }
    ]
  },
  Mortgage: {
    path: "mortgage",
    pageTitle: "Experience Our Voice AI Agents",
    pageCategory: "Nuplay Mortgage",
    agents: [
      {
        id: "29a22b69-d38a-4254-a025-297b966f1116",
        name: "Appointment Booking Agent",
        description: "The agent from Nuplay Mortgage helps eligible customers schedule their Annual Mortgage Review",
        subDescription: "The agent from Nuplay Mortgage helps eligible customers schedule their Annual Mortgage Review",
        agentName: "Erica",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        chatIcon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        featureList: [
          "Compares customer interest rate against fixed rate",
          "Checks for loan anniversary matches based on today’s date",
          "Schedules callback appointments with Nuplay representatives"
        ],
        voice: "true",
        chat: "false",
        callTitle: "Appointment Booking Agent",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "retell",
        try_speaking: [],
        activities: [
          "Checks eligibility based on interest rate and loan anniversary",
          "Books appointments with Nuplay Mortgage representatives"
        ],
        phoneNumber: "070239",
        language: "English",
        default_voiceId: "default",
        voiceConfig: {},
        optional_voices: [
          {
            id: "default",
            name: "Erica",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
            description: "Female Calm & Helpful",
            language: "English",
            region: ""
          }
        ]
      },
      {
        id: "cb1a9af6-ae4b-4403-8fcd-cec7ad2c25ca",
        name: "Lead Qualification Agent",
        description: "The agent from Nuplay Mortgage helps user with the lead qualification related to Nuplay mortgage.",
        subDescription: "The agent from Nuplay Mortgage helps user with the lead qualification related to Nuplay mortgage.",
        agentName: "Nancy",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        chatIcon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        featureList: [
          "Verifies if the inquiry is mortgage or loan-related before proceeding",
          "Checks if the user has previously spoken to a Nuplay Mortgage loan officer",
          "Collects key lead qualification details to connect with a home loan specialist"
        ],
        voice: "true",
        chat: "false",
        callTitle: "Lead Qualification Agent",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "retell",
        try_speaking: [],
        activities: [],
        phoneNumber: "070239",
        language: "English",
        default_voiceId: "default",
        voiceConfig: {},
        optional_voices: [
          {
            id: "default",
            name: "Nancy",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
            description: "Female Professional & Direct",
            language: "English",
            region: ""
          }
        ]
      }
    ]
  },
  BambinosNew: {
    path: "bambinos-new",
    pageTitle: "Experience Our Voice AI Agents",
    pageCategory: "Bambinos",
    agents: [
      {
        id: "82275bcf-1cda-442e-b155-1e07c2224fa2",
        name: "Demo funnel optimisation",
        description: "Meera is a warm, calm and professional agent from Bambinos who helps the people to reconfirm the user details before the scheduled demo session for the courses provided by Bambinos.",
        subDescription: "This agent helps in demo funnel optimisation",
        agentName: "Meera",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        chatIcon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        featureList: [
          "Helps with reconfirming the details",
          "Provides course information if needed",
          "Speaks about the importance of the courses if asked",
          "Addresses the common issues faced by the parents of children",
        ],
        voice: "true",
        chat: "false",
        callTitle: "Demo funnel optimisation  Agent",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        try_speaking: [],
        activities: [],
        phoneNumber: "070239",
        language: "Hinglish",
        default_voiceId: "default",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "82275bcf-1cda-442e-b155-1e07c2224fa2",
          tenant_id: NURIX_TENANT_ID,
          workspace_id: NURIX_WORKSPACE_ID,
          overide_previous_context: true
        },
        optional_voices: [
          {
            id: "default",
            name: "Meera",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
            description: "Female Friendly & Instructive",
            language: "Hinglish",
            region: ""
          }
        ]
      },
      {
        id: "7c31b5cd-3ff7-4435-ad72-ab26eedefdd1",
        name: "Drop-off Recovery",
        description: "Meera is a warm, calm and professional agent from Bambinos who gets in touch with the people who missed their demos and reschedules it for them, based on availability and convenience.",
        subDescription: "This agent helps in drop-off recovery ",
        agentName: "Meera",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female1.png",
        chatIcon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female1.png",
        featureList: [
          "Helps with rescheduing the missed demo",
          "Understands the issues and addresses them accordingly",
          "Speaks about the importance of the courses if asked",
          "Addresses the common issues faced by the parents of children"],
        voice: "true",
        chat: "false",
        callTitle: "Drop-off Recovery agent",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        try_speaking: [],
        activities: [],
        phoneNumber: "070239",
        language: "Hinglish",
        default_voiceId: "default",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "7c31b5cd-3ff7-4435-ad72-ab26eedefdd1",
          tenant_id: NURIX_TENANT_ID,
          workspace_id: NURIX_WORKSPACE_ID,
          overide_previous_context: true
        },
        optional_voices: [
          {
            id: "default",
            name: "Meera",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female1.png",
            description: "Female Friendly & Instructive",
            language: "Hinglish",
            region: ""
          }
        ]
      }
    ]
  },
  Unify: {
    path: "unifi",
    pageTitle: "Experience Our Voice AI Agents",
    pageCategory: "Unifi",
    agents: [
      {
        id: "18f5767c-2de8-4ea9-9827-77e90eb9bc57",
        name: "Recruitment Agent",
        description: "An agent that provides job details, schedules interviews, and enhances applicant engagement throughout the recruitment process.",
        subDescription: "An agent that provides job details, schedules interviews, and enhances applicant engagement throughout the recruitment process.",
        agentName: "Emily",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        chatIcon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        featureList: [
          "Provides Job Details",
          "Efficiently Schedules Interviews",
          "Enhances Applicant Engagement"
        ],
        voice: "true",
        chat: "false",
        callTitle: "Recruitment Agent",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "retell",
        try_speaking: [],
        activities: [],
        phoneNumber: "070239",
        language: "English",
        default_voiceId: "default",
        voiceConfig: {},
        optional_voices: [
          {
            id: "default",
            name: "Emily",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
            description: "Female Friendly & Instructive",
            language: "English",
            region: ""
          }
        ]
      }
    ]
  },
  nurixedtechfinal: {
    path: "nurixedtech",
    pageTitle: "Experience Our Voice AI Agents",
    pageCategory: "Nuplay Edtech",
    agents: [
      {
        id: "4149bb44-1696-4ed9-8707-f84336f4583d",
        name: "Lead Qualification Agent",
        description: "Help students and working professionals understand everything related to courses offered by Nuplay Edtech",
        subDescription: "Help students and working professionals understand everything related to courses offered by Nuplay Edtech",
        agentName: "Olivia",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        chatIcon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        featureList: [
          "Suggests the most suitable bootcamps based on the learner’s educational background.",
          "Delivers personalized career guidance tailored to individual goals.",
          "Proactively follows up with learners to ensure timely support and engagement."
        ],
        voice: "true",
        chat: "false",
        callTitle: "Lead Qualification Agent",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "retell",
        try_speaking: [
          "What are the features included in the Pro Plus plan?",
          "Do you offer placement assistance?",
          "What differentiates Nuplay Edtech from other platforms?"
        ],
        activities: [],
        phoneNumber: "070239",
        language: "English",
        default_voiceId: "default",
        voiceConfig: {},
        optional_voices: [
          {
            id: "default",
            name: "Olivia",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
            description: "Female Friendly & Knowledgeable",
            language: "English",
            region: ""
          }
        ]
      }
    ]
  },
  ThirdPartyCollections: {
    "path": "ThirdPartyCollections",
    "pageTitle": "Experience our Voice AI Agents",
    "pageCategory": "Third Party Collections",
    "agents": [
      {
        "id": "659283d5-2123-496e-8945-ec797113e2c1",
        "name": "Collections Agent",
        "description": "Remind users to pay overdue",
        "subDescription": "Remind users to pay overdue",
        "agentName": "Maria",
        "icon": "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        "chatIcon": "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        "featureList": [
          "Remind users to pay overdue",
          "Optimal Debt Resolution Strategies",
          "Reminds User to Pay Overdue"
        ],
        "voice": "true",
        "chat": "false",
        "callTitle": "Collections Agent",
        "chatHints": [],
        "callHintsTable": [],
        "callHints": [
          "Name of User : Mr Robin Smith",
          "Social security code : 3456",
          "Date of Birth : 2nd Jan 1998"
        ],
        "voiceInputs": [],
        "voiceProvider": "retell",
        "voiceConfig": {},
        "try_speaking": [],
        "activities": [],
        "language": "English",
        "default_voiceId": "default",
        "optional_voices": [
          {
            "id": "default",
            "name": "Maria",
            "icon": "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
            "description": "Female Friendly & Instructive",
            "language": "English",
            "region": ""
          }
        ]
      }
    ]
  },
  cfaOrderTaking: {
    "path": "cfa-order-taking",
    "pageTitle": "Experience our Voice AI Agents",
    "pageCategory": "Chick-Fil-A",
    "agents": [
      {
        "id": "88883b46-b3bb-4bc9-9a81-3598567cb909",
        "name": "Catering - Order Taking",
        "description": "Empathetic voice agent for planning catering menu, placing order, and scheduling delivery",
        "subDescription": "Empathetic voice agent for planning catering menu, placing order, and scheduling delivery",
        "agentName": "Myra",
        "icon": "",
        "chatIcon": "",
        "featureList": [
          "Empathetic and Patient",
          "Can help plan party menu",
          "Well-versed with CFA brand guidelines",
          "Captures cross-sell opportunities"
        ],
        "voice": "true",
        "chat": "false",
        "callTitle": "Catering - Order Taking",
        "chatHints": [],
        "callHintsTable": [],
        "callHints": [
          "Agent Name: Myra",
          "Agent Role: Catering - Order Taking"
        ],
        "voiceInputs": [],
        "voiceProvider": "retell",
        "voiceConfig": {},
        "try_speaking": [
          "Can you recommend meals that are easy to eat while traveling?"
        ],
        "activities": [],
        "language": "English",
        "default_voiceId": "default",
        "optional_voices": [
          {
            "id": "default",
            "name": "Myra",
            "icon": "",
            "description": "",
            "language": "English",
            "region": ""
          }
        ]
      }
    ]
  },
  CfaCustomerRepresentative: {
    "path": "cfa-customer-representative",
    "pageTitle": "Experience our Voice AI Agents",
    "pageCategory": "Chick-Fil-A",
    "agents": [
      {
        "id": "952cacd2-533f-4445-b0f4-e8dce92387c2",
        "name": "Catering - Order Taking",
        "description": "Catering agent guiding event orders, confirming details, sending invoices, or scheduling follow-ups.",
        "subDescription": "Catering agent guiding event orders, confirming details, sending invoices, or scheduling follow-ups.",
        "agentName": "Sarah",
        "icon": "",
        "chatIcon": "",
        "featureList": [
          "Empathetic and Patient",
          "Reaches out and Follows up with customer",
          "Well-versed with CFA brand guidelines",
          "Captures cross-sell opportunities"
        ],
        "voice": "true",
        "chat": "false",
        "callTitle": "Catering - Order Taking",
        "chatHints": [],
        "callHintsTable": [],
        "callHints": [
          "Agent Name: Sarah",
          "Agent Role: Catering - Order Taking"
        ],
        "voiceInputs": [],
        "voiceProvider": "retell",
        "voiceConfig": {},
        "try_speaking": [
          "What does CFA Catering looks like ?"
        ],
        "activities": [],
        "language": "English",
        "default_voiceId": "default",
        "optional_voices": [
          {
            "id": "default",
            "name": "Sarah",
            "icon": "",
            "description": "",
            "language": "English",
            "region": ""
          }
        ]
      }
    ]
  },
  ElevateNow: {
    "path": "elevate-now",
    "pageTitle": "Experience our Voice AI Agents",
    "pageCategory": "Elevate Now",
    "agents": [
      {
        "id": "2ac0a217-78e6-449c-8e04-a7251b98e89a",
        "name": "Elevate now demo",
        "description": "An active listening voice agent that understands user issues and engages with the customer to provide solutions, with a focus on customer satisfaction.",
        "subDescription": "An active listening voice agent that understands user issues and engages with the customer to provide solutions, with a focus on customer satisfaction.",
        "agentName": "Elevate now demo",
        "icon": "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        "chatIcon": "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        "featureList": [
          "Tries to analyse the user’s point of view",
          "Builds rapport with the customer and convinces them."
        ],
        "voice": "true",
        "chat": "false",
        "callTitle": "Elevate now demo",
        "chatHints": [],
        "callHintsTable": [],
        "callHints": [],
        "voiceInputs": [],
        "voiceProvider": "voicex",
        "voiceConfig": {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "2ac0a217-78e6-449c-8e04-a7251b98e89a",
          tenant_id: NURIX_TENANT_ID,
          workspace_id: NURIX_WORKSPACE_ID,
          overide_previous_context: true
        },
        "try_speaking": [
          "My goal is to reduce the weight till 60 kg",
          "I am just looking into the plan"
        ],
        "activities": [],
        "language": "English",
        "default_voiceId": "default",
        "optional_voices": [
          {
            "id": "default",
            "name": "Elevate now demo",
            "icon": "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
            "description": "",
            "language": "English",
            "region": ""
          }
        ]
      }
    ]
  },
  hoabl: {
    path: "hoabl2",
    pageTitle: "Experience our Voice Agents",
    pageCategory: "Chick-Fil-A",
    agents: [
      {
        id: "2c8467f4-5d8d-49a1-9583-0acaedd2ce8f",
        name: "Hinglish Demo",
        description: "A support agent that greets callers, verifies identity, then logs, escalates, or fulfills service/installation and fee‑waiver requests—while calming frustrated customers and owning the case",
        subDescription: "A support agent that greets callers, verifies identity, then logs, escalates, or fulfills service/installation and fee‑waiver requests—while calming frustrated customers and owning the case",
        agentName: "Rahul",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        chatIcon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        featureList: [
          "Emotion-aware de‑escalation",
          "Identifies the type of complaint and proceeds accordingly"
        ],
        voice: "true",
        chat: "false",
        callTitle: "Hinglish Demo",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        try_speaking: [
          "मैंने नया water purifier खरीदा है, installation चाहिए।",
          "आपने टिकट बंद कर दिया, लेकिन समस्या अभी भी है।"
        ],
        activities: [],
        phoneNumber: "070239",
        language: "Hinglish",
        default_voiceId: "default",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "2c8467f4-5d8d-49a1-9583-0acaedd2ce8f",
          tenant_id: "122f0f76-f68c-4cee-a115-94a82b870890",
          workspace_id: "122f0f76-f68c-4cee-a115-94a82b870890",
          overide_previous_context: true
        },
        optional_voices: [
          {
            id: "default",
            name: "Rahul",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
            description: "Male Calm & Reassuring",
            language: "Hinglish",
            region: ""
          }
        ]
      }
    ]
  },
  realestate: {
    path: "realestate",
    pageTitle: "Experience our Voice AI Agents",
    pageCategory: "Real Estate",
    agents: [
      {
        id: "fa441586-b41e-4756-abd5-f4435a8f126d",
        name: "Lead Qualification Agent",
        agentName: "Barbara",
        featureList: [
          "Gather essential information",
          "Screen potential clients"
        ],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {},
        description: "A lead qualification agent that gathers essential information from potential clients, screens them for suitability, and schedules follow-up appointments with human agents.",
        subDescription: "",

        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        chatIcon:
          "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",


        try_speaking: [],
        activities: [],
        phoneNumber: "070239",
        language: "English",
        default_voiceId: "default",
        optional_voices: [
          {
            id: "default",
            name: "Myra",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
            description: "Female Young & Professional",
            language: "English",
            region: ""
          }
        ]
      }
    ]
  },
  Zolve: {
    path: "zolve",
    pageTitle: "Experience our Voice Agents",
    pageCategory: "Zolve",
    agents: [
      {
        id: "2c8467f4-5d8d-49a1-9583-0acaedd2ce8f",
        name: "Lead Qualification",
        description: "Lead Qualification Assistant that engages students and professionals relocating abroad, qualifies them through a structured flow, and arranges expert callbacks for loans, visas, or financial support.",
        subDescription: "Lead Qualification Assistant that engages students and professionals relocating abroad, qualifies them through a structured flow, and arranges expert callbacks for loans, visas, or financial support.",
        agentName: "June",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        chatIcon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        featureList: [
          "Greets and verifies lead identity",
          "Checks travel purpose",
          "Collects funding preference(self - funding or education loan)",
          "Handles visa qualification and stages",
          "Arranges expert callbacks"
        ],
        voice: "true",
        chat: "false",
        callTitle: "Lead Qualification Agent",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        try_speaking: [
          "Hi, I’m going abroad for higher studies",
          "I’m a working professional moving to the US",
          "I don’t have my I - 20 yet."
        ],
        activities: [],
        phoneNumber: "070239",
        language: "English",
        default_voiceId: "default",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "3675a039-14eb-404d-b518-6fe5d871e978",
          tenant_id: "776bb4ab-6b60-48c6-b73e-a6686bacff19",
          workspace_id: "776bb4ab-6b60-48c6-b73e-a6686bacff19",
          overide_previous_context: true
        },
        optional_voices: [
          {
            id: "default",
            name: "June",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
            description: "Female & Calm",
            language: "English",
            region: ""
          }
        ]
      }
    ]
  },
  cfaOperations: {
    "path": "cfa-operations",
    "pageTitle": "Experience our Voice AI Agents",
    "pageCategory": "Chick-Fil-A",
    "agents": [
      {
        "id": "8ae614df-4545-407f-80a6-c1ea9b5e354a",
        "name": "Catering - Order Taking",
        "description": "Intelligent voice agent for resolving delivery errors, arranging recoveries, and managing inventory for Chick-fil-A .",
        "subDescription": "Intelligent voice agent for resolving delivery errors, arranging recoveries, and managing inventory for Chick-fil-A .",
        "agentName": "Sarah",
        "icon": "",
        "chatIcon": "",
        "featureList": [
          "Empathetic and reassuring",
          "Proactive recovery planning",
          "Follows CFA supply standards",
          "Anticipates operator needs"
        ],
        "voice": "true",
        "chat": "false",
        "callTitle": "Catering - Order Taking",
        "chatHints": [],
        "callHintsTable": [],
        "callHints": [
          "Agent Name: Sarah",
          "Agent Role: Operations"
        ],
        "voiceInputs": [],
        "voiceProvider": "retell",
        "voiceConfig": {},
        "try_speaking": [
          "Our Diet Coke didn’t arrive this morning, and our wheat buns are low on stock"
        ],
        "activities": [],
        "language": "English",
        "default_voiceId": "default",
        "optional_voices": [
          {
            "id": "default",
            "name": "Sarah",
            "icon": "",
            "description": "",
            "language": "English",
            "region": ""
          }
        ]
      }
    ]
  },
  Hagerty_insurance: {
    path: "hagertyus-1",
    pageTitle: "Experience our Voice Agents",
    pageCategory: "Hagerty Insurance",
    agents: [
      {
        id: "28b5593a-a84b-4a98-b911-f234cd1471e5",
        name: "Internal Assistant 1",
        description: "A professional internal assistant designed to securely assist authorized Hagerty Insurance personnel in accessing customer data with ease and efficiency.",
        subDescription: "An intelligent voice agent that retrieves customer data using the first and last name along with date of birth.",
        agentName: "Myra",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        chatIcon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        featureList: [
          "Verifies employee identity with a strict 3-attempt login system before granting access to customer data.",
          "Retrieves and shares only verified customer information.",
        ],
        voice: "true",
        chat: "false",
        callTitle: "Internal Assistant 1",
        chatHints: [],
        callHintsTable: [],
        callHints: ["Agent Name: Myra", "Employee ID : 123456"],
        voiceInputs: [],
        voiceProvider: "voicex",
        try_speaking: [
          "Could you please retrieve the data for Chris Moore?",
          "Can we proceed without the Employee ID?",
        ],
        activities: [],
        phoneNumber: "070239",
        language: "English",
        default_voiceId: "default",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-us"],
          user_id: DEFAULT_USER_ID,
          agent_id: "28b5593a-a84b-4a98-b911-f234cd1471e5",
          tenant_id: "bb1b4d52-f6c2-4c37-b2da-030f08db2a70",
          workspace_id: "bb1b4d52-f6c2-4c37-b2da-030f08db2a70",
          overide_previous_context: true
        },
        optional_voices: [
          {
            id: "default",
            name: "June",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
            description: "Female & Calm",
            language: "English",
            region: ""
          }
        ]
      },
      {
        id: "dba2ff8d-30f5-40b5-8030-f9fec9415e9b",
        name: "Internal Assistant 2",
        description: "A professional internal assistant designed to securely assist authorized Hagerty Insurance personnel in accessing customer data with ease and efficiency.",
        subDescription: "An intelligent voice agent capable of retrieving customer data even when only partial information is provided by the employee.",
        agentName: "Myra",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        chatIcon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
        featureList: [
          "Verifies employee identity with a strict 3-attempt login system before granting access to customer data.",
          "Retrieves and shares only verified customer information.",
        ],
        voice: "true",
        chat: "false",
        callTitle: "Internal Assistant 2",
        chatHints: [],
        callHintsTable: [],
        callHints: ["Agent Name: Myra", "Employee ID : 123456"],
        voiceInputs: [],
        voiceProvider: "voicex",
        try_speaking: [
          "Could you please retrieve the data for Chris Moore?",
          "Can we proceed without the Employee ID?",
        ],
        activities: [],
        phoneNumber: "070239",
        language: "English",
        default_voiceId: "default",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-us"],
          user_id: DEFAULT_USER_ID,
          agent_id: "dba2ff8d-30f5-40b5-8030-f9fec9415e9b",
          tenant_id: "bb1b4d52-f6c2-4c37-b2da-030f08db2a70",
          workspace_id: "bb1b4d52-f6c2-4c37-b2da-030f08db2a70",
          overide_previous_context: true
        },
        optional_voices: [
          {
            id: "default",
            name: "June",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
            description: "Female & Calm",
            language: "English",
            region: ""
          }
        ]
      }
    ]
  },
  NurixInsuranceUsa: {
    path: "nurix-insurance-usa",
    pageTitle: "Experience our Voice AI Agents",
    pageCategory: "Nuplay Insurance",
    agents: [
      {
        id: "289caf01-99d0-460f-a3c1-ff1954daab73-draft",
        name: "Lead Qualification Agent",
        description: "A helpful and intelligent voice advisor for Nuplay Insurance, specializing in auto insurance lead qualification.",
        subDescription: "A helpful and intelligent voice advisor for Nuplay Insurance, specializing in auto insurance lead qualification.",
        agentName: "Alex",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/male1.png",
        chatIcon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/male1.png",
        featureList: [
          "Recommends named plans based on real-time inputs like age, driving history, and coverage needs.",
          "Handles objections with empathy while clearly highlighting the value of a free, no-pressure quote.",
        ],
        voice: "true",
        chat: "false",
        callTitle: "Lead Qualification Agent",
        chatHints: [],
        callHintsTable: [],
        callHints: ["ZIP : 123456", "Name : Jake Smith"],
        voiceInputs: [],
        voiceProvider: "voicex",
        try_speaking: [
          "I am happy with my current insurance plan.",
          "I have multiple cars and need a full coverage. Which plan is best for me?",
        ],
        activities: [],
        phoneNumber: "070239",
        language: "English",
        default_voiceId: "default",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-us"],
          user_id: DEFAULT_USER_ID,
          agent_id: "289caf01-99d0-460f-a3c1-ff1954daab73-draft",
          tenant_id: "8df3c72c-12a4-4b2b-8f6c-c15689e2cb8a",
          workspace_id: "8df3c72c-12a4-4b2b-8f6c-c15689e2cb8a",
          overide_previous_context: true
        },
        optional_voices: [
          {
            id: "default",
            name: "June",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/male1.png",
            description: "Female & Calm",
            language: "English",
            region: ""
          }
        ]
      }
    ]
  },
  NurixInsuranceIndia: {
    path: "nurix-insurance-india",
    pageTitle: "Experience our Voice AI Agents",
    pageCategory: "Nuplay Insurance",
    agents: [
      {
        id: "71eba8c4-82cc-43d9-a019-9512ec28c26e-draft",
        name: "Lead Qualification Agent",
        description: "A helpful and intelligent voice advisor for Nuplay Insurance, specializing in auto insurance lead qualification.",
        subDescription: "A helpful and intelligent voice advisor for Nuplay Insurance, specializing in auto insurance lead qualification.",
        agentName: "Alakh",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/male2.png",
        chatIcon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female2.png",
        featureList: [
          "Recommends named plans based on real-time inputs like age, driving history, and coverage needs.",
          "Handles objections with empathy while clearly highlighting the value of a free, no-pressure quote.",
        ],
        voice: "true",
        chat: "false",
        callTitle: "Lead Qualification Agent",
        chatHints: [],
        callHintsTable: [],
        callHints: ["ZIP : 123456", "Name : Jake Smith"],
        voiceInputs: [],
        voiceProvider: "voicex",
        try_speaking: [],
        activities: [],
        phoneNumber: "070239",
        language: "English",
        default_voiceId: "default",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-us"],
          user_id: DEFAULT_USER_ID,
          agent_id: "71eba8c4-82cc-43d9-a019-9512ec28c26e-draft",
          tenant_id: "8df3c72c-12a4-4b2b-8f6c-c15689e2cb8a",
          workspace_id: "8df3c72c-12a4-4b2b-8f6c-c15689e2cb8a",
          overide_previous_context: true
        },
        optional_voices: [
          {
            id: "default",
            name: "June",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/male2.png",
            description: "Female & Calm",
            language: "English",
            region: ""
          }
        ]
      }
    ]
  },
  WishFin: {
    path: "wishfin",
    pageTitle: "Experience our Voice AI Agents",
    pageCategory: "Wishfin",
    agents: [
      {
        id: "5dbbafcb-c8ca-4cef-93e0-b63adb36d4eb",
        name: "Outbound Sales Agent",
        description: "Sangeeta is Wishfin's Outbound Sales Agent - a friendly, bilingual voice assistant who connects customers with pre-approved personal loan opportunities from Tata Capital.",
        subDescription: "",
        agentName: "Sangeetha",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
        chatIcon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
        featureList: [
          "Presents personalised pre-approved loan offers based on CIBIL scores.",
          "Calculates and explains potential savings from credit card debt consolidation.",
          "Guides customers through the loan application process with minimal documentation."
        ],
        voice: "true",
        chat: "false",
        callTitle: "Outbound Sales Agent",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        try_speaking: ["मुझे loan के बारे में बताइए", "What's the interest rate on this loan?", "I'm not sure if I need a loan right now"],
        activities: [],
        phoneNumber: "070239",
        language: "English",
        default_voiceId: "default",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "5dbbafcb-c8ca-4cef-93e0-b63adb36d4eb",
          tenant_id: "8df3c72c-12a4-4b2b-8f6c-c15689e2cb8a",
          workspace_id: "8df3c72c-12a4-4b2b-8f6c-c15689e2cb8a",
          overide_previous_context: true
        },
        optional_voices: [
          {
            id: "default",
            name: "June",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
            description: "Female & Calm",
            language: "Hinglish",
            region: ""
          }
        ]
      }
    ]
  },
  newtonSchool: {
    path: "newton-school-chat",
    pageTitle: "Experience our AI Agents",
    pageCategory: "Newton School",
    agents: [
      {
        id: "86a298c7-1f1d-420c-aab2-59c0a39c734c",
        name: "Customer Support Agent",
        agentName: "Aarushi",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female2.png",
        chatIcon:
          "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female2.png",
        featureList: ["Provides accurate, policy-compliant answers based on Newton School of Technology’s official guidelines.",
          "Engages users with a warm, conversational tone while addressing academic and admissions queries.",
          "Offers real-time support on NSAT, eligibility, scholarships, fees, and campus life without needing backend integration."],
        description:
          "An intelligent chat agent that helps users navigate admissions, NSAT, fees, and campus life at Newton School of Technology with clear, policy-aligned answers.",
        voice: "false",
        chat: "true",
        chatHints: [
        ],
        try_speaking: [
        ],
        callHints: ["User Name: Alex Smith", "User DOB: February 15, 1989"],
        callTitle: "Customer Support Agent",
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {},
        default_voiceId: "default",
        optional_voices: [
          {
            id: "11labs-Myra",
            name: "Myra",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female4.png",
            description: "Female Young & Professional",
            language: "English",
            region: "American"
          },

        ],
        activities: [],
      },
    ]
  },
  TeamLease: {
    path: "teamlease",
    pageTitle: "Experience our Voice AI Agents",
    pageCategory: "Teamlease",
    agents: [
      {
        id: "eba93ca5-30f7-4eeb-b8da-ed58b24f1429",
        name: "Lead Qualification RnR",
        description: "A warm and encouraging admission counsellor of universities whose role is to re-engage users who were RnR from the beginning.",
        subDescription: "An intelligent voice agent that qualifies a lead by asking them qualifying questions and clears their doubts and concerns.",
        agentName: "Priya",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
        chatIcon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
        featureList: [
          "Lead qualification by asking qualifying questions",
          "Answering surface level doubts for CU and DDU",
        ],
        voice: "true",
        chat: "false",
        callTitle: "Lead Qualification RnR",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        try_speaking: ["lead_university value can be CU or DDU", "selected_course can be one of the available courses in CU or DDU respectively", "program_type can be [Work Linked, Online] for CU and [Degree with internship, Online] for DDU"],
        activities: [],
        phoneNumber: "070239",
        language: "English",
        default_voiceId: "default",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "eba93ca5-30f7-4eeb-b8da-ed58b24f1429",
          tenant_id: "3c9d7050-8d6e-4281-894f-27640ee258e1",
          workspace_id: "3c9d7050-8d6e-4281-894f-27640ee258e1",
          overide_previous_context: true
        },
        optional_voices: [
          {
            id: "default",
            name: "Priya",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
            description: "Female & Calm",
            language: "Hinglish",
            region: ""
          }
        ]
      },
      {
        id: "ad17c267-c94b-4d58-864d-3c4629407c42",
        name: "Lead Qualification Fresh Leads (7pm to 9pm)",
        description: "A warm and encouraging admission counsellor of universities whose role is to engage with users who showed interest in the 7pm to 9pm time window",
        subDescription: "An intelligent voice agent that qualifies a lead by asking them qualifying questions and clears their doubts and concerns.",
        agentName: "Priya",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
        chatIcon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
        featureList: [
          "Lead qualification by asking qualifying questions",
          "Answering surface level doubts for CU and DDU"
        ],
        voice: "true",
        chat: "false",
        callTitle: "Lead Qualification Fresh Leads (7pm to 9pm)",
        chatHints: [],
        callHintsTable: [
          { "label": "Agent Name", "value": "Priya" },
          { "label": "Agent Role", "value": "Lead Qualification Fresh Leads" }
        ],
        callHints: [
          "Agent Name: Priya",
          "Agent Role: Lead Qualification Fresh Leads"
        ],
        voiceInputs: [],
        voiceProvider: "voicex",
        try_speaking: [
          "lead_university value can be CU or DDU",
          "selected_course can be one of the available courses in CU or DDU respectively",
          "program_type can be [Work Linked, Online] for CU and [Degree with internship, Online] for DDU"
        ],
        activities: [
          "Qualifies leads by asking structured questions",
          "Engages with users to resolve doubts about CU and DDU programs"
        ],
        phoneNumber: "070239",
        language: "Hinglish",
        default_voiceId: "default",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          agent_id: "ad17c267-c94b-4d58-864d-3c4629407c42",
          user_id: DEFAULT_USER_ID,
          tenant_id: DEFAULT_TENANT_ID,
          workspace_id: "3c9d7050-8d6e-4281-894f-27640ee258e1",
          overide_previous_context: true
        },
        optional_voices: [
          {
            id: "default",
            name: "Priya",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
            description: "Female Warm & Encouraging",
            language: "Hinglish",
            region: "IN"
          }
        ]
      },
      {
        id: "d77ab43d-9096-46d5-b199-294c11262908",
        name: "WhatsApp Chat Agent",
        description: "A chat agent which answers user's doubts and concerns as a counsellor and shares important brochures and links with them.",
        subDescription: "An intelligent chat agent that qualifies a lead by asking them qualifying questions and clears their doubts and concerns.",
        agentName: "Priya",
        icon: "https://retell-utils-public.s3.us-west-2.amazonaws.com/nina.png",
        chatIcon: "https://retell-utils-public.s3.us-west-2.amazonaws.com/nina.png",
        featureList: [
          "Lead qualification by asking qualifying questions",
          "Answering surface level doubts for CU and DDU"
        ],
        voice: "false",
        chat: "true",
        callTitle: "WhatsApp Chat Agent",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        try_speaking: [],
        activities: [
          "Answers student and parent queries over WhatsApp",
          "Shares brochures and course-related links for CU and DDU",
          "Engages in qualification conversations for higher-ed leads"
        ],
        phoneNumber: "070239",
        language: "Hinglish",
        default_voiceId: "default",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "d77ab43d-9096-46d5-b199-294c11262908",
          tenant_id: DEFAULT_TENANT_ID,
          workspace_id: "3c9d7050-8d6e-4281-894f-27640ee258e1",
          overide_previous_context: true
        },
        optional_voices: [
          {
            id: "default",
            name: "Priya",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
            description: "Hinglish Chat Counsellor",
            language: "Hinglish",
            region: "IN"
          }
        ]
      }
    ]
  },
  CultFit2: {
    path: "cultfit_elite_pass",
    pageTitle: "Experience our Voice AI Agents",
    pageCategory: "Cult Fit",
    agents: [
      {
        id: "892a4a10-6f3e-424b-bbb5-0204ce087a20",
        name: "Customer support",
        description: "A warm and energetic customer support agent whose role is to engage with customers to share cultpass elite offers.",
        subDescription: "An intelligent voice agent that collect feedback from cultfit customers who have missed their trials by asking their motivation and sharing available offers with them.",
        agentName: "",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/male1.png",
        chatIcon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/male1.png",
        featureList: [
          "Answers FAQs",
          "Provides Elite package offers to customers",
        ],
        voice: "true",
        chat: "false",
        callTitle: "Customer support",
        chatHints: ["Agent Role: Customer support"],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        try_speaking: [],
        activities: [],
        phoneNumber: "070239",
        language: "English",
        default_voiceId: "default",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "892a4a10-6f3e-424b-bbb5-0204ce087a20",
          tenant_id: "1744b80d-1375-42ca-8f68-5e15e702bf6a",
          workspace_id: "1744b80d-1375-42ca-8f68-5e15e702bf6a",
          overide_previous_context: true
        },
        optional_voices: [
          {
            id: "default",
            name: "",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/male1.png",
            description: "Female & Calm",
            language: "Hinglish",
            region: ""
          }
        ]
      }
    ]
  },
  Visit: {
    path: "visit",
    pageTitle: "Experience our Chat Agents",
    pageCategory: "Visit Health",
    agents: [
      {
        id: "918fa7e6-113d-4d71-82b7-c38e3cb4a5ab-draft",
        name: "Customer Support Agent",
        description: "A caring healthcare advocate who educates users about Visit Health Concierge and helps them sign up for comprehensive health management services.",
        subDescription: "A caring healthcare advocate who educates users about Visit Health Concierge and helps them sign up for comprehensive health management services.",
        agentName: "Maya",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
        chatIcon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
        featureList: [
          "Presents Visit Health's all-inclusive Concierge service covering 1000+ cities across India.",
          "Explains comprehensive healthcare coordination from doctor appointments to emergency support.",
          "Guides customers through instant activation with transparent pricing."
        ],
        voice: "false",
        chat: "true",
        callTitle: "Customer Support",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        try_speaking: [],
        activities: [],
        phoneNumber: "070239",
        language: "English",
        default_voiceId: "default",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "892a4a10-6f3e-424b-bbb5-0204ce087a20",
          tenant_id: "1744b80d-1375-42ca-8f68-5e15e702bf6a",
          workspace_id: "1744b80d-1375-42ca-8f68-5e15e702bf6a",
          overide_previous_context: true
        },
        optional_voices: [
          {
            id: "default",
            name: "Maya",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
            description: "Female & Calm",
            language: "Hinglish",
            region: ""
          }
        ]
      }
    ]
  },
  NurixUSAuto: {
    path: "nurix-us-auto",
    pageTitle: "Experience Our Voice AI Agents",
    pageCategory: "Nuplay Insurance",
    agents: [
      {
        id: "658cae61-49e2-4a28-a9a1-4e4aa1190b1e",
        name: "Auto Insurance",
        description: "Alex is a warm, confident, and emotionally intelligent voice advisor for Nuplay Insurance, specializing in auto insurance lead qualification.",
        subDescription: "Alex is a warm, confident, and emotionally intelligent voice advisor for Nuplay Insurance, specializing in auto insurance lead qualification.",
        agentName: "Alex",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female2.png",
        chatIcon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female2.png",
        featureList: [
          "Recommends named plans based on real-time inputs like age, driving history, and coverage needs.",
          "Handles objections with empathy while clearly highlighting the value of a free, no-pressure quote."
        ],
        voice: "true",
        chat: "false",
        callTitle: "Auto Insurance",
        chatHints: [],
        callHintsTable: [],
        callHints: [
          "ZIP : 12345"
        ],
        voiceInputs: [],
        voiceProvider: "voicex",
        try_speaking: [
          "I am happy with my current insurance plan.",
          "I have multiple cars and need a full coverage. Which plan is best for me?"
        ],
        activities: [
        ],
        language: "English",
        default_voiceId: "default",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-us"],
          user_id: DEFAULT_USER_ID,
          agent_id: "658cae61-49e2-4a28-a9a1-4e4aa1190b1e",
          tenant_id: "8df3c72c-12a4-4b2b-8f6c-c15689e2cb8a",
          workspace_id: "8df3c72c-12a4-4b2b-8f6c-c15689e2cb8a",
          overide_previous_context: true
        },
        optional_voices: [
          {
            id: "default",
            name: "Alex",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female2.png",
            description: "Male Warm & Confident",
            language: "English",
            region: "US"
          }
        ]
      }
    ]
  },
  XanaduChat: {
    path: "xanadu-chat",
    pageTitle: "Experience our Chat Agents",
    pageCategory: "Xanadu",
    agents: [
      {
        id: "cbfc0b3a-04de-438b-a236-59fbec463eb8",
        name: "Xanadu - Salesy Agent",
        description: "Xanadu Chat Agent",
        subDescription: "Xanadu Chat Agent ",
        agentName: "Myra",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
        chatIcon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
        featureList: [],
        voice: "false",
        chat: "true",
        callTitle: "Xanadu - Salesy Agent",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        try_speaking: [],
        activities: [],
        phoneNumber: "070239",
        language: "English",
        default_voiceId: "default",
        voiceConfig: {},
        optional_voices: [
          {
            id: "default",
            name: "Maya",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
            description: "Female & Calm",
            language: "English",
            region: ""
          }
        ]
      }
    ]
  },
  Artium: {
    path: "artiumacademy",
    pageTitle: "Experience our Chat Agents",
    pageCategory: "Artium Academy",
    agents: [
      {
        id: "a2f05356-9484-4afa-8ef5-265565b18e3e",
        name: "User Reactivation Agent",
        description: "User reactivation agent outbound call",
        subDescription: "User reactivation agent outbound call",
        agentName: "Swara",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
        chatIcon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
        featureList: [],
        voice: "true",
        chat: "false",
        callTitle: "User Reactivation Agent",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "outbound-call",
        try_speaking: [],
        activities: [],
        phoneNumber: "070239",
        language: "English",
        default_voiceId: "default",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "a2f05356-9484-4afa-8ef5-265565b18e3e",
          tenant_id: "45616fa9-6c11-4789-9c6c-91f68c2b0e26",
          workspace_id: "45616fa9-6c11-4789-9c6c-91f68c2b0e26",
        },
        optional_voices: [
          {
            id: "default",
            name: "Maya",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
            description: "Female & Calm",
            language: "English",
            region: ""
          }
        ]
      },
      {
        id: "a2f05356-9484-4afa-8ef5-265565b18e3e",
        name: "User Reactivation Agent",
        description: "User reactivation agent web call",
        subDescription: "User reactivation agent web call",
        agentName: "Swara",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
        chatIcon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
        featureList: [],
        voice: "true",
        chat: "false",
        callTitle: "User Reactivation Agent",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        try_speaking: [],
        activities: [],
        phoneNumber: "070239",
        language: "English",
        default_voiceId: "default",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "a2f05356-9484-4afa-8ef5-265565b18e3e",
          tenant_id: "45616fa9-6c11-4789-9c6c-91f68c2b0e26",
          workspace_id: "45616fa9-6c11-4789-9c6c-91f68c2b0e26",
        },
        optional_voices: [
          {
            id: "default",
            name: "Maya",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
            description: "Female & Calm",
            language: "English",
            region: ""
          }
        ]
      },
      {
        id: "ca467e45-3893-4be5-b64a-8ca70f15483e",
        name: "Demo Reminder Agent",
        description: "A warm and encouraging AI companion who reminds the users about their upcoming demo at Artium Academy",
        subDescription: "A smart voice agent that asks the users about their intent of joining the demo and clears any doubts they might have",
        agentName: "Swara",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
        chatIcon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
        featureList: ["Demo Reminder about the upcoming sessions", "Answering doubts related to the courses"],
        voice: "true",
        chat: "false",
        callTitle: "Demo Reminder Agent",
        chatHints: [],
        callHintsTable: [],
        callHints: ["Agent Name: Swara", "Agent Role: Demo Reminder"],
        voiceInputs: [],
        voiceProvider: "outbound-call",
        try_speaking: ["Hey, can I reschedule my demo?", "I need to cancel my demo!"],
        activities: [],
        phoneNumber: "070239",
        language: "English",
        default_voiceId: "default",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "ca467e45-3893-4be5-b64a-8ca70f15483e",
          tenant_id: "45616fa9-6c11-4789-9c6c-91f68c2b0e26",
          workspace_id: "45616fa9-6c11-4789-9c6c-91f68c2b0e26",
        },
        optional_voices: [
          {
            id: "default",
            name: "Maya",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
            description: "Female & Calm",
            language: "English",
            region: ""
          }
        ]
      },
      {
        id: "ca467e45-3893-4be5-b64a-8ca70f15483e",
        name: "Demo Reminder Agent Web Call",
        description: "A warm and encouraging AI companion who reminds the users about their upcoming demo at Artium Academy",
        subDescription: "A smart voice agent that asks the users about their intent of joining the demo and clears any doubts they might have",
        agentName: "Swara",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
        chatIcon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
        featureList: ["Demo Reminder about the upcoming sessions", "Answering doubts related to the courses"],
        voice: "true",
        chat: "false",
        callTitle: "Demo Reminder Agent",
        chatHints: [],
        callHintsTable: [],
        callHints: ["Agent Name: Swara", "Agent Role: Demo Reminder"],
        voiceInputs: [],
        voiceProvider: "voicex",
        try_speaking: ["Hey, can I reschedule my demo?", "I need to cancel my demo!"],
        activities: [],
        phoneNumber: "070239",
        language: "English",
        default_voiceId: "default",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "ca467e45-3893-4be5-b64a-8ca70f15483e",
          tenant_id: "45616fa9-6c11-4789-9c6c-91f68c2b0e26",
          workspace_id: "45616fa9-6c11-4789-9c6c-91f68c2b0e26",
        },
        optional_voices: [
          {
            id: "default",
            name: "Maya",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
            description: "Female & Calm",
            language: "English",
            region: ""
          }
        ]
      },
      {
        id: "a356325b-f2ba-4228-9aec-e9015a564536",
        name: "Re-engage inactive students",
        description: "Re-engage inactive students, understand reasons for their absence, and help them resume their music learning journey.",
        subDescription: "Re-engage inactive students, understand reasons for their absence, and help them resume their music learning journey.",
        agentName: "Swara",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
        chatIcon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
        featureList: [],
        voice: "true",
        chat: "false",
        callTitle: "Re-engage inactive students",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        try_speaking: [],
        activities: [],
        phoneNumber: "070239",
        language: "English",
        default_voiceId: "default",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "a356325b-f2ba-4228-9aec-e9015a564536",
          tenant_id: "45616fa9-6c11-4789-9c6c-91f68c2b0e26",
          workspace_id: "45616fa9-6c11-4789-9c6c-91f68c2b0e26",
        },
        optional_voices: [
          {
            id: "default",
            name: "Maya",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
            description: "Female & Calm",
            language: "English",
            region: ""
          }
        ]
      },
    ]
  },
  Myntra2: {
    path: "nurix-myntra",
    pageTitle: "Experience our Chat Agents",
    pageCategory: "Myntra",
    agents: [
      {
        id: "01a4fa6e-5dbb-4a5b-b627-fbb793a1a4a8",
        name: "Seller Onboarding Agent",
        description: "A professional Myntra Business Development agent that guides shortlisted sellers through the complete onboarding process, explaining commercial terms, operational models, and registration requirements in a clear and supportive manner.",
        subDescription: "Clearly explains the operating model and addresses seller concerns about pricing,timelines and compliance requirements with patience and clarity",
        agentName: "Meera",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
        chatIcon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
        featureList: ["Structured Information Flow with Checkpoints", "Context-Aware Guardrails for Common Objections"],
        voice: "true",
        chat: "false",
        callTitle: "Seller Onboarding Agent",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        try_speaking: ["Commission charges ASP level पर based हैं ?", "और dry run के लिए क्या क्या चाहिए होगा ?"],
        activities: [],
        phoneNumber: "070239",
        language: "English",
        default_voiceId: "default",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "01a4fa6e-5dbb-4a5b-b627-fbb793a1a4a8",
          tenant_id: "7a450992-5eb5-43a9-8a0b-768db7169748",
          workspace_id: "7a450992-5eb5-43a9-8a0b-768db7169748",
        },
        optional_voices: [
          {
            id: "default",
            name: "Maya",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
            description: "Female & Calm",
            language: "English",
            region: ""
          }
        ]
      }
    ]
  },
  RateQuote: {
    path: "rate-quote",
    pageTitle: "Experience our Chat Agents",
    pageCategory: "Rate Quote",
    agents: [
      {
        id: "ac917a45-d9a5-45bd-a995-b11a9733ef50",
        name: "Lead Qualification Agent",
        description: "Handles inbound calls to collect caller information and deliver personalized health and Medicare plan quotes.",
        subDescription: "Collects essential eligibility information including location, household details, and health status, then triggers a branded follow-up email with quote options.",
        agentName: "Madison",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female2.png",
        chatIcon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female2.png",
        featureList: ["Warm", "Professional", "Efficient"],
        voice: "true",
        chat: "false",
        callTitle: "Lead Qualification Agent",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        try_speaking: ["I'm looking to compare Medicare plans in my area.",
          "Can you help me find affordable health coverage?"],
        activities: [],
        phoneNumber: "070239",
        language: "English",
        default_voiceId: "default",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-us"],
          user_id: DEFAULT_USER_ID,
          agent_id: "ac917a45-d9a5-45bd-a995-b11a9733ef50",
          tenant_id: "8b142e1c-14ef-4bbf-a1ce-b7f69095facb",
          workspace_id: "8b142e1c-14ef-4bbf-a1ce-b7f69095facb",
        },
        optional_voices: [
          {
            id: "default",
            name: "Madison",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female2.png",
            description: "Female & Calm",
            language: "English",
            region: ""
          }
        ]
      }
    ]
  },
  Artium_US: {
    path: "artiumacademy-us",
    pageTitle: "Experience our Chat Agents",
    pageCategory: "Artium Academy",
    agents: [
      {
        id: "6ba64d69-0e06-4f37-86b0-adb2b1d297f0",
        name: "Demo Reminder Agent",
        description: "A warm and encouraging AI companion who reminds the users about their upcoming demo at Artium Academy",
        subDescription: "A smart voice agent that asks the users about their intent of joining the demo and clears any doubts they might have",
        agentName: "Swara",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
        chatIcon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
        featureList: ["Demo Reminder about the upcoming sessions", "Answering doubts related to the courses"],
        voice: "true",
        chat: "false",
        callTitle: "Demo Reminder Agent",
        chatHints: [],
        callHintsTable: [],
        callHints: ["Agent Name: Swara", "Agent Role: Demo Reminder"],
        voiceInputs: [],
        voiceProvider: "outbound-call",
        try_speaking: ["Hey, can I reschedule my demo?", "I need to cancel my demo!"],
        activities: [],
        phoneNumber: "070239",
        language: "English",
        default_voiceId: "default",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-us"],
          user_id: DEFAULT_USER_ID,
          agent_id: "6ba64d69-0e06-4f37-86b0-adb2b1d297f0",
          tenant_id: "e9ac1421-8e7b-46c1-a87c-a617251451da",
          workspace_id: "e9ac1421-8e7b-46c1-a87c-a617251451da",
        },
        optional_voices: [
          {
            id: "default",
            name: "Maya",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
            description: "Female & Calm",
            language: "English",
            region: ""
          }
        ]
      }
    ]
  },
  Scaler: {
    path: "scaler",
    pageTitle: "Experience our Chat Agents",
    pageCategory: "Scaler",
    agents: [
      {
        id: "0362609a-c8a7-476d-b470-2b24b7ff4077",
        name: "Refferal Request ",
        description: "A warm and encouraging AI companion who requests refferals from the users",
        subDescription: "A warm and encouraging AI companion who requests refferals from the users",
        agentName: "Anjali",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
        chatIcon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
        featureList: [],
        voice: "true",
        chat: "false",
        callTitle: "Refferal Request Agent",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        try_speaking: [],
        activities: [],
        phoneNumber: "070239",
        language: "English",
        default_voiceId: "default",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "0362609a-c8a7-476d-b470-2b24b7ff4077",
          tenant_id: "d5790d69-2fb8-41d7-bf04-9a99b3c8c348",
          workspace_id: "d5790d69-2fb8-41d7-bf04-9a99b3c8c348",
        },
        optional_voices: [
          {
            id: "default",
            name: "Anjali",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
            description: "Female & Calm",
            language: "English",
            region: ""
          }
        ]
      },

    ]
  },
  AxisBank: {
    path: "axisbank",
    pageTitle: "Experience our AI Agents",
    pageCategory: "Axis Bank",
    agents: [
      {
        id: "2a47e9c2-5169-4b14-a6cf-7ddc2d1c8e8a",
        name: "Candidate Screening Call",
        description: "A professional voice assistant for Axis Bank Talent Acquisition Team to screen candidates.",
        subDescription: "A smart voice agent that evaluates candidate details and asks screening questions for Axis Bank.",
        agentName: "Anjali",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
        chatIcon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
        featureList: [
          "Candidate screening for Axis Bank",
        ],
        voice: "true",
        chat: "false",
        callTitle: "Axis Bank – Candidate Screening",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [
          {
          }
        ],
        voiceProvider: "voicex",
        try_speaking: [
        ],
        activities: [],
        phoneNumber: "070239",
        language: "English",
        default_voiceId: "default",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "2a47e9c2-5169-4b14-a6cf-7ddc2d1c8e8a",
          tenant_id: "24b72de3-a7c4-4a1d-9092-c295f439e456",
          workspace_id: "24b72de3-a7c4-4a1d-9092-c295f439e456"
        },
        optional_voices: [
          {
            id: "default",
            name: "Anjali",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
            description: "Female & Professional",
            language: "English",
            region: ""
          }
        ]
      }
    ]
  },
  AxesTrack: {
    path: "axestrack",
    pageTitle: "Experience our AI Agents",
    pageCategory: "AxesTrack",
    agents: [
      {
        id: "a2f05356-9484-4afa-8ef5-265565b18e3e",
        name: "Axestrack Fleet Status Verification",
        description: "Hindi-speaking fleet verification agent that calls truck drivers to confirm vehicle status when tracking shows vehicles as stopped, collecting unloading/loading status and time estimates.",
        subDescription: "Hindi-speaking fleet verification agent that calls truck drivers to confirm vehicle status when tracking shows vehicles as stopped, collecting unloading/loading status and time estimates.",
        agentName: "Sandeep",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/male2.png",
        chatIcon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/male2.png",
        featureList: ["Availability check and vehicle verification", "Capture relevant time estimates based on status"],
        voice: "true",
        chat: "false",
        callTitle: "Axestrack Fleet Status Verification",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "outbound-call",
        try_speaking: [],
        activities: [],
        phoneNumber: "070239",
        language: "English",
        default_voiceId: "default",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "26cd7fb4-70ce-400f-8efb-420671c62521",
          tenant_id: "93debacb-6338-4fe3-befb-731e7fd94a3b",
          workspace_id: "93debacb-6338-4fe3-befb-731e7fd94a3b",
        },
        optional_voices: [
          {
            id: "default",
            name: "Sandeep",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/male2.png",
            description: "Female & Calm",
            language: "English",
            region: ""
          }
        ]
      }
    ]
  },
  GSG: {
    path: "gsg-widget",
    pageTitle: "Experience our AI Agents",
    pageCategory: "GSG",
    agents: [
      {
        id: "27e24e11-e501-4fad-ab54-b5c33221bb47",
        name: "Admissions counsellor agent",
        description: "A friendly AI admission counsellor that guides students clearly and supports them throughout the application journey",
        subDescription: "A friendly AI admission counsellor that guides students clearly and supports them throughout the application journeyq",
        agentName: "Sara",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/male2.png",
        chatIcon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/male2.png",
        featureList: [],
        voice: "true",
        chat: "false",
        callTitle: "Admissions counsellor agent",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        try_speaking: [],
        activities: [],
        phoneNumber: "070239",
        language: "English",
        default_voiceId: "default",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-us"],
          user_id: DEFAULT_USER_ID,
          agent_id: "27e24e11-e501-4fad-ab54-b5c33221bb47",
          tenant_id: "b2a880a5-84d8-40f4-9616-5f43ed77d2d4",
          workspace_id: "b2a880a5-84d8-40f4-9616-5f43ed77d2d4",
        },
        optional_voices: [
          {
            id: "default",
            name: "Sara",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female1.png",
            description: "Female & Calm",
            language: "English",
            region: ""
          }
        ]
      }
    ]
  },
  AppsForBharat: {
    path: "appsforbharat",
    pageTitle: "Experience our AI Agents",
    pageCategory: "AppsForBharat",
    agents: [
      {
        id: "972d6917-15f2-4786-b896-ba50deb8210c",
        name: "Puja Guidance Assistant",
        description: "Guides users to the right puja based on their life concerns.",
        subDescription: "Helps devotees find and understand the right puja based on their concerns.",
        agentName: "Diya",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
        chatIcon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
        featureList: [],
        voice: "true",
        chat: "false",
        callTitle: "Puja Guidance Assistant",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        try_speaking: [],
        activities: [],
        phoneNumber: "070239",
        language: "English",
        default_voiceId: "default",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "972d6917-15f2-4786-b896-ba50deb8210c",
          tenant_id: "596c2102-7378-4ffc-8ab4-31cd2484fb87",
          workspace_id: "596c2102-7378-4ffc-8ab4-31cd2484fb87",
        },
        optional_voices: [
          {
            id: "default",
            name: "Diya",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
            description: "Female & Calm",
            language: "English",
            region: ""
          }
        ]
      }
    ]
  },
  Agrim: {
    path: "agrim",
    pageTitle: "Experience our AI Agents",
    pageCategory: "Agrim",
    agents: [
      {
        id: "69b5e8c4-df08-4685-b3b3-4f164d533adb",
        name: "Agrim App Guidance Assistant",
        description: "A sales support agent assisting retailers with app installation, verification, and product discovery.",
        subDescription: "Designed for smooth guidance, objection handling, and accurate flow-based conversations.",
        agentName: "Saurabh",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/male2.png",
        chatIcon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/male2.png",
        featureList: [],
        voice: "true",
        chat: "false",
        callTitle: "Agrim App Guidance Assistant",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        try_speaking: [],
        activities: [],
        phoneNumber: "070239",
        language: "English",
        default_voiceId: "default",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "69b5e8c4-df08-4685-b3b3-4f164d533adb",
          tenant_id: "18b678a6-8616-40c5-adad-c1b44896bffd",
          workspace_id: "18b678a6-8616-40c5-adad-c1b44896bffd",
        },
        optional_voices: [
          {
            id: "default",
            name: "Diya",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/male2.png",
            description: "Male & Calm",
            language: "English",
            region: ""
          }
        ]
      }
    ]
  },
  MohaliCU: {
    path: "cu-mohali",
    pageTitle: "Experience our Chat Agents",
    pageCategory: "Chandigarh University",
    agents: [
      {
        id: "807a6985-c278-4af6-a1f0-e94146291aa6",
        name: "Chandigarh University Guide",
        description: "A friendly assistant that answers everything about चंडीगढ़ University—programs, eligibility, admissions, fees, scholarships, hostels, facilities, and placements",
        subDescription: "A friendly assistant that answers everything about चंडीगढ़ University—programs, eligibility, admissions, fees, scholarships, hostels, facilities, and placements ",
        agentName: "Divya",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
        chatIcon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
        try_speaking: [
          "What’s the placement support like for engineering students ?",
          "I’m from another state—how does transport and hostel allocation work ?",
          "Tell me about hostel facilities for girls at चंडीगढ़ University"],
        voice: "false",
        chat: "true",
        callTitle: "Chandigarh University Guide",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        featureList: [],
        activities: [],
        phoneNumber: "070239",
        language: "English",
        default_voiceId: "default",
        voiceConfig: {},
        optional_voices: [
          {
            id: "default",
            name: "Divya",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
            description: "Female & Calm",
            language: "English",
            region: ""
          }
        ]
      }
    ]
  },
  LucknowCU: {
    path: "cu-lucknow",
    pageTitle: "Experience our Chat Agents",
    pageCategory: "Chandigarh University",
    agents: [
      {
        id: "88a47678-9961-400c-aa25-ae7e17946f7b",
        name: "Chandigarh University Guide",
        description: "A friendly assistant that answers everything about चंडीगढ़ University—programs, eligibility, admissions, fees, scholarships, hostels, facilities, and placements",
        subDescription: "A friendly assistant that answers everything about चंडीगढ़ University—programs, eligibility, admissions, fees, scholarships, hostels, facilities, and placements ",
        agentName: "Divya",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
        chatIcon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
        try_speaking: [
          "What’s the placement support like for engineering students ?",
          "I’m from another state—how does transport and hostel allocation work ?",
          "Tell me about hostel facilities for girls at चंडीगढ़ University"],
        voice: "false",
        chat: "true",
        callTitle: "Chandigarh University Guide",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        featureList: [],
        activities: [],
        phoneNumber: "070239",
        language: "English",
        default_voiceId: "default",
        voiceConfig: {},
        optional_voices: [
          {
            id: "default",
            name: "Divya",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
            description: "Female & Calm",
            language: "English",
            region: ""
          }
        ]
      }
    ]
  },
  CUCET: {
    path: "cucet",
    pageTitle: "Experience our Chat Agents",
    pageCategory: "Chandigarh University",
    agents: [
      {
        id: "faa5aa58-ef88-42e6-8941-fd17918d68c6",
        name: "CUCET Helpdesk",
        description: "A friendly assistant for CUCET (Chandigarh University Common Entrance Test)—guiding you on registration, eligibility, exam pattern/syllabus, scholarship benefits, important dates and results.",
        subDescription: "A friendly assistant for CUCET (Chandigarh University Common Entrance Test)—guiding you on registration, eligibility, exam pattern/syllabus, scholarship benefits, important dates and results. ",
        agentName: "Divya",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
        chatIcon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
        featureList: [],
        voice: "false",
        chat: "true",
        callTitle: "CUCET Helpdesk",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        try_speaking: ["What is the syllabus for CUCET?",
          "Is the exam mode online or offline?",
          "How to register for CUCET?",
          "Mandatory courses for CUCET"],
        activities: [],
        phoneNumber: "070239",
        language: "English",
        default_voiceId: "default",
        voiceConfig: {},
        optional_voices: [
          {
            id: "default",
            name: "Divya",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
            description: "Female & Calm",
            language: "English",
            region: ""
          }
        ]
      }
    ]
  },

  WPA: {
    path: "wpa",
    pageTitle: "Experience our AI Agents",
    pageCategory: "Western Provident Association",
    agents: [
      {
        id: "4a538c0b-f13b-49a0-a56e-ce6953057ab8",
        name: "WPA Insurance Consultant",
        description: "The agent makes outbound calls to understand employee health insurance needs and position WPA as a trusted, not-for-profit partner focused on workforce wellbeing.",
        subDescription: "",
        agentName: "Sarah",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female3.png",
        chatIcon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female3.png",
        featureList: ["Real-time detection of user engagement and intent",
          "Clear qualification of employee health insurance status",
          "Appointment scheduling with a specialist WPA advisor",],
        voice: "true",
        chat: "false",
        callTitle: "WPA Insurance Consultant",
        chatHints: [],
        callHintsTable: [],
        callHints: ["Name: Albert",
          "Company: Instaix",
          "Do you hold a current employee insurance plan: No",
          "Current number of employee : 150",
          "Email id: Albert@instaix.com",
          "Reference poc: Sam"],
        voiceInputs: [],
        voiceProvider: "outbound-call",
        try_speaking: ["Yes, we already have health insurance.",
          "No, we don’t offer health insurance.",
          "What are the benefits?",
          "Can we keep this quick?",
          "You need to speak with someone else.",
          "What would the next step be?",],
        activities: ["Assess employee health insurance needs",
          "Schedule follow-ups with a WPA advisor",
          "Capture key business details",
          "Qualify business leads",],
        phoneNumber: "070239",
        language: "English",
        default_voiceId: "default",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-us"],
          user_id: DEFAULT_USER_ID,
          agent_id: "4a538c0b-f13b-49a0-a56e-ce6953057ab8",
          tenant_id: "8df3c72c-12a4-4b2b-8f6c-c15689e2cb8a",
          workspace_id: "8df3c72c-12a4-4b2b-8f6c-c15689e2cb8a",
        },
        optional_voices: [
          {
            id: "default",
            name: "Sarah",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female3.png",
            description: "Female & Calm",
            language: "English",
            region: "United Kingdom"
          }
        ]
      }
    ]
  },

  ICC: {
    path: "icc",
    pageTitle: "Experience our Voice Agents",
    pageCategory: "ICC",
    agents: [
      {
        id: "f4d28586-bbd6-4110-a5d9-fa81e22d1c9e",
        name: "ICC Demo Agent",
        description: "",
        subDescription: "",
        agentName: "Harsha Bhogle",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/male2.png",
        chatIcon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/male2.png",
        featureList: [],
        voice: "true",
        chat: "false",
        callTitle: "ICC Demo Agent",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        try_speaking: [],
        activities: [],
        phoneNumber: "070239",
        language: "English",
        default_voiceId: "default",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-us"],
          user_id: DEFAULT_USER_ID,
          agent_id: "f4d28586-bbd6-4110-a5d9-fa81e22d1c9e",
          tenant_id: "d4736e2d-be79-4074-8be9-33537a670f27",
          workspace_id: "d4736e2d-be79-4074-8be9-33537a670f27",
        },
        optional_voices: [
          {
            id: "default",
            name: "Harsha Bhogle",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/male2.png",
            description: "Female & Calm",
            language: "English",
            region: ""
          }
        ]
      }
    ]
  },

  WPA2: {
    path: "wpa-advisory",
    pageTitle: "Experience our AI Agents",
    pageCategory: "Western Provident Association",
    agents: [
      {
        id: "079e66c4-d8da-4d6d-a534-9a56c262ef3b",
        name: "WPA Business Guide",
        description:
          "Outbound calling agent that qualifies UK businesses’ employee health insurance status, captures key business details, handles objections politely, and schedules follow-ups with a WPA advisor while remaining compliance-aware.",
        subDescription: "",
        agentName: "Sarah",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female3.png",
        chatIcon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female3.png",

        featureList: [
          "Real-time detection of user engagement and intent",
          "Clear qualification of employee health insurance status",
          "Compliance-aware responses (high-level info only; no personal recommendations; no medical history)"
        ],

        voice: "true",
        chat: "false",
        callTitle: "WPA Business Guide",
        chatHints: [],
        callHintsTable: [],

        callHints: [
          "Name: Albert",
          "Company: Nuplay",
          "Do you hold a current employee insurance plan: No",
          "Current number of employees: 150",
          "Email id: Albert@instaix.com",
          "HQ: Somerset"
        ],

        voiceInputs: [],
        voiceProvider: "outbound-call",

        try_speaking: [
          "Yes, we already have health insurance.",
          "No, we don’t offer health insurance.",
          "What are the benefits?",
          "What would the next step be?"
        ],

        activities: [
          "Assess employee health insurance needs",
          "Capture key business details (size, locations, cover approach, dependants, priorities, budget)",
          "Qualify business leads (insured vs not insured, renewal window, decision-maker)",
          "Schedule follow-ups with a WPA advisor",
          "Handle objections politely and exit cleanly when irrelevant or uninterested"
        ],

        phoneNumber: "070239",
        language: "English",
        default_voiceId: "default",

        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-us"],
          user_id: DEFAULT_USER_ID,
          agent_id: "079e66c4-d8da-4d6d-a534-9a56c262ef3b",
          tenant_id: "8df3c72c-12a4-4b2b-8f6c-c15689e2cb8a",
          workspace_id: "8df3c72c-12a4-4b2b-8f6c-c15689e2cb8a"
        },

        optional_voices: [
          {
            id: "default",
            name: "Sarah",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female3.png",
            description: "Female & Calm",
            language: "English",
            region: "United Kingdom"
          }
        ]
      }
    ]
  },

  PocketPos: {
    path: "pocket-pos",
    pageTitle: "Experience our AI Agents",
    pageCategory: "PoketPOS",
    agents: [
      {
        id: "b294ffe4-8d40-4b7d-b4e7-6d4095ba6565",
        name: "Order taking executive",
        description:
          "A warm and professional voice-based restaurant order-taking executive designed to handle live inbound calls. She accurately captures food orders with all details such as item names, quantities, spice levels, and customizations, confirms delivery addresses, and clearly communicates payment steps",
        subDescription: "",
        agentName: "Neha",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
        chatIcon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",

        featureList: [],

        voice: "true",
        chat: "false",
        callTitle: "Order taking executive",
        chatHints: [],
        callHintsTable: [],

        callHints: [],

        voiceInputs: [],
        voiceProvider: "voicex",

        try_speaking: [],

        activities: [],

        phoneNumber: "070239",
        language: "English",
        default_voiceId: "default",

        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "b294ffe4-8d40-4b7d-b4e7-6d4095ba6565",
          tenant_id: "df41ab63-710e-48f0-a511-1708428b211f",
          workspace_id: "df41ab63-710e-48f0-a511-1708428b211f"
        },

        optional_voices: [
          {
            id: "default",
            name: "Neha",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
            description: "Female & Calm",
            language: "English",
            region: "India"
          }
        ]
      }
    ]
  },

  XanaduChat2: {
    path: "xanadu-demo-chat",
    pageTitle: "Experience our AI Agents",
    pageCategory: "Xanadu",
    agents: [
      {
        id: "0d91ec31-c527-49f0-b818-26bddf10f039",
        name: "Xanadu WhatsApp Agent",
        description: "AI-powered WhatsApp Sales Assistant that manages end-to-end lead qualification, information delivery, and conversion for real estate projects.",
        subDescription: "Designed to drive high-intent registrations through structured conversations, smart intent detection, and a seamless, fully automated buyer journey",
        agentName: "Priya",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
        chatIcon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
        featureList: [],
        voice: "chat",
        chat: "true",
        callTitle: "Xanadu WhatsApp Agent",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        try_speaking: [],
        activities: [],
        phoneNumber: "070239",
        language: "English",
        default_voiceId: "default",
        voiceConfig: {},
        optional_voices: [
          {
            id: "default",
            name: "Priya",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
            description: "Female & Calm",
            language: "English",
            region: ""
          }
        ]
      }
    ]
  },
  ACSTus: {
    path: "acst",
    pageTitle: "Experience Our AI Agents",
    pageCategory: "ACST",
    agents: [
      {
        id: "f70ec4fb-2545-455b-a39b-7f503ab4a6c2",
        name: "FAQ Agent",
        agentName: "Alex",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/male1.png",
        chatIcon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/male1.png",
        featureList: [],
        description:
          "A voice agent that answers user queries, guides step-by-step through tasks, and helps resolve issues quickly with natural, human-like conversations.",
        subDescription:
          "An intelligent voice assistant that helps users manage accounting tasks, answer product FAQs, and guide them step-by-step through processes, all through natural, conversational voice interactions.",
        voice: "true",
        chat: "false",
        chatHints: [],
        try_speaking: [],
        callHints: [],
        callTitle: "FAQ Agent",
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {},
        language: "English",
        default_voiceId: "default",
        optional_voices: [
          {
            id: "default",
            name: "Alex",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/male1.png",
            description: "Male & Professional",
            language: "English",
            region: "American"
          }
        ],
        activities: []
      }
    ]
  },
  TalentOs: {
    path: "talent-os",
    pageTitle: "Experience Our AI Agents",
    pageCategory: "TalentOs",
    agents: [
      {
        id: "e4185c00-648a-4816-9324-0405c871ded9",
        name: "AI Recruiter",
        agentName: "Alex",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/male1.png",
        chatIcon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/male1.png",
        featureList: [
          "Structured screening interviews",
          "Consistent candidate experience",
          "Clear process guidance"
        ],
        description:
          "Alex is a virtual agent that assists candidates by asking questions and guiding them through the process.",
        subDescription: "A virtual assistant that guides candidates.",
        voice: "true",
        chat: "false",
        callTitle: "AI Recruiter",
        chatHints: [],
        callHintsTable: [],
        callHints: [
          "Name: Adam",
          "Powers: Fly and Lift heavy objects",
          "Education: Avengers Academy"
        ],
        voiceInputs: [],
        voiceProvider: "outbound-call",
        try_speaking: [
          "I have a degree from Avengers Academy",
          "I can fly and lift heavy objects",
          "With whom will I be working?"
        ],
        activities: [],
        phoneNumber: "070239",
        language: "English",
        default_voiceId: "default",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-us"],
          user_id: US_USER_ID,
          agent_id: "e4185c00-648a-4816-9324-0405c871ded9",
          tenant_id: "8df3c72c-12a4-4b2b-8f6c-c15689e2cb8a",
          workspace_id: "8df3c72c-12a4-4b2b-8f6c-c15689e2cb8a"
        },
        optional_voices: [
          {
            id: "default",
            name: "Alex",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/male1.png",
            description: "Male & Professional",
            language: "English",
            region: "United States"
          }
        ]
      }
    ]
  },

  XanaduDemo: {
    path: "xanadu-demo",
    pageTitle: "Experience Our AI Agents",
    pageCategory: "Xanadu",
    agents: [
      {
        id: "e1d7d60f-ffdf-41b0-93c7-22610564be3a",
        name: "Real Estate Assistant",
        agentName: "Payal",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
        chatIcon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
        featureList: [],
        description:
          "Engages customers professionally, answers property queries using verified data, manages language flow, and closes calls politely without pressure.",
        subDescription:
          "Ensures accurate information delivery, smooth conversation flow, and a respectful customer experience from first contact to call closure.",
        voice: "true",
        chat: "false",
        callTitle: "Real Estate Assistant",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        try_speaking: [],
        activities: [],
        phoneNumber: "070239",
        language: "English",
        default_voiceId: "default",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "e1d7d60f-ffdf-41b0-93c7-22610564be3a",
          tenant_id: "122f0f76-f68c-4cee-a115-94a82b870890",
          workspace_id: "122f0f76-f68c-4cee-a115-94a82b870890"
        },
        optional_voices: [
          {
            id: "default",
            name: "Payal",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
            description: "Female & Professional",
            language: "English",
            region: "India"
          }
        ]
      }
    ]
  },

  Infosys: {
    path: "infosys",
    pageTitle: "Experience Our AI Agents",
    pageCategory: "Infosys",
    agents: [
      {
        id: "36de6579-0c8f-4d7f-867a-4469459da2f9", // Agent ID to be provided
        name: "IT Support",
        agentName: "Priya",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
        chatIcon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
        featureList: [],
        description:
          "Helps user in resetting their password by validating their identity through OTP verification",
        subDescription:
          "Handles identity verification and executes automated password reset or account unlock workflows for Infosys-managed systems.",
        voice: "true",
        chat: "false",
        callTitle: "IT Support",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        try_speaking: [],
        activities: [],
        phoneNumber: "070239",
        language: "English",
        default_voiceId: "default",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "36de6579-0c8f-4d7f-867a-4469459da2f9", // Agent ID to be provided
          tenant_id: "20ef946f-c79c-441e-9e6c-db2f57410778",
          workspace_id: "20ef946f-c79c-441e-9e6c-db2f57410778"
        },
        optional_voices: [
          {
            id: "default",
            name: "Priya",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
            description: "Female & Professional",
            language: "English",
            region: "India"
          }
        ]
      }
    ]
  },

  MyntraCrew: {
    path: "myntra-crew",
    pageTitle: "Experience Our AI Agents",
    pageCategory: "Infosys",
    agents: [
      {
        id: "3c5295ef-d560-4279-b770-62ea7cf0b45f", // Agent ID to be provided
        name: "Exchange test agent",
        agentName: "Meera",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
        chatIcon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
        featureList: [],
        description:"",
        subDescription:"",
        voice: "true",
        chat: "false",
        callTitle: "Exchange test agent",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        try_speaking: [],
        activities: [],
        phoneNumber: "070239",
        language: "English",
        default_voiceId: "default",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "3c5295ef-d560-4279-b770-62ea7cf0b45f", // Agent ID to be provided
          tenant_id: "7a450992-5eb5-43a9-8a0b-768db7169748",
          workspace_id: "7a450992-5eb5-43a9-8a0b-768db7169748"
        },
        optional_voices: [
          {
            id: "default",
            name: "Meera",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
            description: "Female & Professional",
            language: "English",
            region: "India"
          }
        ]
      }
    ]
  },
  TractorSupplyCo: {
    path: "tractor-supply-co",
    pageTitle: "Experience Our AI Agents",
    pageCategory: "Tractor Supply Co.",
    agents: [
      {
        id: "9d7d892d-010c-437d-8dfb-32bacc3d9817",
        name: "TSC Customer Support Crew",
        agentName: "Riley",
        icon: "/tsc-agent.png",
        chatIcon: "/tsc-agent.png",
        featureList: [
          "Live order lookup with sentiment-aware routing",
          "One-time save attempts with species-strict cross-sell",
          "Seamless multi-agent flow — one voice, no handoff seams"
        ],
        description: "Riley is a virtual TSC associate who handles order tracking, cancellations, refunds, and recommendations in one seamless conversation.",
        subDescription: "A virtual TSC associate that guides customers through every stage of post-purchase support.",
        voice: "true",
        chat: "false",
        callTitle: "Tractor Supply Co. Customer Support",
        chatHints: [],
        callHintsTable: [
          {
            title: "Ship to Home",
            hints: [
              "Phone Number: 555-330-7712",
              "Last Four Digits of Order Id: 0502",
              "Product: Seresto 8-Month Flea & Tick Collar for Large Dogs"
            ]
          },
          {
            title: "Store Pickup",
            hints: [
              "Phone Number: 555-663-1145",
              "Last Four Digits of Order Id: 0505",
              "Product: Ruffwear Front Range All-Day Adventure Harness Medium"
            ]
          }
        ],
        callHints: [
          "Ship to Home — Phone: 555-330-7712, Order: 0502, Product: Seresto 8-Month Flea & Tick Collar for Large Dogs",
          "Store Pickup — Phone: 555-663-1145, Order: 0505, Product: Ruffwear Front Range All-Day Adventure Harness Medium"
        ],
        voiceInputs: [],
        voiceProvider: "voicex",
        try_speaking: [
          "Where is my order?",
          "My order has not arrived yet.",
          "I want to cancel my order."
        ],
        activities: [
          "Order tracking & delivery status",
          "Cancellation & refunds",
          "Personalized product recommendations"
        ],
        phoneNumber: "",
        language: "English",
        default_voiceId: "default",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-us"],
          user_id: DEFAULT_USER_ID,
          agent_id: "9d7d892d-010c-437d-8dfb-32bacc3d9817",
          tenant_id: "25228786-6f67-4043-9f59-d5f7cccdc41d",
          workspace_id: "25228786-6f67-4043-9f59-d5f7cccdc41d"
        },
        optional_voices: [
          {
            id: "default",
            name: "Riley",
            icon: "/tsc-agent.png",
            description: "Female & Professional",
            language: "English",
            region: "US"
          }
        ]
      },
      {
        id: "1bf106c9-d10e-43e3-bf5d-8521acba146a",
        name: "TSC Tax Agent",
        agentName: "Riley",
        icon: "/tsc-agent.png",
        chatIcon: "/tsc-agent.png",
        featureList: [
          "Identity-first verification with store registry check",
          "Plain-English item-level answers under 60 seconds",
          "Internal-only line with proactive escalation paths"
        ],
        description: "An internal phone line for TSC store associates standing at the register. Verifies the associate, identifies the state and situation, and gives precise, item-level tax answers in plain English — under 60 seconds.",
        subDescription: "A virtual TSC tax expert that supports store associates with on-the-spot tax guidance.",
        voice: "true",
        chat: "false",
        callTitle: "Tractor Supply Co. Tax Agent (Internal)",
        chatHints: [],
        callHintsTable: [
          {
            title: "Tennessee — Agricultural Exemption — Multi-item",
            hints: [
              "Associate: Sarah",
              "Store Number: 1157",
              "State: Tennessee",
              "Customer Exemption: Agricultural",
              "Items in question: Baling wire, 3PT hay handling attachment, tractor seat"
            ]
          }
        ],
        callHints: [
          "Associate: Sarah, Store: 1157, State: Tennessee",
          "Customer Exemption: Agricultural",
          "Items: Baling wire, 3PT hay handling attachment, tractor seat"
        ],
        voiceInputs: [],
        voiceProvider: "voicex",
        try_speaking: [
          "I have a customer with an agricultural exemption — should baling wire be exempt?",
          "Customer is trying to register her exemption online and it keeps failing.",
          "How do I look up a receipt from two years ago?"
        ],
        activities: [
          "State-specific item-level tax lookups",
          "Exemption setup & escalation guidance",
          "Fee explanation & tax summary support"
        ],
        phoneNumber: "",
        language: "English",
        default_voiceId: "default",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-us"],
          user_id: DEFAULT_USER_ID,
          agent_id: "1bf106c9-d10e-43e3-bf5d-8521acba146a",
          tenant_id: "25228786-6f67-4043-9f59-d5f7cccdc41d",
          workspace_id: "25228786-6f67-4043-9f59-d5f7cccdc41d"
        },
        optional_voices: [
          {
            id: "default",
            name: "Riley",
            icon: "/tsc-agent.png",
            description: "Female & Professional",
            language: "English",
            region: "US"
          }
        ]
      }
    ]
  },
  TopRankers3:{
    path: "top-rankers-demo",
    pageTitle: "Experience Our AI Agents",
    pageCategory: "Top Rankers",
    agents: [
      {
        id: "39288a62-8ec8-4a78-9770-b0fadf5db63a",
        name: "Lead Qualification Agent",
        agentName: "Meera",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
        chatIcon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
        featureList: [],
        description:"Lead Qualification",
        subDescription: "",
        voice: "true",
        chat: "false",
        callTitle: "Lead Qualification",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "outbound-call",
        try_speaking: [],
        activities: [],
        phoneNumber: "",
        language: "Hinglish",
        default_voiceId: "default",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: US_USER_ID,
          agent_id: "39288a62-8ec8-4a78-9770-b0fadf5db63a",
          tenant_id: "a7789bcc-365e-497d-891b-7a057b887103",
          workspace_id: "a7789bcc-365e-497d-891b-7a057b887103"
        },
        optional_voices: [
          {
            id: "default",
            name: "Meera",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
            description: "Female & Conversational",
            language: "Hinglish",
            region: "India"
          }
        ]
      }
    ]
  },
  KayaClinic:{
    path: "kaya-clinic", 
    pageTitle: "Experience Our AI Agents",
    pageCategory: "Kaya Clinic",
    agents: [
      {
        id: "0b8756a6-13f1-479e-875a-26c0b4374930",
        name: "Appointment Confirmation Agent",
        agentName: "Riya", 
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
        chatIcon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
        featureList: [],
        description:"Appointment Confirmation",
        subDescription: "",
        voice: "true",
        chat: "false",
        callTitle: "Appointment Confirmation",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "outbound-call",
        try_speaking: [],
        activities: [],
        phoneNumber: "",
        language: "Hinglish",
        default_voiceId: "default",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: US_USER_ID, 
          agent_id: "5b940b36-6523-4340-8e21-04d7bb4c4894",
          tenant_id: "330531ad-f6cd-4a8d-b310-3f479d08f4f4", 
          workspace_id: "330531ad-f6cd-4a8d-b310-3f479d08f4f4"
        },
        optional_voices: [
          {
            id: "default",
            name: "Riya",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
            description: "Female & Conversational",
            language: "Hinglish",
            region: "India"
          }
        ]
      }
    ]
  },
  Scalerv3: {
    path: "scalerv3",
    pageTitle: "Experience Our AI Agents",
    pageCategory: "Scaler",
    agents: [
      {
        id: "f982b901-95eb-44d6-972c-4a19504aa91a",
        name: "Scaler Career Guidance",
        agentName: "Tanya",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
        chatIcon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
        featureList: [
          "Busy handling with Tanya callback scheduling",
          "Counselor callback booking with slot mapping",
          "Objection handling relevant to the user"
        ],
        description: "Tanya calls who registered for a Scaler masterclass. She uses a warm, non-pushy tone to understand their career situation, validate tech interest, and route qualified leads to a senior counselor call.",
        subDescription:
          "Tanya calls who registered for a Scaler masterclass. She uses a warm, non-pushy tone to understand their career situation, validate tech interest, and route qualified leads to a senior counselor call.",
        voice: "true",
        chat: "false",
        callTitle: "Scaler Career Guidance",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        try_speaking: [
          "I'm stuck in my current role and in my current company",
          "There are too many things to learn. I am confused about how to learn them in a structured manner."
        ],
        activities: [],
        phoneNumber: "",
        language: "English",
        default_voiceId: "default",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: US_USER_ID,
          agent_id: "f982b901-95eb-44d6-972c-4a19504aa91a",
          tenant_id: "d5790d69-2fb8-41d7-bf04-9a99b3c8c348",
          workspace_id: "d5790d69-2fb8-41d7-bf04-9a99b3c8c348"
        },
        optional_voices: [
          {
            id: "default",
            name: "Tanya",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
            description: "Female & Warm Conversational",
            language: "English",
            region: "India"
          }
        ]
      }
    ]
  },
  TopRankers4: {
    path: "toprankers-4-demo",
    pageTitle: "Experience our AI Agents",
    pageCategory: "Top Rankers",
    agents: [
      {
        id: "f679c945-92ea-444b-9d95-10ccf5b2dfb7",
        name: "Feedback Agent",
        description: "A professional TopRankers feedback reminder calling executive. She captures feedback accurately, handles confusion calmly, escalates serious concerns for fast support, and wraps up with next steps and a polite close.",
        subDescription: "Sonam, a warm and professional student feedback calling executive.",
        agentName: "Sonam",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
        chatIcon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
        featureList: [],
        voice: "true",
        chat: "false",
        callTitle: "Feedback Agent",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        try_speaking: [],
        activities: [],
        phoneNumber: "070239",
        language: "Hindi, English",
        default_voiceId: "default",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "f679c945-92ea-444b-9d95-10ccf5b2dfb7",
          tenant_id: "a7789bcc-365e-497d-891b-7a057b887103",
          workspace_id: "a7789bcc-365e-497d-891b-7a057b887103",
        },
        optional_voices: [
          {
            id: "default",
            name: "Sonam",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
            description: "Female & Professional",
            language: "Hindi, English",
            region: ""
          }
        ]
      },
      {
        id: "1974a470-d83c-4afd-bbfd-3c4cc0437438",
        name: "Recovery Agent",
        description: "A professional TopRankers fee reminder calling executive who confirms the student’s identity and clearly communicates the pending amount and due date. She asks if the payment can be completed by today or tomorrow, shares the Razorpay link on WhatsApp after the call for online payments, and escalates to a senior admission counselor if the student needs more time.",
        subDescription: "Sonam, a warm and professional fee reminder calling executive.",
        agentName: "Sonam",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
        chatIcon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
        featureList: [],
        voice: "true",
        chat: "false",
        callTitle: "Recovery Agent",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        try_speaking: [],
        activities: [],
        phoneNumber: "070239",
        language: "Hindi, English",
        default_voiceId: "default",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "1974a470-d83c-4afd-bbfd-3c4cc0437438",
          tenant_id: "a7789bcc-365e-497d-891b-7a057b887103",
          workspace_id: "a7789bcc-365e-497d-891b-7a057b887103",
        },
        optional_voices: [
          {
            id: "default",
            name: "Maya",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
            description: "Female & Professional",
            language: "Hindi, English",
            region: ""
          }
        ]
      },
    ]
  },
  Cholmandlam: {
    path: "cholamandalam",
    pageTitle: "Experience our AI Agents",
    pageCategory: "Cholamandalam",
    agents: [
      {
        id: "5e36c1f0-be9d-4bd4-8688-92050ecc8b73",
        name: "Chola welcome",
        agentName: "Priya",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
        chatIcon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
        featureList: [
          "Structured step-by-step onboarding flow without skipping levels.",
          "Charge Query Handling"
        ],
        description:
          "Priya is a customer support executive from cholamandalam making outbound welcome calls to confirm Loan Against Property details and guide customers through onboarding.",
        subDescription:
          "Handles structured onboarding calls, verifies sanctioned loan details, clarifies key charges, and ensures smooth customer communication for Loan Against Property accounts.",
        voice: "true",
        chat: "false",
        callTitle: "LAP Onboarding Welcome Call",
        chatHints: [],
        callHintsTable: [],
        callHints: [
          "Customer Name: Rajesh Sharma",
          "Loan Account Number: LAP 0048293017",
          "Sanction Amount: 45 Lakhs",
          "Loan Tenor: 15Y / 180 months",
          "EMI Due Date: 5th of every month",
          "EMI Amount: Rs. 48,500 /month",
          "Interest Rate: 10.5%",
          "Registered Email: rajesh.sharma91@gmail.com",
          "Repayment Mode: eNACH",
          "Communication Address: Flat four zero two, Sai Krupa Apartments, Sector fourteen, Bandra, Mumbai, 410210",
          "Mandate Status: Not Registered"
        ],
        voiceInputs: [],
        voiceProvider: "voicex",
        try_speaking: [],
        activities: [
          "Verifies sanctioned Loan Against Property details.",
          "Confirms customer records and contact information.",
          "Guides customers through onboarding and service charges."
        ],
        phoneNumber: "",
        language: "English",
        default_voiceId: "default",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "5e36c1f0-be9d-4bd4-8688-92050ecc8b73",
          tenant_id: "93debacb-6338-4fe3-befb-731e7fd94a3b",
          workspace_id: "93debacb-6338-4fe3-befb-731e7fd94a3b"
        },
        optional_voices: [
          {
            id: "default",
            name: "Priya",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
            description: "Female & Professional",
            language: "English",
            region: ""
          }
        ]
      },
      {
        id: "df850e80-4cfe-442d-b001-ca0023622cb5",
        name: "Chola FAQ Support Agent",
        agentName: "Priya",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
        chatIcon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png-chat",
        featureList: [
          "EMI and loan balance information",
          "Overdue and bounce status updates",
          "Branch guidance"
        ],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHints: [
          "Name: Jatin",
          "Last 4 digits of loan account: 7890",
          "City: Chennai",
          "Pincode: 631208"
        ],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        voiceConfig: {
          baseUrl: "https://external-proxy.nurixlabs.tech",
          user_id: "idn_37sA9FIOqyGeAfLmPFub8gNtdc0",
          agent_id: "df850e80-4cfe-442d-b001-ca0023622cb5",
          tenant_id: "93debacb-6338-4fe3-befb-731e7fd94a3b",
          workspace_id: "93debacb-6338-4fe3-befb-731e7fd94a3b",
          overide_previous_context: true
        },
        description:
          "Chola Mandalam Loan FAQ Support Agent assisting with EMI, balance, overdue, charges, documents, branch details, and new loan enquiries.",
        subDescription:
          "Warm and professional support for all your Chola Mandalam loan related questions.",
        default_voiceId: "default",
        optional_voices: [
          {
            id: "default",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
            name: "Priya",
            region: "India",
            language: "English, Hindi",
            description:
              "Chola Mandalam Loan FAQ Support Agent assisting with EMI, balance, overdue, charges, documents, branch details, and new loan enquiries."
          }
        ],
        try_speaking: [
          "Tell me my outstanding loan balance",
          "Do I have any overdue amount",
          "What is my next EMI date"
        ],
        activities: [
          "Provide EMI and loan balance details",
          "Check overdue and bounce status",
          "Guide on branch information"
        ],
        callTitle: "Loan FAQ Assistance",
        phoneNumber: "",
        language: "English, Hindi"
      }
    ]
  },
  MyntraAds: {
    path: "myntra-ads",
    pageTitle: "Experience our AI Agents",
    pageCategory: "Myntra",
    agents: [
      {
        id: "c74562e5-b5cf-471e-b224-bc2cdb34a838",
        name: "Ads Informational Agent",
        description: "This agent is designed for a short, informational conversation about Myntra Ads and the first ad campaign created using Myntra-funded free credits. It explains what the free credits are, reassures sellers that no payment is required unless they add budget themselves, and highlights that they remain fully in control of their campaigns through the Ads Portal.",
        subDescription: "",
        agentName: "Meera",
        icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
        chatIcon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
        featureList: [],
        voice: "true",
        chat: "false",
        callTitle: "Ads Informational Agent",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "voicex",
        try_speaking: [],
        activities: [],
        phoneNumber: "070239",
        language: "English",
        default_voiceId: "default",
        voiceConfig: {
          baseUrl: VOICEX_URL_CONSTANTS["voicex-in"],
          user_id: DEFAULT_USER_ID,
          agent_id: "c74562e5-b5cf-471e-b224-bc2cdb34a838",
          tenant_id: "cea0f129-ccd7-49e3-b9a3-7c55e530e2a6",
          workspace_id: "cea0f129-ccd7-49e3-b9a3-7c55e530e2a6",
        },
        optional_voices: [
          {
            id: "default",
            name: "Meera",
            icon: "https://d3udl6i7sipqjw.cloudfront.net/agent-images/Female5.png",
            description: "Female & Professional",
            language: "English",
            region: ""
          }
        ]
      },
    ]
  },
};



